import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  float8: any;
  jsonb: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};


export type AddParticipantsItem = {
  companyId: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  group?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  namePronunciation?: Maybe<Scalars['String']>;
  notificationPreference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferredName: Scalars['String'];
  profilePhoto?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
};

export type AddParticipantsOutput = {
  __typename?: 'AddParticipantsOutput';
  failedAddingParticipants: Array<Scalars['String']>;
  failedAddingParticipantsCount: Scalars['Int'];
  successfullyAddedParticipants: Scalars['Int'];
  successfullyUpdatedParticipants: Scalars['Int'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type ChangePreferencesOutput = {
  __typename?: 'ChangePreferencesOutput';
  id: Scalars['String'];
};

export type EmailResponseOutput = {
  __typename?: 'EmailResponseOutput';
  success: Scalars['Boolean'];
};

export type FinishSessionOutput = {
  __typename?: 'FinishSessionOutput';
  resourceId?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
  sid?: Maybe<Scalars['String']>;
};

export type GetAgoraTempTokenOutput = {
  __typename?: 'GetAgoraTempTokenOutput';
  channelName: Scalars['String'];
  participantAgoraId: Scalars['Int'];
  token: Scalars['String'];
};

export type GetProgramRegistrationLinkOutput = {
  __typename?: 'GetProgramRegistrationLinkOutput';
  link: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type RegisterEventOutput = {
  __typename?: 'RegisterEventOutput';
  created_at: Scalars['String'];
  id: Scalars['String'];
};

export type RescheduleParticipantSessionOutput = {
  __typename?: 'RescheduleParticipantSessionOutput';
  sessionId: Scalars['String'];
};

export type StartRecordingOutput = {
  __typename?: 'StartRecordingOutput';
  resourceId: Scalars['String'];
  sessionId: Scalars['String'];
  sid: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export type SyntethizeTextToSpeechOutput = {
  __typename?: 'SyntethizeTextToSpeechOutput';
  audioContent: Scalars['String'];
};

export type TalkTimeMessageEventOutput = {
  __typename?: 'TalkTimeMessageEventOutput';
  id: Scalars['String'];
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  address_1: Scalars['String'];
  address_2: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  zip_code: Scalars['String'];
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Address_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: Maybe<Array<Address_Bool_Exp>>;
  _not?: Maybe<Address_Bool_Exp>;
  _or?: Maybe<Array<Address_Bool_Exp>>;
  address_1?: Maybe<String_Comparison_Exp>;
  address_2?: Maybe<String_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  zip_code?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Address_On_Conflict>;
};

/** on conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: Maybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  address_1?: Maybe<Order_By>;
  address_2?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zip_code?: Maybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipCode = 'zip_code'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipCode = 'zip_code'
}


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  /** An object relationship */
  address: Address;
  address_id: Scalars['uuid'];
  /** An object relationship */
  company_contact: Company_Contact;
  company_contact_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  participants: Array<Participant>;
  /** An aggregate relationship */
  participants_aggregate: Participant_Aggregate;
  /** An array relationship */
  sessions: Array<Session>;
  /** An aggregate relationship */
  sessions_aggregate: Session_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_logins: Array<User_Login>;
  /** An aggregate relationship */
  user_logins_aggregate: User_Login_Aggregate;
};


/** columns and relationships of "company" */
export type CompanyParticipantsArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyParticipants_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySessionsArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUser_LoginsArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUser_Logins_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: Maybe<Array<Company_Bool_Exp>>;
  _not?: Maybe<Company_Bool_Exp>;
  _or?: Maybe<Array<Company_Bool_Exp>>;
  address?: Maybe<Address_Bool_Exp>;
  address_id?: Maybe<Uuid_Comparison_Exp>;
  company_contact?: Maybe<Company_Contact_Bool_Exp>;
  company_contact_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participants?: Maybe<Participant_Bool_Exp>;
  sessions?: Maybe<Session_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_logins?: Maybe<User_Login_Bool_Exp>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint */
  CompanyPkey = 'company_pkey'
}

/** columns and relationships of "company_contact" */
export type Company_Contact = {
  __typename?: 'company_contact';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['uuid'];
  last_name: Scalars['String'];
  primary_phone: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "company_contact" */
export type Company_Contact_Aggregate = {
  __typename?: 'company_contact_aggregate';
  aggregate?: Maybe<Company_Contact_Aggregate_Fields>;
  nodes: Array<Company_Contact>;
};

/** aggregate fields of "company_contact" */
export type Company_Contact_Aggregate_Fields = {
  __typename?: 'company_contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Contact_Max_Fields>;
  min?: Maybe<Company_Contact_Min_Fields>;
};


/** aggregate fields of "company_contact" */
export type Company_Contact_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Contact_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_contact". All fields are combined with a logical 'AND'. */
export type Company_Contact_Bool_Exp = {
  _and?: Maybe<Array<Company_Contact_Bool_Exp>>;
  _not?: Maybe<Company_Contact_Bool_Exp>;
  _or?: Maybe<Array<Company_Contact_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  primary_phone?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_contact" */
export enum Company_Contact_Constraint {
  /** unique or primary key constraint */
  CompanyContactPkey = 'company_contact_pkey'
}

/** input type for inserting data into table "company_contact" */
export type Company_Contact_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Company_Contact_Max_Fields = {
  __typename?: 'company_contact_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Company_Contact_Min_Fields = {
  __typename?: 'company_contact_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_contact" */
export type Company_Contact_Mutation_Response = {
  __typename?: 'company_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Contact>;
};

/** input type for inserting object relation for remote table "company_contact" */
export type Company_Contact_Obj_Rel_Insert_Input = {
  data: Company_Contact_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Company_Contact_On_Conflict>;
};

/** on conflict condition type for table "company_contact" */
export type Company_Contact_On_Conflict = {
  constraint: Company_Contact_Constraint;
  update_columns?: Array<Company_Contact_Update_Column>;
  where?: Maybe<Company_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "company_contact". */
export type Company_Contact_Order_By = {
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  primary_phone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: company_contact */
export type Company_Contact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company_contact" */
export enum Company_Contact_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company_contact" */
export type Company_Contact_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "company_contact" */
export enum Company_Contact_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  address?: Maybe<Address_Obj_Rel_Insert_Input>;
  address_id?: Maybe<Scalars['uuid']>;
  company_contact?: Maybe<Company_Contact_Obj_Rel_Insert_Input>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participants?: Maybe<Participant_Arr_Rel_Insert_Input>;
  sessions?: Maybe<Session_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_logins?: Maybe<User_Login_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Company_On_Conflict>;
};

/** on conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: Maybe<Company_Bool_Exp>;
};

/** Ordering options when selecting data from "company". */
export type Company_Order_By = {
  address?: Maybe<Address_Order_By>;
  address_id?: Maybe<Order_By>;
  company_contact?: Maybe<Company_Contact_Order_By>;
  company_contact_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participants_aggregate?: Maybe<Participant_Aggregate_Order_By>;
  sessions_aggregate?: Maybe<Session_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user_logins_aggregate?: Maybe<User_Login_Aggregate_Order_By>;
};

/** primary key columns input for table: company */
export type Company_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CompanyContactId = 'company_contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CompanyContactId = 'company_contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "confirmation_status" */
export type Confirmation_Status = {
  __typename?: 'confirmation_status';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "confirmation_status" */
export type Confirmation_Status_Aggregate = {
  __typename?: 'confirmation_status_aggregate';
  aggregate?: Maybe<Confirmation_Status_Aggregate_Fields>;
  nodes: Array<Confirmation_Status>;
};

/** aggregate fields of "confirmation_status" */
export type Confirmation_Status_Aggregate_Fields = {
  __typename?: 'confirmation_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Confirmation_Status_Max_Fields>;
  min?: Maybe<Confirmation_Status_Min_Fields>;
};


/** aggregate fields of "confirmation_status" */
export type Confirmation_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Confirmation_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "confirmation_status". All fields are combined with a logical 'AND'. */
export type Confirmation_Status_Bool_Exp = {
  _and?: Maybe<Array<Confirmation_Status_Bool_Exp>>;
  _not?: Maybe<Confirmation_Status_Bool_Exp>;
  _or?: Maybe<Array<Confirmation_Status_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "confirmation_status" */
export enum Confirmation_Status_Constraint {
  /** unique or primary key constraint */
  ConfirmationStatusPkey = 'confirmation_status_pkey'
}

export enum Confirmation_Status_Enum {
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Pending */
  Pending = 'PENDING',
  /** Rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** Unknown confirmation status */
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "confirmation_status_enum". All fields are combined with logical 'AND'. */
export type Confirmation_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Confirmation_Status_Enum>;
  _in?: Maybe<Array<Confirmation_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Confirmation_Status_Enum>;
  _nin?: Maybe<Array<Confirmation_Status_Enum>>;
};

/** input type for inserting data into table "confirmation_status" */
export type Confirmation_Status_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Confirmation_Status_Max_Fields = {
  __typename?: 'confirmation_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Confirmation_Status_Min_Fields = {
  __typename?: 'confirmation_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "confirmation_status" */
export type Confirmation_Status_Mutation_Response = {
  __typename?: 'confirmation_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Confirmation_Status>;
};

/** on conflict condition type for table "confirmation_status" */
export type Confirmation_Status_On_Conflict = {
  constraint: Confirmation_Status_Constraint;
  update_columns?: Array<Confirmation_Status_Update_Column>;
  where?: Maybe<Confirmation_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "confirmation_status". */
export type Confirmation_Status_Order_By = {
  comment?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: confirmation_status */
export type Confirmation_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "confirmation_status" */
export enum Confirmation_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "confirmation_status" */
export type Confirmation_Status_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "confirmation_status" */
export enum Confirmation_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "event" */
export type Event = {
  __typename?: 'event';
  client_timestamp: Scalars['timestamptz'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  /** An object relationship */
  event_type: Event_Type;
  event_type_id: Scalars['uuid'];
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "event" */
export type EventMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "event" */
export type Event_Aggregate = {
  __typename?: 'event_aggregate';
  aggregate?: Maybe<Event_Aggregate_Fields>;
  nodes: Array<Event>;
};

/** aggregate fields of "event" */
export type Event_Aggregate_Fields = {
  __typename?: 'event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Max_Fields>;
  min?: Maybe<Event_Min_Fields>;
};


/** aggregate fields of "event" */
export type Event_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Event_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event" */
export type Event_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Event_Max_Order_By>;
  min?: Maybe<Event_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Event_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event" */
export type Event_Arr_Rel_Insert_Input = {
  data: Array<Event_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "event". All fields are combined with a logical 'AND'. */
export type Event_Bool_Exp = {
  _and?: Maybe<Array<Event_Bool_Exp>>;
  _not?: Maybe<Event_Bool_Exp>;
  _or?: Maybe<Array<Event_Bool_Exp>>;
  client_timestamp?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  event_type?: Maybe<Event_Type_Bool_Exp>;
  event_type_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "event" */
export enum Event_Constraint {
  /** unique or primary key constraint */
  EventPkey = 'event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Event_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Event_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Event_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "event" */
export type Event_Insert_Input = {
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type?: Maybe<Event_Type_Obj_Rel_Insert_Input>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Event_Max_Fields = {
  __typename?: 'event_max_fields';
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event" */
export type Event_Max_Order_By = {
  client_timestamp?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  event_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Min_Fields = {
  __typename?: 'event_min_fields';
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event" */
export type Event_Min_Order_By = {
  client_timestamp?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  event_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "event" */
export type Event_Mutation_Response = {
  __typename?: 'event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event>;
};

/** on conflict condition type for table "event" */
export type Event_On_Conflict = {
  constraint: Event_Constraint;
  update_columns?: Array<Event_Update_Column>;
  where?: Maybe<Event_Bool_Exp>;
};

/** Ordering options when selecting data from "event". */
export type Event_Order_By = {
  client_timestamp?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  event_type?: Maybe<Event_Type_Order_By>;
  event_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: event */
export type Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Event_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "event" */
export enum Event_Select_Column {
  /** column name */
  ClientTimestamp = 'client_timestamp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "event" */
export type Event_Set_Input = {
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_type" */
export type Event_Type = {
  __typename?: 'event_type';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "event_type" */
export type Event_Type_Aggregate = {
  __typename?: 'event_type_aggregate';
  aggregate?: Maybe<Event_Type_Aggregate_Fields>;
  nodes: Array<Event_Type>;
};

/** aggregate fields of "event_type" */
export type Event_Type_Aggregate_Fields = {
  __typename?: 'event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Type_Max_Fields>;
  min?: Maybe<Event_Type_Min_Fields>;
};


/** aggregate fields of "event_type" */
export type Event_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Event_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_type". All fields are combined with a logical 'AND'. */
export type Event_Type_Bool_Exp = {
  _and?: Maybe<Array<Event_Type_Bool_Exp>>;
  _not?: Maybe<Event_Type_Bool_Exp>;
  _or?: Maybe<Array<Event_Type_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_type" */
export enum Event_Type_Constraint {
  /** unique or primary key constraint */
  EventTypeNameKey = 'event_type_name_key',
  /** unique or primary key constraint */
  EventTypePkey = 'event_type_pkey'
}

/** input type for inserting data into table "event_type" */
export type Event_Type_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Event_Type_Max_Fields = {
  __typename?: 'event_type_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Event_Type_Min_Fields = {
  __typename?: 'event_type_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_type" */
export type Event_Type_Mutation_Response = {
  __typename?: 'event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Type>;
};

/** input type for inserting object relation for remote table "event_type" */
export type Event_Type_Obj_Rel_Insert_Input = {
  data: Event_Type_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Event_Type_On_Conflict>;
};

/** on conflict condition type for table "event_type" */
export type Event_Type_On_Conflict = {
  constraint: Event_Type_Constraint;
  update_columns?: Array<Event_Type_Update_Column>;
  where?: Maybe<Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "event_type". */
export type Event_Type_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: event_type */
export type Event_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "event_type" */
export enum Event_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "event_type" */
export type Event_Type_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "event_type" */
export enum Event_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "event" */
export enum Event_Update_Column {
  /** column name */
  ClientTimestamp = 'client_timestamp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "historic_events" */
export type Historic_Events = {
  __typename?: 'historic_events';
  client_timestamp: Scalars['timestamptz'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  /** An object relationship */
  event_type: Event_Type;
  event_type_id: Scalars['uuid'];
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "historic_events" */
export type Historic_EventsMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "historic_events" */
export type Historic_Events_Aggregate = {
  __typename?: 'historic_events_aggregate';
  aggregate?: Maybe<Historic_Events_Aggregate_Fields>;
  nodes: Array<Historic_Events>;
};

/** aggregate fields of "historic_events" */
export type Historic_Events_Aggregate_Fields = {
  __typename?: 'historic_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Historic_Events_Max_Fields>;
  min?: Maybe<Historic_Events_Min_Fields>;
};


/** aggregate fields of "historic_events" */
export type Historic_Events_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Historic_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Historic_Events_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "historic_events". All fields are combined with a logical 'AND'. */
export type Historic_Events_Bool_Exp = {
  _and?: Maybe<Array<Historic_Events_Bool_Exp>>;
  _not?: Maybe<Historic_Events_Bool_Exp>;
  _or?: Maybe<Array<Historic_Events_Bool_Exp>>;
  client_timestamp?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  event_type?: Maybe<Event_Type_Bool_Exp>;
  event_type_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "historic_events" */
export enum Historic_Events_Constraint {
  /** unique or primary key constraint */
  HistoricEventsPkey = 'historic_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Historic_Events_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Historic_Events_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Historic_Events_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "historic_events" */
export type Historic_Events_Insert_Input = {
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type?: Maybe<Event_Type_Obj_Rel_Insert_Input>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Historic_Events_Max_Fields = {
  __typename?: 'historic_events_max_fields';
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Historic_Events_Min_Fields = {
  __typename?: 'historic_events_min_fields';
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "historic_events" */
export type Historic_Events_Mutation_Response = {
  __typename?: 'historic_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Historic_Events>;
};

/** on conflict condition type for table "historic_events" */
export type Historic_Events_On_Conflict = {
  constraint: Historic_Events_Constraint;
  update_columns?: Array<Historic_Events_Update_Column>;
  where?: Maybe<Historic_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "historic_events". */
export type Historic_Events_Order_By = {
  client_timestamp?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  event_type?: Maybe<Event_Type_Order_By>;
  event_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: historic_events */
export type Historic_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Historic_Events_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "historic_events" */
export enum Historic_Events_Select_Column {
  /** column name */
  ClientTimestamp = 'client_timestamp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "historic_events" */
export type Historic_Events_Set_Input = {
  client_timestamp?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "historic_events" */
export enum Historic_Events_Update_Column {
  /** column name */
  ClientTimestamp = 'client_timestamp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}


/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'logs';
  action: Logs_Action_Enum;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** columns and relationships of "logs_action" */
export type Logs_Action = {
  __typename?: 'logs_action';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "logs_action" */
export type Logs_Action_Aggregate = {
  __typename?: 'logs_action_aggregate';
  aggregate?: Maybe<Logs_Action_Aggregate_Fields>;
  nodes: Array<Logs_Action>;
};

/** aggregate fields of "logs_action" */
export type Logs_Action_Aggregate_Fields = {
  __typename?: 'logs_action_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Logs_Action_Max_Fields>;
  min?: Maybe<Logs_Action_Min_Fields>;
};


/** aggregate fields of "logs_action" */
export type Logs_Action_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Logs_Action_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "logs_action". All fields are combined with a logical 'AND'. */
export type Logs_Action_Bool_Exp = {
  _and?: Maybe<Array<Logs_Action_Bool_Exp>>;
  _not?: Maybe<Logs_Action_Bool_Exp>;
  _or?: Maybe<Array<Logs_Action_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs_action" */
export enum Logs_Action_Constraint {
  /** unique or primary key constraint */
  LogsActionPkey = 'logs_action_pkey'
}

export enum Logs_Action_Enum {
  /** Logs when an user has authenticated successfully in the mobile app or the conductor web app. */
  AuthLogin = 'auth_login',
  /** Logs when an user has intentionally signed out of the mobile app or conductor web app. */
  AuthLogout = 'auth_logout'
}

/** Boolean expression to compare columns of type "logs_action_enum". All fields are combined with logical 'AND'. */
export type Logs_Action_Enum_Comparison_Exp = {
  _eq?: Maybe<Logs_Action_Enum>;
  _in?: Maybe<Array<Logs_Action_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Logs_Action_Enum>;
  _nin?: Maybe<Array<Logs_Action_Enum>>;
};

/** input type for inserting data into table "logs_action" */
export type Logs_Action_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Logs_Action_Max_Fields = {
  __typename?: 'logs_action_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Logs_Action_Min_Fields = {
  __typename?: 'logs_action_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "logs_action" */
export type Logs_Action_Mutation_Response = {
  __typename?: 'logs_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs_Action>;
};

/** on conflict condition type for table "logs_action" */
export type Logs_Action_On_Conflict = {
  constraint: Logs_Action_Constraint;
  update_columns?: Array<Logs_Action_Update_Column>;
  where?: Maybe<Logs_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "logs_action". */
export type Logs_Action_Order_By = {
  comment?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: logs_action */
export type Logs_Action_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "logs_action" */
export enum Logs_Action_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "logs_action" */
export type Logs_Action_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "logs_action" */
export enum Logs_Action_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** aggregated selection of "logs" */
export type Logs_Aggregate = {
  __typename?: 'logs_aggregate';
  aggregate?: Maybe<Logs_Aggregate_Fields>;
  nodes: Array<Logs>;
};

/** aggregate fields of "logs" */
export type Logs_Aggregate_Fields = {
  __typename?: 'logs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Logs_Max_Fields>;
  min?: Maybe<Logs_Min_Fields>;
};


/** aggregate fields of "logs" */
export type Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type Logs_Bool_Exp = {
  _and?: Maybe<Array<Logs_Bool_Exp>>;
  _not?: Maybe<Logs_Bool_Exp>;
  _or?: Maybe<Array<Logs_Bool_Exp>>;
  action?: Maybe<Logs_Action_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs" */
export enum Logs_Constraint {
  /** unique or primary key constraint */
  LogsPkey = 'logs_pkey'
}

/** input type for inserting data into table "logs" */
export type Logs_Insert_Input = {
  action?: Maybe<Logs_Action_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Logs_Max_Fields = {
  __typename?: 'logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Logs_Min_Fields = {
  __typename?: 'logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "logs" */
export type Logs_Mutation_Response = {
  __typename?: 'logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs>;
};

/** on conflict condition type for table "logs" */
export type Logs_On_Conflict = {
  constraint: Logs_Constraint;
  update_columns?: Array<Logs_Update_Column>;
  where?: Maybe<Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "logs". */
export type Logs_Order_By = {
  action?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: logs */
export type Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "logs" */
export enum Logs_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "logs" */
export type Logs_Set_Input = {
  action?: Maybe<Logs_Action_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "logs" */
export enum Logs_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "media" */
export type Media = {
  __typename?: 'media';
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  storage_key: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "media" */
export type Media_Aggregate = {
  __typename?: 'media_aggregate';
  aggregate?: Maybe<Media_Aggregate_Fields>;
  nodes: Array<Media>;
};

/** aggregate fields of "media" */
export type Media_Aggregate_Fields = {
  __typename?: 'media_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Media_Max_Fields>;
  min?: Maybe<Media_Min_Fields>;
};


/** aggregate fields of "media" */
export type Media_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Media_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Media_Bool_Exp = {
  _and?: Maybe<Array<Media_Bool_Exp>>;
  _not?: Maybe<Media_Bool_Exp>;
  _or?: Maybe<Array<Media_Bool_Exp>>;
  content_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  storage_key?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Media_Constraint {
  /** unique or primary key constraint */
  MediaPkey = 'media_pkey'
}

/** input type for inserting data into table "media" */
export type Media_Insert_Input = {
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  storage_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Media_Max_Fields = {
  __typename?: 'media_max_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  storage_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Media_Min_Fields = {
  __typename?: 'media_min_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  storage_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "media" */
export type Media_Mutation_Response = {
  __typename?: 'media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Media_Obj_Rel_Insert_Input = {
  data: Media_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Media_On_Conflict>;
};

/** on conflict condition type for table "media" */
export type Media_On_Conflict = {
  constraint: Media_Constraint;
  update_columns?: Array<Media_Update_Column>;
  where?: Maybe<Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Media_Order_By = {
  content_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  storage_key?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: media */
export type Media_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "media" */
export enum Media_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StorageKey = 'storage_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "media" */
export type Media_Set_Input = {
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  storage_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "media" */
export enum Media_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StorageKey = 'storage_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  addParticipants?: Maybe<AddParticipantsOutput>;
  changePreferences?: Maybe<ChangePreferencesOutput>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "company_contact" */
  delete_company_contact?: Maybe<Company_Contact_Mutation_Response>;
  /** delete single row from the table: "company_contact" */
  delete_company_contact_by_pk?: Maybe<Company_Contact>;
  /** delete data from the table: "confirmation_status" */
  delete_confirmation_status?: Maybe<Confirmation_Status_Mutation_Response>;
  /** delete single row from the table: "confirmation_status" */
  delete_confirmation_status_by_pk?: Maybe<Confirmation_Status>;
  /** delete data from the table: "event" */
  delete_event?: Maybe<Event_Mutation_Response>;
  /** delete single row from the table: "event" */
  delete_event_by_pk?: Maybe<Event>;
  /** delete data from the table: "event_type" */
  delete_event_type?: Maybe<Event_Type_Mutation_Response>;
  /** delete single row from the table: "event_type" */
  delete_event_type_by_pk?: Maybe<Event_Type>;
  /** delete data from the table: "historic_events" */
  delete_historic_events?: Maybe<Historic_Events_Mutation_Response>;
  /** delete single row from the table: "historic_events" */
  delete_historic_events_by_pk?: Maybe<Historic_Events>;
  /** delete data from the table: "logs" */
  delete_logs?: Maybe<Logs_Mutation_Response>;
  /** delete data from the table: "logs_action" */
  delete_logs_action?: Maybe<Logs_Action_Mutation_Response>;
  /** delete single row from the table: "logs_action" */
  delete_logs_action_by_pk?: Maybe<Logs_Action>;
  /** delete single row from the table: "logs" */
  delete_logs_by_pk?: Maybe<Logs>;
  /** delete data from the table: "media" */
  delete_media?: Maybe<Media_Mutation_Response>;
  /** delete single row from the table: "media" */
  delete_media_by_pk?: Maybe<Media>;
  /** delete data from the table: "nabu.companies" */
  delete_nabu_companies?: Maybe<Nabu_Companies_Mutation_Response>;
  /** delete data from the table: "nabu.feedback" */
  delete_nabu_feedback?: Maybe<Nabu_Feedback_Mutation_Response>;
  /** delete single row from the table: "nabu.feedback" */
  delete_nabu_feedback_by_pk?: Maybe<Nabu_Feedback>;
  /** delete data from the table: "nabu.feedback_type" */
  delete_nabu_feedback_type?: Maybe<Nabu_Feedback_Type_Mutation_Response>;
  /** delete single row from the table: "nabu.feedback_type" */
  delete_nabu_feedback_type_by_pk?: Maybe<Nabu_Feedback_Type>;
  /** delete data from the table: "nabu.prevalence_score_classification_runs" */
  delete_nabu_prevalence_score_classification_runs?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Mutation_Response>;
  /** delete single row from the table: "nabu.prevalence_score_classification_runs" */
  delete_nabu_prevalence_score_classification_runs_by_pk?: Maybe<Nabu_Prevalence_Score_Classification_Runs>;
  /** delete data from the table: "nabu.programs" */
  delete_nabu_programs?: Maybe<Nabu_Programs_Mutation_Response>;
  /** delete data from the table: "nabu.prompts" */
  delete_nabu_prompts?: Maybe<Nabu_Prompts_Mutation_Response>;
  /** delete data from the table: "nabu.quotes" */
  delete_nabu_quotes?: Maybe<Nabu_Quotes_Mutation_Response>;
  /** delete single row from the table: "nabu.quotes" */
  delete_nabu_quotes_by_pk?: Maybe<Nabu_Quotes>;
  /** delete data from the table: "nabu.segments" */
  delete_nabu_segments?: Maybe<Nabu_Segments_Mutation_Response>;
  /** delete data from the table: "nabu.sessions" */
  delete_nabu_sessions?: Maybe<Nabu_Sessions_Mutation_Response>;
  /** delete data from the table: "nabu.survey_questions" */
  delete_nabu_survey_questions?: Maybe<Nabu_Survey_Questions_Mutation_Response>;
  /** delete data from the table: "nabu.surveys" */
  delete_nabu_surveys?: Maybe<Nabu_Surveys_Mutation_Response>;
  /** delete data from the table: "nabu.turns" */
  delete_nabu_turns?: Maybe<Nabu_Turns_Mutation_Response>;
  /** delete single row from the table: "nabu.turns" */
  delete_nabu_turns_by_pk?: Maybe<Nabu_Turns>;
  /** delete data from the table: "nabu.users" */
  delete_nabu_users?: Maybe<Nabu_Users_Mutation_Response>;
  /** delete data from the table: "nabu.voxes" */
  delete_nabu_voxes?: Maybe<Nabu_Voxes_Mutation_Response>;
  /** delete single row from the table: "nabu.voxes" */
  delete_nabu_voxes_by_pk?: Maybe<Nabu_Voxes>;
  /** delete data from the table: "notification_conditions" */
  delete_notification_conditions?: Maybe<Notification_Conditions_Mutation_Response>;
  /** delete single row from the table: "notification_conditions" */
  delete_notification_conditions_by_pk?: Maybe<Notification_Conditions>;
  /** delete data from the table: "notification_offsets" */
  delete_notification_offsets?: Maybe<Notification_Offsets_Mutation_Response>;
  /** delete single row from the table: "notification_offsets" */
  delete_notification_offsets_by_pk?: Maybe<Notification_Offsets>;
  /** delete data from the table: "notification_templates" */
  delete_notification_templates?: Maybe<Notification_Templates_Mutation_Response>;
  /** delete single row from the table: "notification_templates" */
  delete_notification_templates_by_pk?: Maybe<Notification_Templates>;
  /** delete data from the table: "notification_type" */
  delete_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** delete single row from the table: "notification_type" */
  delete_notification_type_by_pk?: Maybe<Notification_Type>;
  /** delete data from the table: "participant" */
  delete_participant?: Maybe<Participant_Mutation_Response>;
  /** delete single row from the table: "participant" */
  delete_participant_by_pk?: Maybe<Participant>;
  /** delete data from the table: "participant_session" */
  delete_participant_session?: Maybe<Participant_Session_Mutation_Response>;
  /** delete single row from the table: "participant_session" */
  delete_participant_session_by_pk?: Maybe<Participant_Session>;
  /** delete data from the table: "program" */
  delete_program?: Maybe<Program_Mutation_Response>;
  /** delete single row from the table: "program" */
  delete_program_by_pk?: Maybe<Program>;
  /** delete data from the table: "prompts" */
  delete_prompts?: Maybe<Prompts_Mutation_Response>;
  /** delete single row from the table: "prompts" */
  delete_prompts_by_pk?: Maybe<Prompts>;
  /** delete data from the table: "question_type" */
  delete_question_type?: Maybe<Question_Type_Mutation_Response>;
  /** delete single row from the table: "question_type" */
  delete_question_type_by_pk?: Maybe<Question_Type>;
  /** delete data from the table: "recording_session" */
  delete_recording_session?: Maybe<Recording_Session_Mutation_Response>;
  /** delete single row from the table: "recording_session" */
  delete_recording_session_by_pk?: Maybe<Recording_Session>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "scripts" */
  delete_scripts?: Maybe<Scripts_Mutation_Response>;
  /** delete single row from the table: "scripts" */
  delete_scripts_by_pk?: Maybe<Scripts>;
  /** delete data from the table: "session" */
  delete_session?: Maybe<Session_Mutation_Response>;
  /** delete single row from the table: "session" */
  delete_session_by_pk?: Maybe<Session>;
  /** delete data from the table: "speech_phrases" */
  delete_speech_phrases?: Maybe<Speech_Phrases_Mutation_Response>;
  /** delete single row from the table: "speech_phrases" */
  delete_speech_phrases_by_pk?: Maybe<Speech_Phrases>;
  /** delete data from the table: "speech_phrases_session" */
  delete_speech_phrases_session?: Maybe<Speech_Phrases_Session_Mutation_Response>;
  /** delete single row from the table: "speech_phrases_session" */
  delete_speech_phrases_session_by_pk?: Maybe<Speech_Phrases_Session>;
  /** delete data from the table: "survey_questions" */
  delete_survey_questions?: Maybe<Survey_Questions_Mutation_Response>;
  /** delete single row from the table: "survey_questions" */
  delete_survey_questions_by_pk?: Maybe<Survey_Questions>;
  /** delete data from the table: "surveys" */
  delete_surveys?: Maybe<Surveys_Mutation_Response>;
  /** delete single row from the table: "surveys" */
  delete_surveys_by_pk?: Maybe<Surveys>;
  /** delete data from the table: "user_login" */
  delete_user_login?: Maybe<User_Login_Mutation_Response>;
  /** delete single row from the table: "user_login" */
  delete_user_login_by_pk?: Maybe<User_Login>;
  /** delete data from the table: "user_presence" */
  delete_user_presence?: Maybe<User_Presence_Mutation_Response>;
  /** delete single row from the table: "user_presence" */
  delete_user_presence_by_pk?: Maybe<User_Presence>;
  /** delete data from the table: "user_role" */
  delete_user_role?: Maybe<User_Role_Mutation_Response>;
  /** delete single row from the table: "user_role" */
  delete_user_role_by_pk?: Maybe<User_Role>;
  /** delete data from the table: "video_session" */
  delete_video_session?: Maybe<Video_Session_Mutation_Response>;
  /** delete single row from the table: "video_session" */
  delete_video_session_by_pk?: Maybe<Video_Session>;
  emailRegisterSession?: Maybe<EmailResponseOutput>;
  emailRescheduleSession?: Maybe<EmailResponseOutput>;
  finishSession?: Maybe<FinishSessionOutput>;
  /** Custom BL to build the proper link for Jotform's webhook integration on registration forms. */
  getProgramRegistrationLink?: Maybe<GetProgramRegistrationLinkOutput>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert data into the table: "company_contact" */
  insert_company_contact?: Maybe<Company_Contact_Mutation_Response>;
  /** insert a single row into the table: "company_contact" */
  insert_company_contact_one?: Maybe<Company_Contact>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "confirmation_status" */
  insert_confirmation_status?: Maybe<Confirmation_Status_Mutation_Response>;
  /** insert a single row into the table: "confirmation_status" */
  insert_confirmation_status_one?: Maybe<Confirmation_Status>;
  /** insert data into the table: "event" */
  insert_event?: Maybe<Event_Mutation_Response>;
  /** insert a single row into the table: "event" */
  insert_event_one?: Maybe<Event>;
  /** insert data into the table: "event_type" */
  insert_event_type?: Maybe<Event_Type_Mutation_Response>;
  /** insert a single row into the table: "event_type" */
  insert_event_type_one?: Maybe<Event_Type>;
  /** insert data into the table: "historic_events" */
  insert_historic_events?: Maybe<Historic_Events_Mutation_Response>;
  /** insert a single row into the table: "historic_events" */
  insert_historic_events_one?: Maybe<Historic_Events>;
  /** insert data into the table: "logs" */
  insert_logs?: Maybe<Logs_Mutation_Response>;
  /** insert data into the table: "logs_action" */
  insert_logs_action?: Maybe<Logs_Action_Mutation_Response>;
  /** insert a single row into the table: "logs_action" */
  insert_logs_action_one?: Maybe<Logs_Action>;
  /** insert a single row into the table: "logs" */
  insert_logs_one?: Maybe<Logs>;
  /** insert data into the table: "media" */
  insert_media?: Maybe<Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_media_one?: Maybe<Media>;
  /** insert data into the table: "nabu.companies" */
  insert_nabu_companies?: Maybe<Nabu_Companies_Mutation_Response>;
  /** insert a single row into the table: "nabu.companies" */
  insert_nabu_companies_one?: Maybe<Nabu_Companies>;
  /** insert data into the table: "nabu.feedback" */
  insert_nabu_feedback?: Maybe<Nabu_Feedback_Mutation_Response>;
  /** insert a single row into the table: "nabu.feedback" */
  insert_nabu_feedback_one?: Maybe<Nabu_Feedback>;
  /** insert data into the table: "nabu.feedback_type" */
  insert_nabu_feedback_type?: Maybe<Nabu_Feedback_Type_Mutation_Response>;
  /** insert a single row into the table: "nabu.feedback_type" */
  insert_nabu_feedback_type_one?: Maybe<Nabu_Feedback_Type>;
  /** insert data into the table: "nabu.prevalence_score_classification_runs" */
  insert_nabu_prevalence_score_classification_runs?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Mutation_Response>;
  /** insert a single row into the table: "nabu.prevalence_score_classification_runs" */
  insert_nabu_prevalence_score_classification_runs_one?: Maybe<Nabu_Prevalence_Score_Classification_Runs>;
  /** insert data into the table: "nabu.programs" */
  insert_nabu_programs?: Maybe<Nabu_Programs_Mutation_Response>;
  /** insert a single row into the table: "nabu.programs" */
  insert_nabu_programs_one?: Maybe<Nabu_Programs>;
  /** insert data into the table: "nabu.prompts" */
  insert_nabu_prompts?: Maybe<Nabu_Prompts_Mutation_Response>;
  /** insert a single row into the table: "nabu.prompts" */
  insert_nabu_prompts_one?: Maybe<Nabu_Prompts>;
  /** insert data into the table: "nabu.quotes" */
  insert_nabu_quotes?: Maybe<Nabu_Quotes_Mutation_Response>;
  /** insert a single row into the table: "nabu.quotes" */
  insert_nabu_quotes_one?: Maybe<Nabu_Quotes>;
  /** insert data into the table: "nabu.segments" */
  insert_nabu_segments?: Maybe<Nabu_Segments_Mutation_Response>;
  /** insert a single row into the table: "nabu.segments" */
  insert_nabu_segments_one?: Maybe<Nabu_Segments>;
  /** insert data into the table: "nabu.sessions" */
  insert_nabu_sessions?: Maybe<Nabu_Sessions_Mutation_Response>;
  /** insert a single row into the table: "nabu.sessions" */
  insert_nabu_sessions_one?: Maybe<Nabu_Sessions>;
  /** insert data into the table: "nabu.survey_questions" */
  insert_nabu_survey_questions?: Maybe<Nabu_Survey_Questions_Mutation_Response>;
  /** insert a single row into the table: "nabu.survey_questions" */
  insert_nabu_survey_questions_one?: Maybe<Nabu_Survey_Questions>;
  /** insert data into the table: "nabu.surveys" */
  insert_nabu_surveys?: Maybe<Nabu_Surveys_Mutation_Response>;
  /** insert a single row into the table: "nabu.surveys" */
  insert_nabu_surveys_one?: Maybe<Nabu_Surveys>;
  /** insert data into the table: "nabu.turns" */
  insert_nabu_turns?: Maybe<Nabu_Turns_Mutation_Response>;
  /** insert a single row into the table: "nabu.turns" */
  insert_nabu_turns_one?: Maybe<Nabu_Turns>;
  /** insert data into the table: "nabu.users" */
  insert_nabu_users?: Maybe<Nabu_Users_Mutation_Response>;
  /** insert a single row into the table: "nabu.users" */
  insert_nabu_users_one?: Maybe<Nabu_Users>;
  /** insert data into the table: "nabu.voxes" */
  insert_nabu_voxes?: Maybe<Nabu_Voxes_Mutation_Response>;
  /** insert a single row into the table: "nabu.voxes" */
  insert_nabu_voxes_one?: Maybe<Nabu_Voxes>;
  /** insert data into the table: "notification_conditions" */
  insert_notification_conditions?: Maybe<Notification_Conditions_Mutation_Response>;
  /** insert a single row into the table: "notification_conditions" */
  insert_notification_conditions_one?: Maybe<Notification_Conditions>;
  /** insert data into the table: "notification_offsets" */
  insert_notification_offsets?: Maybe<Notification_Offsets_Mutation_Response>;
  /** insert a single row into the table: "notification_offsets" */
  insert_notification_offsets_one?: Maybe<Notification_Offsets>;
  /** insert data into the table: "notification_templates" */
  insert_notification_templates?: Maybe<Notification_Templates_Mutation_Response>;
  /** insert a single row into the table: "notification_templates" */
  insert_notification_templates_one?: Maybe<Notification_Templates>;
  /** insert data into the table: "notification_type" */
  insert_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "notification_type" */
  insert_notification_type_one?: Maybe<Notification_Type>;
  /** insert data into the table: "participant" */
  insert_participant?: Maybe<Participant_Mutation_Response>;
  /** insert a single row into the table: "participant" */
  insert_participant_one?: Maybe<Participant>;
  /** insert data into the table: "participant_session" */
  insert_participant_session?: Maybe<Participant_Session_Mutation_Response>;
  /** insert a single row into the table: "participant_session" */
  insert_participant_session_one?: Maybe<Participant_Session>;
  /** insert data into the table: "program" */
  insert_program?: Maybe<Program_Mutation_Response>;
  /** insert a single row into the table: "program" */
  insert_program_one?: Maybe<Program>;
  /** insert data into the table: "prompts" */
  insert_prompts?: Maybe<Prompts_Mutation_Response>;
  /** insert a single row into the table: "prompts" */
  insert_prompts_one?: Maybe<Prompts>;
  /** insert data into the table: "question_type" */
  insert_question_type?: Maybe<Question_Type_Mutation_Response>;
  /** insert a single row into the table: "question_type" */
  insert_question_type_one?: Maybe<Question_Type>;
  /** insert data into the table: "recording_session" */
  insert_recording_session?: Maybe<Recording_Session_Mutation_Response>;
  /** insert a single row into the table: "recording_session" */
  insert_recording_session_one?: Maybe<Recording_Session>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "scripts" */
  insert_scripts?: Maybe<Scripts_Mutation_Response>;
  /** insert a single row into the table: "scripts" */
  insert_scripts_one?: Maybe<Scripts>;
  /** insert data into the table: "session" */
  insert_session?: Maybe<Session_Mutation_Response>;
  /** insert a single row into the table: "session" */
  insert_session_one?: Maybe<Session>;
  /** insert data into the table: "speech_phrases" */
  insert_speech_phrases?: Maybe<Speech_Phrases_Mutation_Response>;
  /** insert a single row into the table: "speech_phrases" */
  insert_speech_phrases_one?: Maybe<Speech_Phrases>;
  /** insert data into the table: "speech_phrases_session" */
  insert_speech_phrases_session?: Maybe<Speech_Phrases_Session_Mutation_Response>;
  /** insert a single row into the table: "speech_phrases_session" */
  insert_speech_phrases_session_one?: Maybe<Speech_Phrases_Session>;
  /** insert data into the table: "survey_questions" */
  insert_survey_questions?: Maybe<Survey_Questions_Mutation_Response>;
  /** insert a single row into the table: "survey_questions" */
  insert_survey_questions_one?: Maybe<Survey_Questions>;
  /** insert data into the table: "surveys" */
  insert_surveys?: Maybe<Surveys_Mutation_Response>;
  /** insert a single row into the table: "surveys" */
  insert_surveys_one?: Maybe<Surveys>;
  /** insert data into the table: "user_login" */
  insert_user_login?: Maybe<User_Login_Mutation_Response>;
  /** insert a single row into the table: "user_login" */
  insert_user_login_one?: Maybe<User_Login>;
  /** insert data into the table: "user_presence" */
  insert_user_presence?: Maybe<User_Presence_Mutation_Response>;
  /** insert a single row into the table: "user_presence" */
  insert_user_presence_one?: Maybe<User_Presence>;
  /** insert data into the table: "user_role" */
  insert_user_role?: Maybe<User_Role_Mutation_Response>;
  /** insert a single row into the table: "user_role" */
  insert_user_role_one?: Maybe<User_Role>;
  /** insert data into the table: "video_session" */
  insert_video_session?: Maybe<Video_Session_Mutation_Response>;
  /** insert a single row into the table: "video_session" */
  insert_video_session_one?: Maybe<Video_Session>;
  registerEvent?: Maybe<RegisterEventOutput>;
  /** Reschedule participant session to another session */
  rescheduleParticipantSession?: Maybe<RescheduleParticipantSessionOutput>;
  sendTalkTimeMessage?: Maybe<TalkTimeMessageEventOutput>;
  startRecording?: Maybe<StartRecordingOutput>;
  syntethizeTextToSpeech?: Maybe<SyntethizeTextToSpeechOutput>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update data of the table: "company_contact" */
  update_company_contact?: Maybe<Company_Contact_Mutation_Response>;
  /** update single row of the table: "company_contact" */
  update_company_contact_by_pk?: Maybe<Company_Contact>;
  /** update data of the table: "confirmation_status" */
  update_confirmation_status?: Maybe<Confirmation_Status_Mutation_Response>;
  /** update single row of the table: "confirmation_status" */
  update_confirmation_status_by_pk?: Maybe<Confirmation_Status>;
  /** update data of the table: "event" */
  update_event?: Maybe<Event_Mutation_Response>;
  /** update single row of the table: "event" */
  update_event_by_pk?: Maybe<Event>;
  /** update data of the table: "event_type" */
  update_event_type?: Maybe<Event_Type_Mutation_Response>;
  /** update single row of the table: "event_type" */
  update_event_type_by_pk?: Maybe<Event_Type>;
  /** update data of the table: "historic_events" */
  update_historic_events?: Maybe<Historic_Events_Mutation_Response>;
  /** update single row of the table: "historic_events" */
  update_historic_events_by_pk?: Maybe<Historic_Events>;
  /** update data of the table: "logs" */
  update_logs?: Maybe<Logs_Mutation_Response>;
  /** update data of the table: "logs_action" */
  update_logs_action?: Maybe<Logs_Action_Mutation_Response>;
  /** update single row of the table: "logs_action" */
  update_logs_action_by_pk?: Maybe<Logs_Action>;
  /** update single row of the table: "logs" */
  update_logs_by_pk?: Maybe<Logs>;
  /** update data of the table: "media" */
  update_media?: Maybe<Media_Mutation_Response>;
  /** update single row of the table: "media" */
  update_media_by_pk?: Maybe<Media>;
  /** update data of the table: "nabu.companies" */
  update_nabu_companies?: Maybe<Nabu_Companies_Mutation_Response>;
  /** update data of the table: "nabu.feedback" */
  update_nabu_feedback?: Maybe<Nabu_Feedback_Mutation_Response>;
  /** update single row of the table: "nabu.feedback" */
  update_nabu_feedback_by_pk?: Maybe<Nabu_Feedback>;
  /** update data of the table: "nabu.feedback_type" */
  update_nabu_feedback_type?: Maybe<Nabu_Feedback_Type_Mutation_Response>;
  /** update single row of the table: "nabu.feedback_type" */
  update_nabu_feedback_type_by_pk?: Maybe<Nabu_Feedback_Type>;
  /** update data of the table: "nabu.prevalence_score_classification_runs" */
  update_nabu_prevalence_score_classification_runs?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Mutation_Response>;
  /** update single row of the table: "nabu.prevalence_score_classification_runs" */
  update_nabu_prevalence_score_classification_runs_by_pk?: Maybe<Nabu_Prevalence_Score_Classification_Runs>;
  /** update data of the table: "nabu.programs" */
  update_nabu_programs?: Maybe<Nabu_Programs_Mutation_Response>;
  /** update data of the table: "nabu.prompts" */
  update_nabu_prompts?: Maybe<Nabu_Prompts_Mutation_Response>;
  /** update data of the table: "nabu.quotes" */
  update_nabu_quotes?: Maybe<Nabu_Quotes_Mutation_Response>;
  /** update single row of the table: "nabu.quotes" */
  update_nabu_quotes_by_pk?: Maybe<Nabu_Quotes>;
  /** update data of the table: "nabu.segments" */
  update_nabu_segments?: Maybe<Nabu_Segments_Mutation_Response>;
  /** update data of the table: "nabu.sessions" */
  update_nabu_sessions?: Maybe<Nabu_Sessions_Mutation_Response>;
  /** update data of the table: "nabu.survey_questions" */
  update_nabu_survey_questions?: Maybe<Nabu_Survey_Questions_Mutation_Response>;
  /** update data of the table: "nabu.surveys" */
  update_nabu_surveys?: Maybe<Nabu_Surveys_Mutation_Response>;
  /** update data of the table: "nabu.turns" */
  update_nabu_turns?: Maybe<Nabu_Turns_Mutation_Response>;
  /** update single row of the table: "nabu.turns" */
  update_nabu_turns_by_pk?: Maybe<Nabu_Turns>;
  /** update data of the table: "nabu.users" */
  update_nabu_users?: Maybe<Nabu_Users_Mutation_Response>;
  /** update data of the table: "nabu.voxes" */
  update_nabu_voxes?: Maybe<Nabu_Voxes_Mutation_Response>;
  /** update single row of the table: "nabu.voxes" */
  update_nabu_voxes_by_pk?: Maybe<Nabu_Voxes>;
  /** update data of the table: "notification_conditions" */
  update_notification_conditions?: Maybe<Notification_Conditions_Mutation_Response>;
  /** update single row of the table: "notification_conditions" */
  update_notification_conditions_by_pk?: Maybe<Notification_Conditions>;
  /** update data of the table: "notification_offsets" */
  update_notification_offsets?: Maybe<Notification_Offsets_Mutation_Response>;
  /** update single row of the table: "notification_offsets" */
  update_notification_offsets_by_pk?: Maybe<Notification_Offsets>;
  /** update data of the table: "notification_templates" */
  update_notification_templates?: Maybe<Notification_Templates_Mutation_Response>;
  /** update single row of the table: "notification_templates" */
  update_notification_templates_by_pk?: Maybe<Notification_Templates>;
  /** update data of the table: "notification_type" */
  update_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** update single row of the table: "notification_type" */
  update_notification_type_by_pk?: Maybe<Notification_Type>;
  /** update data of the table: "participant" */
  update_participant?: Maybe<Participant_Mutation_Response>;
  /** update single row of the table: "participant" */
  update_participant_by_pk?: Maybe<Participant>;
  /** update data of the table: "participant_session" */
  update_participant_session?: Maybe<Participant_Session_Mutation_Response>;
  /** update single row of the table: "participant_session" */
  update_participant_session_by_pk?: Maybe<Participant_Session>;
  /** update data of the table: "program" */
  update_program?: Maybe<Program_Mutation_Response>;
  /** update single row of the table: "program" */
  update_program_by_pk?: Maybe<Program>;
  /** update data of the table: "prompts" */
  update_prompts?: Maybe<Prompts_Mutation_Response>;
  /** update single row of the table: "prompts" */
  update_prompts_by_pk?: Maybe<Prompts>;
  /** update data of the table: "question_type" */
  update_question_type?: Maybe<Question_Type_Mutation_Response>;
  /** update single row of the table: "question_type" */
  update_question_type_by_pk?: Maybe<Question_Type>;
  /** update data of the table: "recording_session" */
  update_recording_session?: Maybe<Recording_Session_Mutation_Response>;
  /** update single row of the table: "recording_session" */
  update_recording_session_by_pk?: Maybe<Recording_Session>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update data of the table: "scripts" */
  update_scripts?: Maybe<Scripts_Mutation_Response>;
  /** update single row of the table: "scripts" */
  update_scripts_by_pk?: Maybe<Scripts>;
  /** update data of the table: "session" */
  update_session?: Maybe<Session_Mutation_Response>;
  /** update single row of the table: "session" */
  update_session_by_pk?: Maybe<Session>;
  /** update data of the table: "speech_phrases" */
  update_speech_phrases?: Maybe<Speech_Phrases_Mutation_Response>;
  /** update single row of the table: "speech_phrases" */
  update_speech_phrases_by_pk?: Maybe<Speech_Phrases>;
  /** update data of the table: "speech_phrases_session" */
  update_speech_phrases_session?: Maybe<Speech_Phrases_Session_Mutation_Response>;
  /** update single row of the table: "speech_phrases_session" */
  update_speech_phrases_session_by_pk?: Maybe<Speech_Phrases_Session>;
  /** update data of the table: "survey_questions" */
  update_survey_questions?: Maybe<Survey_Questions_Mutation_Response>;
  /** update single row of the table: "survey_questions" */
  update_survey_questions_by_pk?: Maybe<Survey_Questions>;
  /** update data of the table: "surveys" */
  update_surveys?: Maybe<Surveys_Mutation_Response>;
  /** update single row of the table: "surveys" */
  update_surveys_by_pk?: Maybe<Surveys>;
  /** update data of the table: "user_login" */
  update_user_login?: Maybe<User_Login_Mutation_Response>;
  /** update single row of the table: "user_login" */
  update_user_login_by_pk?: Maybe<User_Login>;
  /** update data of the table: "user_presence" */
  update_user_presence?: Maybe<User_Presence_Mutation_Response>;
  /** update single row of the table: "user_presence" */
  update_user_presence_by_pk?: Maybe<User_Presence>;
  /** update data of the table: "user_role" */
  update_user_role?: Maybe<User_Role_Mutation_Response>;
  /** update single row of the table: "user_role" */
  update_user_role_by_pk?: Maybe<User_Role>;
  /** update data of the table: "video_session" */
  update_video_session?: Maybe<Video_Session_Mutation_Response>;
  /** update single row of the table: "video_session" */
  update_video_session_by_pk?: Maybe<Video_Session>;
};


/** mutation root */
export type Mutation_RootAddParticipantsArgs = {
  participants: Array<AddParticipantsItem>;
};


/** mutation root */
export type Mutation_RootChangePreferencesArgs = {
  preferences: Scalars['String'];
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_ContactArgs = {
  where: Company_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Confirmation_StatusArgs = {
  where: Confirmation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Confirmation_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_EventArgs = {
  where: Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TypeArgs = {
  where: Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Historic_EventsArgs = {
  where: Historic_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Historic_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LogsArgs = {
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_ActionArgs = {
  where: Logs_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_Action_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MediaArgs = {
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Media_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_CompaniesArgs = {
  where: Nabu_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_FeedbackArgs = {
  where: Nabu_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Feedback_TypeArgs = {
  where: Nabu_Feedback_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Feedback_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Prevalence_Score_Classification_RunsArgs = {
  where: Nabu_Prevalence_Score_Classification_Runs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Prevalence_Score_Classification_Runs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_ProgramsArgs = {
  where: Nabu_Programs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_PromptsArgs = {
  where: Nabu_Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_QuotesArgs = {
  where: Nabu_Quotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Quotes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_SegmentsArgs = {
  where: Nabu_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_SessionsArgs = {
  where: Nabu_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Survey_QuestionsArgs = {
  where: Nabu_Survey_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_SurveysArgs = {
  where: Nabu_Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_TurnsArgs = {
  where: Nabu_Turns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Turns_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabu_UsersArgs = {
  where: Nabu_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_VoxesArgs = {
  where: Nabu_Voxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabu_Voxes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_ConditionsArgs = {
  where: Notification_Conditions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Conditions_By_PkArgs = {
  value: Notification_Type_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Notification_OffsetsArgs = {
  where: Notification_Offsets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Offsets_By_PkArgs = {
  value: Notification_Type_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Notification_TemplatesArgs = {
  where: Notification_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TypeArgs = {
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ParticipantArgs = {
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Participant_SessionArgs = {
  where: Participant_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProgramArgs = {
  where: Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Program_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PromptsArgs = {
  where: Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prompts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Question_TypeArgs = {
  where: Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Recording_SessionArgs = {
  where: Recording_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recording_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ScriptsArgs = {
  where: Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scripts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SessionArgs = {
  where: Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Speech_PhrasesArgs = {
  where: Speech_Phrases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Speech_Phrases_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Speech_Phrases_SessionArgs = {
  where: Speech_Phrases_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Speech_Phrases_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_QuestionsArgs = {
  where: Survey_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SurveysArgs = {
  where: Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Surveys_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_LoginArgs = {
  where: User_Login_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Login_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_PresenceArgs = {
  where: User_Presence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Presence_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_RoleArgs = {
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Video_SessionArgs = {
  where: Video_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Video_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootEmailRegisterSessionArgs = {
  companyName: Scalars['String'];
  participantEmail: Scalars['String'];
  participantFirstName: Scalars['String'];
  participantId: Scalars['String'];
  participantLastName: Scalars['String'];
  participantPreferredName?: Maybe<Scalars['String']>;
  sessionDateTime: Scalars['String'];
  sessionId: Scalars['String'];
  sessionName: Scalars['String'];
  sessionTimezone: Scalars['String'];
};


/** mutation root */
export type Mutation_RootEmailRescheduleSessionArgs = {
  companyName: Scalars['String'];
  participantEmail: Scalars['String'];
  participantFirstName: Scalars['String'];
  participantId: Scalars['String'];
  participantLastName: Scalars['String'];
  participantPreferredName?: Maybe<Scalars['String']>;
  prevSessionDateTime: Scalars['String'];
  prevSessionId: Scalars['String'];
  prevSessionName: Scalars['String'];
  prevSessionTimezone: Scalars['String'];
  sessionDateTime: Scalars['String'];
  sessionId: Scalars['String'];
  sessionName: Scalars['String'];
  sessionTimezone: Scalars['String'];
};


/** mutation root */
export type Mutation_RootFinishSessionArgs = {
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetProgramRegistrationLinkArgs = {
  programId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: Maybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: Maybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_ContactArgs = {
  objects: Array<Company_Contact_Insert_Input>;
  on_conflict?: Maybe<Company_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Contact_OneArgs = {
  object: Company_Contact_Insert_Input;
  on_conflict?: Maybe<Company_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Confirmation_StatusArgs = {
  objects: Array<Confirmation_Status_Insert_Input>;
  on_conflict?: Maybe<Confirmation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Confirmation_Status_OneArgs = {
  object: Confirmation_Status_Insert_Input;
  on_conflict?: Maybe<Confirmation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventArgs = {
  objects: Array<Event_Insert_Input>;
  on_conflict?: Maybe<Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_OneArgs = {
  object: Event_Insert_Input;
  on_conflict?: Maybe<Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TypeArgs = {
  objects: Array<Event_Type_Insert_Input>;
  on_conflict?: Maybe<Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Type_OneArgs = {
  object: Event_Type_Insert_Input;
  on_conflict?: Maybe<Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historic_EventsArgs = {
  objects: Array<Historic_Events_Insert_Input>;
  on_conflict?: Maybe<Historic_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historic_Events_OneArgs = {
  object: Historic_Events_Insert_Input;
  on_conflict?: Maybe<Historic_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LogsArgs = {
  objects: Array<Logs_Insert_Input>;
  on_conflict?: Maybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_ActionArgs = {
  objects: Array<Logs_Action_Insert_Input>;
  on_conflict?: Maybe<Logs_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_Action_OneArgs = {
  object: Logs_Action_Insert_Input;
  on_conflict?: Maybe<Logs_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_OneArgs = {
  object: Logs_Insert_Input;
  on_conflict?: Maybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MediaArgs = {
  objects: Array<Media_Insert_Input>;
  on_conflict?: Maybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Media_OneArgs = {
  object: Media_Insert_Input;
  on_conflict?: Maybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_CompaniesArgs = {
  objects: Array<Nabu_Companies_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Companies_OneArgs = {
  object: Nabu_Companies_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_FeedbackArgs = {
  objects: Array<Nabu_Feedback_Insert_Input>;
  on_conflict?: Maybe<Nabu_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Feedback_OneArgs = {
  object: Nabu_Feedback_Insert_Input;
  on_conflict?: Maybe<Nabu_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Feedback_TypeArgs = {
  objects: Array<Nabu_Feedback_Type_Insert_Input>;
  on_conflict?: Maybe<Nabu_Feedback_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Feedback_Type_OneArgs = {
  object: Nabu_Feedback_Type_Insert_Input;
  on_conflict?: Maybe<Nabu_Feedback_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Prevalence_Score_Classification_RunsArgs = {
  objects: Array<Nabu_Prevalence_Score_Classification_Runs_Insert_Input>;
  on_conflict?: Maybe<Nabu_Prevalence_Score_Classification_Runs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Prevalence_Score_Classification_Runs_OneArgs = {
  object: Nabu_Prevalence_Score_Classification_Runs_Insert_Input;
  on_conflict?: Maybe<Nabu_Prevalence_Score_Classification_Runs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_ProgramsArgs = {
  objects: Array<Nabu_Programs_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Programs_OneArgs = {
  object: Nabu_Programs_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_PromptsArgs = {
  objects: Array<Nabu_Prompts_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Prompts_OneArgs = {
  object: Nabu_Prompts_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_QuotesArgs = {
  objects: Array<Nabu_Quotes_Insert_Input>;
  on_conflict?: Maybe<Nabu_Quotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Quotes_OneArgs = {
  object: Nabu_Quotes_Insert_Input;
  on_conflict?: Maybe<Nabu_Quotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_SegmentsArgs = {
  objects: Array<Nabu_Segments_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Segments_OneArgs = {
  object: Nabu_Segments_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_SessionsArgs = {
  objects: Array<Nabu_Sessions_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Sessions_OneArgs = {
  object: Nabu_Sessions_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Survey_QuestionsArgs = {
  objects: Array<Nabu_Survey_Questions_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Survey_Questions_OneArgs = {
  object: Nabu_Survey_Questions_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_SurveysArgs = {
  objects: Array<Nabu_Surveys_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Surveys_OneArgs = {
  object: Nabu_Surveys_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_TurnsArgs = {
  objects: Array<Nabu_Turns_Insert_Input>;
  on_conflict?: Maybe<Nabu_Turns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Turns_OneArgs = {
  object: Nabu_Turns_Insert_Input;
  on_conflict?: Maybe<Nabu_Turns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_UsersArgs = {
  objects: Array<Nabu_Users_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Users_OneArgs = {
  object: Nabu_Users_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_VoxesArgs = {
  objects: Array<Nabu_Voxes_Insert_Input>;
  on_conflict?: Maybe<Nabu_Voxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabu_Voxes_OneArgs = {
  object: Nabu_Voxes_Insert_Input;
  on_conflict?: Maybe<Nabu_Voxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_ConditionsArgs = {
  objects: Array<Notification_Conditions_Insert_Input>;
  on_conflict?: Maybe<Notification_Conditions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Conditions_OneArgs = {
  object: Notification_Conditions_Insert_Input;
  on_conflict?: Maybe<Notification_Conditions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OffsetsArgs = {
  objects: Array<Notification_Offsets_Insert_Input>;
  on_conflict?: Maybe<Notification_Offsets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Offsets_OneArgs = {
  object: Notification_Offsets_Insert_Input;
  on_conflict?: Maybe<Notification_Offsets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TemplatesArgs = {
  objects: Array<Notification_Templates_Insert_Input>;
  on_conflict?: Maybe<Notification_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Templates_OneArgs = {
  object: Notification_Templates_Insert_Input;
  on_conflict?: Maybe<Notification_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TypeArgs = {
  objects: Array<Notification_Type_Insert_Input>;
  on_conflict?: Maybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Type_OneArgs = {
  object: Notification_Type_Insert_Input;
  on_conflict?: Maybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ParticipantArgs = {
  objects: Array<Participant_Insert_Input>;
  on_conflict?: Maybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_OneArgs = {
  object: Participant_Insert_Input;
  on_conflict?: Maybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_SessionArgs = {
  objects: Array<Participant_Session_Insert_Input>;
  on_conflict?: Maybe<Participant_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Session_OneArgs = {
  object: Participant_Session_Insert_Input;
  on_conflict?: Maybe<Participant_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProgramArgs = {
  objects: Array<Program_Insert_Input>;
  on_conflict?: Maybe<Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Program_OneArgs = {
  object: Program_Insert_Input;
  on_conflict?: Maybe<Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PromptsArgs = {
  objects: Array<Prompts_Insert_Input>;
  on_conflict?: Maybe<Prompts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prompts_OneArgs = {
  object: Prompts_Insert_Input;
  on_conflict?: Maybe<Prompts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_TypeArgs = {
  objects: Array<Question_Type_Insert_Input>;
  on_conflict?: Maybe<Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Type_OneArgs = {
  object: Question_Type_Insert_Input;
  on_conflict?: Maybe<Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recording_SessionArgs = {
  objects: Array<Recording_Session_Insert_Input>;
  on_conflict?: Maybe<Recording_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recording_Session_OneArgs = {
  object: Recording_Session_Insert_Input;
  on_conflict?: Maybe<Recording_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: Maybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: Maybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScriptsArgs = {
  objects: Array<Scripts_Insert_Input>;
  on_conflict?: Maybe<Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scripts_OneArgs = {
  object: Scripts_Insert_Input;
  on_conflict?: Maybe<Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SessionArgs = {
  objects: Array<Session_Insert_Input>;
  on_conflict?: Maybe<Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_OneArgs = {
  object: Session_Insert_Input;
  on_conflict?: Maybe<Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speech_PhrasesArgs = {
  objects: Array<Speech_Phrases_Insert_Input>;
  on_conflict?: Maybe<Speech_Phrases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speech_Phrases_OneArgs = {
  object: Speech_Phrases_Insert_Input;
  on_conflict?: Maybe<Speech_Phrases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speech_Phrases_SessionArgs = {
  objects: Array<Speech_Phrases_Session_Insert_Input>;
  on_conflict?: Maybe<Speech_Phrases_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speech_Phrases_Session_OneArgs = {
  object: Speech_Phrases_Session_Insert_Input;
  on_conflict?: Maybe<Speech_Phrases_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_QuestionsArgs = {
  objects: Array<Survey_Questions_Insert_Input>;
  on_conflict?: Maybe<Survey_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Questions_OneArgs = {
  object: Survey_Questions_Insert_Input;
  on_conflict?: Maybe<Survey_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SurveysArgs = {
  objects: Array<Surveys_Insert_Input>;
  on_conflict?: Maybe<Surveys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Surveys_OneArgs = {
  object: Surveys_Insert_Input;
  on_conflict?: Maybe<Surveys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LoginArgs = {
  objects: Array<User_Login_Insert_Input>;
  on_conflict?: Maybe<User_Login_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Login_OneArgs = {
  object: User_Login_Insert_Input;
  on_conflict?: Maybe<User_Login_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PresenceArgs = {
  objects: Array<User_Presence_Insert_Input>;
  on_conflict?: Maybe<User_Presence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Presence_OneArgs = {
  object: User_Presence_Insert_Input;
  on_conflict?: Maybe<User_Presence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RoleArgs = {
  objects: Array<User_Role_Insert_Input>;
  on_conflict?: Maybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Role_OneArgs = {
  object: User_Role_Insert_Input;
  on_conflict?: Maybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_SessionArgs = {
  objects: Array<Video_Session_Insert_Input>;
  on_conflict?: Maybe<Video_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_Session_OneArgs = {
  object: Video_Session_Insert_Input;
  on_conflict?: Maybe<Video_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRegisterEventArgs = {
  clientTimestamp?: Maybe<Scalars['String']>;
  eventTypeName: Scalars['String'];
  metadata: Scalars['String'];
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRescheduleParticipantSessionArgs = {
  participantId: Scalars['String'];
  sessionId: Scalars['String'];
  targetSessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSendTalkTimeMessageArgs = {
  segmentName: Scalars['String'];
  segmentType: Scalars['String'];
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootStartRecordingArgs = {
  sessionId: Scalars['String'];
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSyntethizeTextToSpeechArgs = {
  sessionId: Scalars['String'];
  text: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _set?: Maybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _set?: Maybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _set?: Maybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _set?: Maybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ContactArgs = {
  _set?: Maybe<Company_Contact_Set_Input>;
  where: Company_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Contact_By_PkArgs = {
  _set?: Maybe<Company_Contact_Set_Input>;
  pk_columns: Company_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Confirmation_StatusArgs = {
  _set?: Maybe<Confirmation_Status_Set_Input>;
  where: Confirmation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Confirmation_Status_By_PkArgs = {
  _set?: Maybe<Confirmation_Status_Set_Input>;
  pk_columns: Confirmation_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventArgs = {
  _append?: Maybe<Event_Append_Input>;
  _delete_at_path?: Maybe<Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Event_Delete_Key_Input>;
  _prepend?: Maybe<Event_Prepend_Input>;
  _set?: Maybe<Event_Set_Input>;
  where: Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_By_PkArgs = {
  _append?: Maybe<Event_Append_Input>;
  _delete_at_path?: Maybe<Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Event_Delete_Key_Input>;
  _prepend?: Maybe<Event_Prepend_Input>;
  _set?: Maybe<Event_Set_Input>;
  pk_columns: Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TypeArgs = {
  _set?: Maybe<Event_Type_Set_Input>;
  where: Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Type_By_PkArgs = {
  _set?: Maybe<Event_Type_Set_Input>;
  pk_columns: Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Historic_EventsArgs = {
  _append?: Maybe<Historic_Events_Append_Input>;
  _delete_at_path?: Maybe<Historic_Events_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Historic_Events_Delete_Elem_Input>;
  _delete_key?: Maybe<Historic_Events_Delete_Key_Input>;
  _prepend?: Maybe<Historic_Events_Prepend_Input>;
  _set?: Maybe<Historic_Events_Set_Input>;
  where: Historic_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Historic_Events_By_PkArgs = {
  _append?: Maybe<Historic_Events_Append_Input>;
  _delete_at_path?: Maybe<Historic_Events_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Historic_Events_Delete_Elem_Input>;
  _delete_key?: Maybe<Historic_Events_Delete_Key_Input>;
  _prepend?: Maybe<Historic_Events_Prepend_Input>;
  _set?: Maybe<Historic_Events_Set_Input>;
  pk_columns: Historic_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LogsArgs = {
  _set?: Maybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_ActionArgs = {
  _set?: Maybe<Logs_Action_Set_Input>;
  where: Logs_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_Action_By_PkArgs = {
  _set?: Maybe<Logs_Action_Set_Input>;
  pk_columns: Logs_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_By_PkArgs = {
  _set?: Maybe<Logs_Set_Input>;
  pk_columns: Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MediaArgs = {
  _set?: Maybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Media_By_PkArgs = {
  _set?: Maybe<Media_Set_Input>;
  pk_columns: Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_CompaniesArgs = {
  _set?: Maybe<Nabu_Companies_Set_Input>;
  where: Nabu_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_FeedbackArgs = {
  _set?: Maybe<Nabu_Feedback_Set_Input>;
  where: Nabu_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Feedback_By_PkArgs = {
  _set?: Maybe<Nabu_Feedback_Set_Input>;
  pk_columns: Nabu_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Feedback_TypeArgs = {
  _set?: Maybe<Nabu_Feedback_Type_Set_Input>;
  where: Nabu_Feedback_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Feedback_Type_By_PkArgs = {
  _set?: Maybe<Nabu_Feedback_Type_Set_Input>;
  pk_columns: Nabu_Feedback_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Prevalence_Score_Classification_RunsArgs = {
  _set?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Set_Input>;
  where: Nabu_Prevalence_Score_Classification_Runs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Prevalence_Score_Classification_Runs_By_PkArgs = {
  _set?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Set_Input>;
  pk_columns: Nabu_Prevalence_Score_Classification_Runs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_ProgramsArgs = {
  _set?: Maybe<Nabu_Programs_Set_Input>;
  where: Nabu_Programs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_PromptsArgs = {
  _set?: Maybe<Nabu_Prompts_Set_Input>;
  where: Nabu_Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_QuotesArgs = {
  _inc?: Maybe<Nabu_Quotes_Inc_Input>;
  _set?: Maybe<Nabu_Quotes_Set_Input>;
  where: Nabu_Quotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Quotes_By_PkArgs = {
  _inc?: Maybe<Nabu_Quotes_Inc_Input>;
  _set?: Maybe<Nabu_Quotes_Set_Input>;
  pk_columns: Nabu_Quotes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_SegmentsArgs = {
  _append?: Maybe<Nabu_Segments_Append_Input>;
  _delete_at_path?: Maybe<Nabu_Segments_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Nabu_Segments_Delete_Elem_Input>;
  _delete_key?: Maybe<Nabu_Segments_Delete_Key_Input>;
  _inc?: Maybe<Nabu_Segments_Inc_Input>;
  _prepend?: Maybe<Nabu_Segments_Prepend_Input>;
  _set?: Maybe<Nabu_Segments_Set_Input>;
  where: Nabu_Segments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_SessionsArgs = {
  _append?: Maybe<Nabu_Sessions_Append_Input>;
  _delete_at_path?: Maybe<Nabu_Sessions_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Nabu_Sessions_Delete_Elem_Input>;
  _delete_key?: Maybe<Nabu_Sessions_Delete_Key_Input>;
  _inc?: Maybe<Nabu_Sessions_Inc_Input>;
  _prepend?: Maybe<Nabu_Sessions_Prepend_Input>;
  _set?: Maybe<Nabu_Sessions_Set_Input>;
  where: Nabu_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Survey_QuestionsArgs = {
  _set?: Maybe<Nabu_Survey_Questions_Set_Input>;
  where: Nabu_Survey_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_SurveysArgs = {
  _inc?: Maybe<Nabu_Surveys_Inc_Input>;
  _set?: Maybe<Nabu_Surveys_Set_Input>;
  where: Nabu_Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_TurnsArgs = {
  _inc?: Maybe<Nabu_Turns_Inc_Input>;
  _set?: Maybe<Nabu_Turns_Set_Input>;
  where: Nabu_Turns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Turns_By_PkArgs = {
  _inc?: Maybe<Nabu_Turns_Inc_Input>;
  _set?: Maybe<Nabu_Turns_Set_Input>;
  pk_columns: Nabu_Turns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_UsersArgs = {
  _append?: Maybe<Nabu_Users_Append_Input>;
  _delete_at_path?: Maybe<Nabu_Users_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Nabu_Users_Delete_Elem_Input>;
  _delete_key?: Maybe<Nabu_Users_Delete_Key_Input>;
  _inc?: Maybe<Nabu_Users_Inc_Input>;
  _prepend?: Maybe<Nabu_Users_Prepend_Input>;
  _set?: Maybe<Nabu_Users_Set_Input>;
  where: Nabu_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_VoxesArgs = {
  _set?: Maybe<Nabu_Voxes_Set_Input>;
  where: Nabu_Voxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabu_Voxes_By_PkArgs = {
  _set?: Maybe<Nabu_Voxes_Set_Input>;
  pk_columns: Nabu_Voxes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ConditionsArgs = {
  _set?: Maybe<Notification_Conditions_Set_Input>;
  where: Notification_Conditions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Conditions_By_PkArgs = {
  _set?: Maybe<Notification_Conditions_Set_Input>;
  pk_columns: Notification_Conditions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_OffsetsArgs = {
  _inc?: Maybe<Notification_Offsets_Inc_Input>;
  _set?: Maybe<Notification_Offsets_Set_Input>;
  where: Notification_Offsets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Offsets_By_PkArgs = {
  _inc?: Maybe<Notification_Offsets_Inc_Input>;
  _set?: Maybe<Notification_Offsets_Set_Input>;
  pk_columns: Notification_Offsets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TemplatesArgs = {
  _set?: Maybe<Notification_Templates_Set_Input>;
  where: Notification_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Templates_By_PkArgs = {
  _set?: Maybe<Notification_Templates_Set_Input>;
  pk_columns: Notification_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TypeArgs = {
  _set?: Maybe<Notification_Type_Set_Input>;
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_By_PkArgs = {
  _set?: Maybe<Notification_Type_Set_Input>;
  pk_columns: Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ParticipantArgs = {
  _append?: Maybe<Participant_Append_Input>;
  _delete_at_path?: Maybe<Participant_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Participant_Delete_Elem_Input>;
  _delete_key?: Maybe<Participant_Delete_Key_Input>;
  _inc?: Maybe<Participant_Inc_Input>;
  _prepend?: Maybe<Participant_Prepend_Input>;
  _set?: Maybe<Participant_Set_Input>;
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_By_PkArgs = {
  _append?: Maybe<Participant_Append_Input>;
  _delete_at_path?: Maybe<Participant_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Participant_Delete_Elem_Input>;
  _delete_key?: Maybe<Participant_Delete_Key_Input>;
  _inc?: Maybe<Participant_Inc_Input>;
  _prepend?: Maybe<Participant_Prepend_Input>;
  _set?: Maybe<Participant_Set_Input>;
  pk_columns: Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_SessionArgs = {
  _set?: Maybe<Participant_Session_Set_Input>;
  where: Participant_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Session_By_PkArgs = {
  _set?: Maybe<Participant_Session_Set_Input>;
  pk_columns: Participant_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProgramArgs = {
  _set?: Maybe<Program_Set_Input>;
  where: Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Program_By_PkArgs = {
  _set?: Maybe<Program_Set_Input>;
  pk_columns: Program_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PromptsArgs = {
  _set?: Maybe<Prompts_Set_Input>;
  where: Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prompts_By_PkArgs = {
  _set?: Maybe<Prompts_Set_Input>;
  pk_columns: Prompts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_TypeArgs = {
  _set?: Maybe<Question_Type_Set_Input>;
  where: Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Type_By_PkArgs = {
  _set?: Maybe<Question_Type_Set_Input>;
  pk_columns: Question_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recording_SessionArgs = {
  _set?: Maybe<Recording_Session_Set_Input>;
  where: Recording_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recording_Session_By_PkArgs = {
  _set?: Maybe<Recording_Session_Set_Input>;
  pk_columns: Recording_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _set?: Maybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _set?: Maybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ScriptsArgs = {
  _append?: Maybe<Scripts_Append_Input>;
  _delete_at_path?: Maybe<Scripts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Scripts_Delete_Elem_Input>;
  _delete_key?: Maybe<Scripts_Delete_Key_Input>;
  _inc?: Maybe<Scripts_Inc_Input>;
  _prepend?: Maybe<Scripts_Prepend_Input>;
  _set?: Maybe<Scripts_Set_Input>;
  where: Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scripts_By_PkArgs = {
  _append?: Maybe<Scripts_Append_Input>;
  _delete_at_path?: Maybe<Scripts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Scripts_Delete_Elem_Input>;
  _delete_key?: Maybe<Scripts_Delete_Key_Input>;
  _inc?: Maybe<Scripts_Inc_Input>;
  _prepend?: Maybe<Scripts_Prepend_Input>;
  _set?: Maybe<Scripts_Set_Input>;
  pk_columns: Scripts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SessionArgs = {
  _append?: Maybe<Session_Append_Input>;
  _delete_at_path?: Maybe<Session_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Session_Delete_Elem_Input>;
  _delete_key?: Maybe<Session_Delete_Key_Input>;
  _inc?: Maybe<Session_Inc_Input>;
  _prepend?: Maybe<Session_Prepend_Input>;
  _set?: Maybe<Session_Set_Input>;
  where: Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Session_By_PkArgs = {
  _append?: Maybe<Session_Append_Input>;
  _delete_at_path?: Maybe<Session_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Session_Delete_Elem_Input>;
  _delete_key?: Maybe<Session_Delete_Key_Input>;
  _inc?: Maybe<Session_Inc_Input>;
  _prepend?: Maybe<Session_Prepend_Input>;
  _set?: Maybe<Session_Set_Input>;
  pk_columns: Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Speech_PhrasesArgs = {
  _inc?: Maybe<Speech_Phrases_Inc_Input>;
  _set?: Maybe<Speech_Phrases_Set_Input>;
  where: Speech_Phrases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Speech_Phrases_By_PkArgs = {
  _inc?: Maybe<Speech_Phrases_Inc_Input>;
  _set?: Maybe<Speech_Phrases_Set_Input>;
  pk_columns: Speech_Phrases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Speech_Phrases_SessionArgs = {
  _set?: Maybe<Speech_Phrases_Session_Set_Input>;
  where: Speech_Phrases_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Speech_Phrases_Session_By_PkArgs = {
  _set?: Maybe<Speech_Phrases_Session_Set_Input>;
  pk_columns: Speech_Phrases_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_QuestionsArgs = {
  _set?: Maybe<Survey_Questions_Set_Input>;
  where: Survey_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Questions_By_PkArgs = {
  _set?: Maybe<Survey_Questions_Set_Input>;
  pk_columns: Survey_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SurveysArgs = {
  _inc?: Maybe<Surveys_Inc_Input>;
  _set?: Maybe<Surveys_Set_Input>;
  where: Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Surveys_By_PkArgs = {
  _inc?: Maybe<Surveys_Inc_Input>;
  _set?: Maybe<Surveys_Set_Input>;
  pk_columns: Surveys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_LoginArgs = {
  _set?: Maybe<User_Login_Set_Input>;
  where: User_Login_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Login_By_PkArgs = {
  _set?: Maybe<User_Login_Set_Input>;
  pk_columns: User_Login_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_PresenceArgs = {
  _set?: Maybe<User_Presence_Set_Input>;
  where: User_Presence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Presence_By_PkArgs = {
  _set?: Maybe<User_Presence_Set_Input>;
  pk_columns: User_Presence_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_RoleArgs = {
  _set?: Maybe<User_Role_Set_Input>;
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Role_By_PkArgs = {
  _set?: Maybe<User_Role_Set_Input>;
  pk_columns: User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Video_SessionArgs = {
  _set?: Maybe<Video_Session_Set_Input>;
  where: Video_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Session_By_PkArgs = {
  _set?: Maybe<Video_Session_Set_Input>;
  pk_columns: Video_Session_Pk_Columns_Input;
};

/** columns and relationships of "nabu.companies" */
export type Nabu_Companies = {
  __typename?: 'nabu_companies';
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  programs: Array<Nabu_Programs>;
  /** An aggregate relationship */
  programs_aggregate: Nabu_Programs_Aggregate;
  /** An array relationship */
  sessions: Array<Nabu_Sessions>;
  /** An aggregate relationship */
  sessions_aggregate: Nabu_Sessions_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "nabu.companies" */
export type Nabu_CompaniesProgramsArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


/** columns and relationships of "nabu.companies" */
export type Nabu_CompaniesPrograms_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


/** columns and relationships of "nabu.companies" */
export type Nabu_CompaniesSessionsArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};


/** columns and relationships of "nabu.companies" */
export type Nabu_CompaniesSessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};

/** aggregated selection of "nabu.companies" */
export type Nabu_Companies_Aggregate = {
  __typename?: 'nabu_companies_aggregate';
  aggregate?: Maybe<Nabu_Companies_Aggregate_Fields>;
  nodes: Array<Nabu_Companies>;
};

/** aggregate fields of "nabu.companies" */
export type Nabu_Companies_Aggregate_Fields = {
  __typename?: 'nabu_companies_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Companies_Max_Fields>;
  min?: Maybe<Nabu_Companies_Min_Fields>;
};


/** aggregate fields of "nabu.companies" */
export type Nabu_Companies_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Companies_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nabu.companies". All fields are combined with a logical 'AND'. */
export type Nabu_Companies_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Companies_Bool_Exp>>;
  _not?: Maybe<Nabu_Companies_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Companies_Bool_Exp>>;
  address_id?: Maybe<Uuid_Comparison_Exp>;
  company_contact_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  programs?: Maybe<Nabu_Programs_Bool_Exp>;
  sessions?: Maybe<Nabu_Sessions_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "nabu.companies" */
export type Nabu_Companies_Insert_Input = {
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  programs?: Maybe<Nabu_Programs_Arr_Rel_Insert_Input>;
  sessions?: Maybe<Nabu_Sessions_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Companies_Max_Fields = {
  __typename?: 'nabu_companies_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabu_Companies_Min_Fields = {
  __typename?: 'nabu_companies_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabu.companies" */
export type Nabu_Companies_Mutation_Response = {
  __typename?: 'nabu_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Companies>;
};

/** input type for inserting object relation for remote table "nabu.companies" */
export type Nabu_Companies_Obj_Rel_Insert_Input = {
  data: Nabu_Companies_Insert_Input;
};

/** Ordering options when selecting data from "nabu.companies". */
export type Nabu_Companies_Order_By = {
  address_id?: Maybe<Order_By>;
  company_contact_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  programs_aggregate?: Maybe<Nabu_Programs_Aggregate_Order_By>;
  sessions_aggregate?: Maybe<Nabu_Sessions_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "nabu.companies" */
export enum Nabu_Companies_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CompanyContactId = 'company_contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.companies" */
export type Nabu_Companies_Set_Input = {
  address_id?: Maybe<Scalars['uuid']>;
  company_contact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "nabu.feedback" */
export type Nabu_Feedback = {
  __typename?: 'nabu_feedback';
  created_at: Scalars['timestamptz'];
  feedback: Nabu_Feedback_Type_Enum;
  id: Scalars['uuid'];
  /** An object relationship */
  turn: Nabu_Turns;
  turn_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "nabu.feedback" */
export type Nabu_Feedback_Aggregate = {
  __typename?: 'nabu_feedback_aggregate';
  aggregate?: Maybe<Nabu_Feedback_Aggregate_Fields>;
  nodes: Array<Nabu_Feedback>;
};

/** aggregate fields of "nabu.feedback" */
export type Nabu_Feedback_Aggregate_Fields = {
  __typename?: 'nabu_feedback_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Feedback_Max_Fields>;
  min?: Maybe<Nabu_Feedback_Min_Fields>;
};


/** aggregate fields of "nabu.feedback" */
export type Nabu_Feedback_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.feedback" */
export type Nabu_Feedback_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Feedback_Max_Order_By>;
  min?: Maybe<Nabu_Feedback_Min_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.feedback" */
export type Nabu_Feedback_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Feedback_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Feedback_On_Conflict>;
};

/** Boolean expression to filter rows from the table "nabu.feedback". All fields are combined with a logical 'AND'. */
export type Nabu_Feedback_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Feedback_Bool_Exp>>;
  _not?: Maybe<Nabu_Feedback_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Feedback_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  feedback?: Maybe<Nabu_Feedback_Type_Enum_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  turn?: Maybe<Nabu_Turns_Bool_Exp>;
  turn_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabu.feedback" */
export enum Nabu_Feedback_Constraint {
  /** unique or primary key constraint */
  FeedbacksPkey = 'feedbacks_pkey'
}

/** input type for inserting data into table "nabu.feedback" */
export type Nabu_Feedback_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Nabu_Feedback_Type_Enum>;
  id?: Maybe<Scalars['uuid']>;
  turn?: Maybe<Nabu_Turns_Obj_Rel_Insert_Input>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Nabu_Feedback_Max_Fields = {
  __typename?: 'nabu_feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "nabu.feedback" */
export type Nabu_Feedback_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Feedback_Min_Fields = {
  __typename?: 'nabu_feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "nabu.feedback" */
export type Nabu_Feedback_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.feedback" */
export type Nabu_Feedback_Mutation_Response = {
  __typename?: 'nabu_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Feedback>;
};

/** on conflict condition type for table "nabu.feedback" */
export type Nabu_Feedback_On_Conflict = {
  constraint: Nabu_Feedback_Constraint;
  update_columns?: Array<Nabu_Feedback_Update_Column>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.feedback". */
export type Nabu_Feedback_Order_By = {
  created_at?: Maybe<Order_By>;
  feedback?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  turn?: Maybe<Nabu_Turns_Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: nabu_feedback */
export type Nabu_Feedback_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nabu.feedback" */
export enum Nabu_Feedback_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "nabu.feedback" */
export type Nabu_Feedback_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Nabu_Feedback_Type_Enum>;
  id?: Maybe<Scalars['uuid']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/**
 * Enumeration for the different type of feedback that is given to the user.
 *
 *
 * columns and relationships of "nabu.feedback_type"
 *
 */
export type Nabu_Feedback_Type = {
  __typename?: 'nabu_feedback_type';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "nabu.feedback_type" */
export type Nabu_Feedback_Type_Aggregate = {
  __typename?: 'nabu_feedback_type_aggregate';
  aggregate?: Maybe<Nabu_Feedback_Type_Aggregate_Fields>;
  nodes: Array<Nabu_Feedback_Type>;
};

/** aggregate fields of "nabu.feedback_type" */
export type Nabu_Feedback_Type_Aggregate_Fields = {
  __typename?: 'nabu_feedback_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Feedback_Type_Max_Fields>;
  min?: Maybe<Nabu_Feedback_Type_Min_Fields>;
};


/** aggregate fields of "nabu.feedback_type" */
export type Nabu_Feedback_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Feedback_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nabu.feedback_type". All fields are combined with a logical 'AND'. */
export type Nabu_Feedback_Type_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Feedback_Type_Bool_Exp>>;
  _not?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Feedback_Type_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabu.feedback_type" */
export enum Nabu_Feedback_Type_Constraint {
  /** unique or primary key constraint */
  FeedbackTypePkey = 'feedback_type_pkey'
}

export enum Nabu_Feedback_Type_Enum {
  /** Shows agreement with a current comment being said. */
  Agreed = 'AGREED',
  /** Shows empathy towards a comment that was said */
  FeelYa = 'FEEL_YA',
  /** Denotes a quick laugh at a certain comment */
  Haha = 'HAHA',
  /** Denotes doubt towards a comment that was made */
  Huh = 'HUH'
}

/** Boolean expression to compare columns of type "nabu_feedback_type_enum". All fields are combined with logical 'AND'. */
export type Nabu_Feedback_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Nabu_Feedback_Type_Enum>;
  _in?: Maybe<Array<Nabu_Feedback_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Nabu_Feedback_Type_Enum>;
  _nin?: Maybe<Array<Nabu_Feedback_Type_Enum>>;
};

/** input type for inserting data into table "nabu.feedback_type" */
export type Nabu_Feedback_Type_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nabu_Feedback_Type_Max_Fields = {
  __typename?: 'nabu_feedback_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Nabu_Feedback_Type_Min_Fields = {
  __typename?: 'nabu_feedback_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nabu.feedback_type" */
export type Nabu_Feedback_Type_Mutation_Response = {
  __typename?: 'nabu_feedback_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Feedback_Type>;
};

/** on conflict condition type for table "nabu.feedback_type" */
export type Nabu_Feedback_Type_On_Conflict = {
  constraint: Nabu_Feedback_Type_Constraint;
  update_columns?: Array<Nabu_Feedback_Type_Update_Column>;
  where?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.feedback_type". */
export type Nabu_Feedback_Type_Order_By = {
  comment?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: nabu_feedback_type */
export type Nabu_Feedback_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "nabu.feedback_type" */
export enum Nabu_Feedback_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "nabu.feedback_type" */
export type Nabu_Feedback_Type_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "nabu.feedback_type" */
export enum Nabu_Feedback_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "nabu.feedback" */
export enum Nabu_Feedback_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs = {
  __typename?: 'nabu_prevalence_score_classification_runs';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  owner: Scalars['String'];
  program_id: Scalars['uuid'];
  status: Scalars['String'];
  storage_path: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Aggregate = {
  __typename?: 'nabu_prevalence_score_classification_runs_aggregate';
  aggregate?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Aggregate_Fields>;
  nodes: Array<Nabu_Prevalence_Score_Classification_Runs>;
};

/** aggregate fields of "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Aggregate_Fields = {
  __typename?: 'nabu_prevalence_score_classification_runs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Max_Fields>;
  min?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Min_Fields>;
};


/** aggregate fields of "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nabu.prevalence_score_classification_runs". All fields are combined with a logical 'AND'. */
export type Nabu_Prevalence_Score_Classification_Runs_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>>;
  _not?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  owner?: Maybe<String_Comparison_Exp>;
  program_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  storage_path?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabu.prevalence_score_classification_runs" */
export enum Nabu_Prevalence_Score_Classification_Runs_Constraint {
  /** unique or primary key constraint */
  PrevalenceScoreClassificationRunsPkey = 'prevalence_score_classification_runs_pkey'
}

/** input type for inserting data into table "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  storage_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Prevalence_Score_Classification_Runs_Max_Fields = {
  __typename?: 'nabu_prevalence_score_classification_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  storage_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabu_Prevalence_Score_Classification_Runs_Min_Fields = {
  __typename?: 'nabu_prevalence_score_classification_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  storage_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Mutation_Response = {
  __typename?: 'nabu_prevalence_score_classification_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Prevalence_Score_Classification_Runs>;
};

/** on conflict condition type for table "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_On_Conflict = {
  constraint: Nabu_Prevalence_Score_Classification_Runs_Constraint;
  update_columns?: Array<Nabu_Prevalence_Score_Classification_Runs_Update_Column>;
  where?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.prevalence_score_classification_runs". */
export type Nabu_Prevalence_Score_Classification_Runs_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  owner?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  storage_path?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: nabu_prevalence_score_classification_runs */
export type Nabu_Prevalence_Score_Classification_Runs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nabu.prevalence_score_classification_runs" */
export enum Nabu_Prevalence_Score_Classification_Runs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  Status = 'status',
  /** column name */
  StoragePath = 'storage_path',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.prevalence_score_classification_runs" */
export type Nabu_Prevalence_Score_Classification_Runs_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  storage_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "nabu.prevalence_score_classification_runs" */
export enum Nabu_Prevalence_Score_Classification_Runs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  Status = 'status',
  /** column name */
  StoragePath = 'storage_path',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "nabu.programs" */
export type Nabu_Programs = {
  __typename?: 'nabu_programs';
  /** An object relationship */
  company?: Maybe<Nabu_Companies>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "nabu.programs" */
export type Nabu_Programs_Aggregate = {
  __typename?: 'nabu_programs_aggregate';
  aggregate?: Maybe<Nabu_Programs_Aggregate_Fields>;
  nodes: Array<Nabu_Programs>;
};

/** aggregate fields of "nabu.programs" */
export type Nabu_Programs_Aggregate_Fields = {
  __typename?: 'nabu_programs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Programs_Max_Fields>;
  min?: Maybe<Nabu_Programs_Min_Fields>;
};


/** aggregate fields of "nabu.programs" */
export type Nabu_Programs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Programs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.programs" */
export type Nabu_Programs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Programs_Max_Order_By>;
  min?: Maybe<Nabu_Programs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.programs" */
export type Nabu_Programs_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Programs_Insert_Input>;
};

/** Boolean expression to filter rows from the table "nabu.programs". All fields are combined with a logical 'AND'. */
export type Nabu_Programs_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Programs_Bool_Exp>>;
  _not?: Maybe<Nabu_Programs_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Programs_Bool_Exp>>;
  company?: Maybe<Nabu_Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "nabu.programs" */
export type Nabu_Programs_Insert_Input = {
  company?: Maybe<Nabu_Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Programs_Max_Fields = {
  __typename?: 'nabu_programs_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.programs" */
export type Nabu_Programs_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Programs_Min_Fields = {
  __typename?: 'nabu_programs_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.programs" */
export type Nabu_Programs_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.programs" */
export type Nabu_Programs_Mutation_Response = {
  __typename?: 'nabu_programs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Programs>;
};

/** input type for inserting object relation for remote table "nabu.programs" */
export type Nabu_Programs_Obj_Rel_Insert_Input = {
  data: Nabu_Programs_Insert_Input;
};

/** Ordering options when selecting data from "nabu.programs". */
export type Nabu_Programs_Order_By = {
  company?: Maybe<Nabu_Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "nabu.programs" */
export enum Nabu_Programs_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.programs" */
export type Nabu_Programs_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "nabu.prompts" */
export type Nabu_Prompts = {
  __typename?: 'nabu_prompts';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  segment?: Maybe<Nabu_Segments>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "nabu.prompts" */
export type Nabu_Prompts_Aggregate = {
  __typename?: 'nabu_prompts_aggregate';
  aggregate?: Maybe<Nabu_Prompts_Aggregate_Fields>;
  nodes: Array<Nabu_Prompts>;
};

/** aggregate fields of "nabu.prompts" */
export type Nabu_Prompts_Aggregate_Fields = {
  __typename?: 'nabu_prompts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Prompts_Max_Fields>;
  min?: Maybe<Nabu_Prompts_Min_Fields>;
};


/** aggregate fields of "nabu.prompts" */
export type Nabu_Prompts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.prompts" */
export type Nabu_Prompts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Prompts_Max_Order_By>;
  min?: Maybe<Nabu_Prompts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.prompts" */
export type Nabu_Prompts_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Prompts_Insert_Input>;
};

/** Boolean expression to filter rows from the table "nabu.prompts". All fields are combined with a logical 'AND'. */
export type Nabu_Prompts_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Prompts_Bool_Exp>>;
  _not?: Maybe<Nabu_Prompts_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Prompts_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  segment?: Maybe<Nabu_Segments_Bool_Exp>;
  segment_id?: Maybe<Uuid_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "nabu.prompts" */
export type Nabu_Prompts_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment?: Maybe<Nabu_Segments_Obj_Rel_Insert_Input>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Prompts_Max_Fields = {
  __typename?: 'nabu_prompts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.prompts" */
export type Nabu_Prompts_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Prompts_Min_Fields = {
  __typename?: 'nabu_prompts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.prompts" */
export type Nabu_Prompts_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.prompts" */
export type Nabu_Prompts_Mutation_Response = {
  __typename?: 'nabu_prompts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Prompts>;
};

/** Ordering options when selecting data from "nabu.prompts". */
export type Nabu_Prompts_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment?: Maybe<Nabu_Segments_Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "nabu.prompts" */
export enum Nabu_Prompts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.prompts" */
export type Nabu_Prompts_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "nabu.quotes" */
export type Nabu_Quotes = {
  __typename?: 'nabu_quotes';
  audio_end_time: Scalars['float8'];
  audio_start_time: Scalars['float8'];
  created_at: Scalars['timestamptz'];
  end_idx: Scalars['Int'];
  id: Scalars['uuid'];
  start_idx: Scalars['Int'];
  /** An object relationship */
  turn: Nabu_Turns;
  turn_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  voxes: Array<Nabu_Voxes>;
  /** An aggregate relationship */
  voxes_aggregate: Nabu_Voxes_Aggregate;
};


/** columns and relationships of "nabu.quotes" */
export type Nabu_QuotesVoxesArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};


/** columns and relationships of "nabu.quotes" */
export type Nabu_QuotesVoxes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};

/** aggregated selection of "nabu.quotes" */
export type Nabu_Quotes_Aggregate = {
  __typename?: 'nabu_quotes_aggregate';
  aggregate?: Maybe<Nabu_Quotes_Aggregate_Fields>;
  nodes: Array<Nabu_Quotes>;
};

/** aggregate fields of "nabu.quotes" */
export type Nabu_Quotes_Aggregate_Fields = {
  __typename?: 'nabu_quotes_aggregate_fields';
  avg?: Maybe<Nabu_Quotes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Quotes_Max_Fields>;
  min?: Maybe<Nabu_Quotes_Min_Fields>;
  stddev?: Maybe<Nabu_Quotes_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Quotes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Quotes_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Quotes_Sum_Fields>;
  var_pop?: Maybe<Nabu_Quotes_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Quotes_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Quotes_Variance_Fields>;
};


/** aggregate fields of "nabu.quotes" */
export type Nabu_Quotes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.quotes" */
export type Nabu_Quotes_Aggregate_Order_By = {
  avg?: Maybe<Nabu_Quotes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Quotes_Max_Order_By>;
  min?: Maybe<Nabu_Quotes_Min_Order_By>;
  stddev?: Maybe<Nabu_Quotes_Stddev_Order_By>;
  stddev_pop?: Maybe<Nabu_Quotes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Nabu_Quotes_Stddev_Samp_Order_By>;
  sum?: Maybe<Nabu_Quotes_Sum_Order_By>;
  var_pop?: Maybe<Nabu_Quotes_Var_Pop_Order_By>;
  var_samp?: Maybe<Nabu_Quotes_Var_Samp_Order_By>;
  variance?: Maybe<Nabu_Quotes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.quotes" */
export type Nabu_Quotes_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Quotes_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Quotes_On_Conflict>;
};

/** aggregate avg on columns */
export type Nabu_Quotes_Avg_Fields = {
  __typename?: 'nabu_quotes_avg_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Avg_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nabu.quotes". All fields are combined with a logical 'AND'. */
export type Nabu_Quotes_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Quotes_Bool_Exp>>;
  _not?: Maybe<Nabu_Quotes_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Quotes_Bool_Exp>>;
  audio_end_time?: Maybe<Float8_Comparison_Exp>;
  audio_start_time?: Maybe<Float8_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_idx?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  start_idx?: Maybe<Int_Comparison_Exp>;
  turn?: Maybe<Nabu_Turns_Bool_Exp>;
  turn_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  voxes?: Maybe<Nabu_Voxes_Bool_Exp>;
};

/** unique or primary key constraints on table "nabu.quotes" */
export enum Nabu_Quotes_Constraint {
  /** unique or primary key constraint */
  QuotesPkey = 'quotes_pkey'
}

/** input type for incrementing numeric columns in table "nabu.quotes" */
export type Nabu_Quotes_Inc_Input = {
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  end_idx?: Maybe<Scalars['Int']>;
  start_idx?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "nabu.quotes" */
export type Nabu_Quotes_Insert_Input = {
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_idx?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  start_idx?: Maybe<Scalars['Int']>;
  turn?: Maybe<Nabu_Turns_Obj_Rel_Insert_Input>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voxes?: Maybe<Nabu_Voxes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Nabu_Quotes_Max_Fields = {
  __typename?: 'nabu_quotes_max_fields';
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_idx?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  start_idx?: Maybe<Scalars['Int']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Max_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Quotes_Min_Fields = {
  __typename?: 'nabu_quotes_min_fields';
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_idx?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  start_idx?: Maybe<Scalars['Int']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Min_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.quotes" */
export type Nabu_Quotes_Mutation_Response = {
  __typename?: 'nabu_quotes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Quotes>;
};

/** input type for inserting object relation for remote table "nabu.quotes" */
export type Nabu_Quotes_Obj_Rel_Insert_Input = {
  data: Nabu_Quotes_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Quotes_On_Conflict>;
};

/** on conflict condition type for table "nabu.quotes" */
export type Nabu_Quotes_On_Conflict = {
  constraint: Nabu_Quotes_Constraint;
  update_columns?: Array<Nabu_Quotes_Update_Column>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.quotes". */
export type Nabu_Quotes_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
  turn?: Maybe<Nabu_Turns_Order_By>;
  turn_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  voxes_aggregate?: Maybe<Nabu_Voxes_Aggregate_Order_By>;
};

/** primary key columns input for table: nabu_quotes */
export type Nabu_Quotes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nabu.quotes" */
export enum Nabu_Quotes_Select_Column {
  /** column name */
  AudioEndTime = 'audio_end_time',
  /** column name */
  AudioStartTime = 'audio_start_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndIdx = 'end_idx',
  /** column name */
  Id = 'id',
  /** column name */
  StartIdx = 'start_idx',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.quotes" */
export type Nabu_Quotes_Set_Input = {
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_idx?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  start_idx?: Maybe<Scalars['Int']>;
  turn_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nabu_Quotes_Stddev_Fields = {
  __typename?: 'nabu_quotes_stddev_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Stddev_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Quotes_Stddev_Pop_Fields = {
  __typename?: 'nabu_quotes_stddev_pop_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Stddev_Pop_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Quotes_Stddev_Samp_Fields = {
  __typename?: 'nabu_quotes_stddev_samp_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Stddev_Samp_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Nabu_Quotes_Sum_Fields = {
  __typename?: 'nabu_quotes_sum_fields';
  audio_end_time?: Maybe<Scalars['float8']>;
  audio_start_time?: Maybe<Scalars['float8']>;
  end_idx?: Maybe<Scalars['Int']>;
  start_idx?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Sum_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** update columns of table "nabu.quotes" */
export enum Nabu_Quotes_Update_Column {
  /** column name */
  AudioEndTime = 'audio_end_time',
  /** column name */
  AudioStartTime = 'audio_start_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndIdx = 'end_idx',
  /** column name */
  Id = 'id',
  /** column name */
  StartIdx = 'start_idx',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Nabu_Quotes_Var_Pop_Fields = {
  __typename?: 'nabu_quotes_var_pop_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Var_Pop_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nabu_Quotes_Var_Samp_Fields = {
  __typename?: 'nabu_quotes_var_samp_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Var_Samp_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Nabu_Quotes_Variance_Fields = {
  __typename?: 'nabu_quotes_variance_fields';
  audio_end_time?: Maybe<Scalars['Float']>;
  audio_start_time?: Maybe<Scalars['Float']>;
  end_idx?: Maybe<Scalars['Float']>;
  start_idx?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nabu.quotes" */
export type Nabu_Quotes_Variance_Order_By = {
  audio_end_time?: Maybe<Order_By>;
  audio_start_time?: Maybe<Order_By>;
  end_idx?: Maybe<Order_By>;
  start_idx?: Maybe<Order_By>;
};

/** columns and relationships of "nabu.segments" */
export type Nabu_Segments = {
  __typename?: 'nabu_segments';
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  prompts: Array<Nabu_Prompts>;
  /** An aggregate relationship */
  prompts_aggregate: Nabu_Prompts_Aggregate;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  session?: Maybe<Nabu_Sessions>;
  session_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  turns: Array<Nabu_Turns>;
  /** An aggregate relationship */
  turns_aggregate: Nabu_Turns_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "nabu.segments" */
export type Nabu_SegmentsPreferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "nabu.segments" */
export type Nabu_SegmentsPromptsArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


/** columns and relationships of "nabu.segments" */
export type Nabu_SegmentsPrompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


/** columns and relationships of "nabu.segments" */
export type Nabu_SegmentsTurnsArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


/** columns and relationships of "nabu.segments" */
export type Nabu_SegmentsTurns_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};

/** aggregated selection of "nabu.segments" */
export type Nabu_Segments_Aggregate = {
  __typename?: 'nabu_segments_aggregate';
  aggregate?: Maybe<Nabu_Segments_Aggregate_Fields>;
  nodes: Array<Nabu_Segments>;
};

/** aggregate fields of "nabu.segments" */
export type Nabu_Segments_Aggregate_Fields = {
  __typename?: 'nabu_segments_aggregate_fields';
  avg?: Maybe<Nabu_Segments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Segments_Max_Fields>;
  min?: Maybe<Nabu_Segments_Min_Fields>;
  stddev?: Maybe<Nabu_Segments_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Segments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Segments_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Segments_Sum_Fields>;
  var_pop?: Maybe<Nabu_Segments_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Segments_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Segments_Variance_Fields>;
};


/** aggregate fields of "nabu.segments" */
export type Nabu_Segments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Segments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.segments" */
export type Nabu_Segments_Aggregate_Order_By = {
  avg?: Maybe<Nabu_Segments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Segments_Max_Order_By>;
  min?: Maybe<Nabu_Segments_Min_Order_By>;
  stddev?: Maybe<Nabu_Segments_Stddev_Order_By>;
  stddev_pop?: Maybe<Nabu_Segments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Nabu_Segments_Stddev_Samp_Order_By>;
  sum?: Maybe<Nabu_Segments_Sum_Order_By>;
  var_pop?: Maybe<Nabu_Segments_Var_Pop_Order_By>;
  var_samp?: Maybe<Nabu_Segments_Var_Samp_Order_By>;
  variance?: Maybe<Nabu_Segments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Segments_Append_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "nabu.segments" */
export type Nabu_Segments_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Segments_Insert_Input>;
};

/** aggregate avg on columns */
export type Nabu_Segments_Avg_Fields = {
  __typename?: 'nabu_segments_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nabu.segments" */
export type Nabu_Segments_Avg_Order_By = {
  order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nabu.segments". All fields are combined with a logical 'AND'. */
export type Nabu_Segments_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Segments_Bool_Exp>>;
  _not?: Maybe<Nabu_Segments_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Segments_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  media_id?: Maybe<Uuid_Comparison_Exp>;
  order?: Maybe<Int_Comparison_Exp>;
  preferences?: Maybe<Jsonb_Comparison_Exp>;
  prompts?: Maybe<Nabu_Prompts_Bool_Exp>;
  segment_name?: Maybe<String_Comparison_Exp>;
  segment_type?: Maybe<String_Comparison_Exp>;
  session?: Maybe<Nabu_Sessions_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  start?: Maybe<Timestamptz_Comparison_Exp>;
  turns?: Maybe<Nabu_Turns_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Nabu_Segments_Delete_At_Path_Input = {
  preferences?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Nabu_Segments_Delete_Elem_Input = {
  preferences?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Nabu_Segments_Delete_Key_Input = {
  preferences?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "nabu.segments" */
export type Nabu_Segments_Inc_Input = {
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "nabu.segments" */
export type Nabu_Segments_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  prompts?: Maybe<Nabu_Prompts_Arr_Rel_Insert_Input>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session?: Maybe<Nabu_Sessions_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  turns?: Maybe<Nabu_Turns_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Segments_Max_Fields = {
  __typename?: 'nabu_segments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.segments" */
export type Nabu_Segments_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Segments_Min_Fields = {
  __typename?: 'nabu_segments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.segments" */
export type Nabu_Segments_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.segments" */
export type Nabu_Segments_Mutation_Response = {
  __typename?: 'nabu_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Segments>;
};

/** input type for inserting object relation for remote table "nabu.segments" */
export type Nabu_Segments_Obj_Rel_Insert_Input = {
  data: Nabu_Segments_Insert_Input;
};

/** Ordering options when selecting data from "nabu.segments". */
export type Nabu_Segments_Order_By = {
  created_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  preferences?: Maybe<Order_By>;
  prompts_aggregate?: Maybe<Nabu_Prompts_Aggregate_Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session?: Maybe<Nabu_Sessions_Order_By>;
  session_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  turns_aggregate?: Maybe<Nabu_Turns_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Segments_Prepend_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "nabu.segments" */
export enum Nabu_Segments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  Order = 'order',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  SegmentName = 'segment_name',
  /** column name */
  SegmentType = 'segment_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.segments" */
export type Nabu_Segments_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nabu_Segments_Stddev_Fields = {
  __typename?: 'nabu_segments_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nabu.segments" */
export type Nabu_Segments_Stddev_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Segments_Stddev_Pop_Fields = {
  __typename?: 'nabu_segments_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nabu.segments" */
export type Nabu_Segments_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Segments_Stddev_Samp_Fields = {
  __typename?: 'nabu_segments_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nabu.segments" */
export type Nabu_Segments_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Nabu_Segments_Sum_Fields = {
  __typename?: 'nabu_segments_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nabu.segments" */
export type Nabu_Segments_Sum_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Nabu_Segments_Var_Pop_Fields = {
  __typename?: 'nabu_segments_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nabu.segments" */
export type Nabu_Segments_Var_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nabu_Segments_Var_Samp_Fields = {
  __typename?: 'nabu_segments_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nabu.segments" */
export type Nabu_Segments_Var_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Nabu_Segments_Variance_Fields = {
  __typename?: 'nabu_segments_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nabu.segments" */
export type Nabu_Segments_Variance_Order_By = {
  order?: Maybe<Order_By>;
};

/** columns and relationships of "nabu.sessions" */
export type Nabu_Sessions = {
  __typename?: 'nabu_sessions';
  /** An object relationship */
  company?: Maybe<Nabu_Companies>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_template?: Maybe<Scalars['Boolean']>;
  is_test?: Maybe<Scalars['Boolean']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  program?: Maybe<Nabu_Programs>;
  program_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  segments: Array<Nabu_Segments>;
  /** An aggregate relationship */
  segments_aggregate: Nabu_Segments_Aggregate;
  session_name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "nabu.sessions" */
export type Nabu_SessionsPreferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "nabu.sessions" */
export type Nabu_SessionsSegmentsArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};


/** columns and relationships of "nabu.sessions" */
export type Nabu_SessionsSegments_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};

/** aggregated selection of "nabu.sessions" */
export type Nabu_Sessions_Aggregate = {
  __typename?: 'nabu_sessions_aggregate';
  aggregate?: Maybe<Nabu_Sessions_Aggregate_Fields>;
  nodes: Array<Nabu_Sessions>;
};

/** aggregate fields of "nabu.sessions" */
export type Nabu_Sessions_Aggregate_Fields = {
  __typename?: 'nabu_sessions_aggregate_fields';
  avg?: Maybe<Nabu_Sessions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Sessions_Max_Fields>;
  min?: Maybe<Nabu_Sessions_Min_Fields>;
  stddev?: Maybe<Nabu_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Sessions_Sum_Fields>;
  var_pop?: Maybe<Nabu_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Sessions_Variance_Fields>;
};


/** aggregate fields of "nabu.sessions" */
export type Nabu_Sessions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.sessions" */
export type Nabu_Sessions_Aggregate_Order_By = {
  avg?: Maybe<Nabu_Sessions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Sessions_Max_Order_By>;
  min?: Maybe<Nabu_Sessions_Min_Order_By>;
  stddev?: Maybe<Nabu_Sessions_Stddev_Order_By>;
  stddev_pop?: Maybe<Nabu_Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Nabu_Sessions_Stddev_Samp_Order_By>;
  sum?: Maybe<Nabu_Sessions_Sum_Order_By>;
  var_pop?: Maybe<Nabu_Sessions_Var_Pop_Order_By>;
  var_samp?: Maybe<Nabu_Sessions_Var_Samp_Order_By>;
  variance?: Maybe<Nabu_Sessions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Sessions_Append_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "nabu.sessions" */
export type Nabu_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Sessions_Insert_Input>;
};

/** aggregate avg on columns */
export type Nabu_Sessions_Avg_Fields = {
  __typename?: 'nabu_sessions_avg_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Avg_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nabu.sessions". All fields are combined with a logical 'AND'. */
export type Nabu_Sessions_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Sessions_Bool_Exp>>;
  _not?: Maybe<Nabu_Sessions_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Sessions_Bool_Exp>>;
  company?: Maybe<Nabu_Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  date_time?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  end?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_template?: Maybe<Boolean_Comparison_Exp>;
  is_test?: Maybe<Boolean_Comparison_Exp>;
  max_participant_limit?: Maybe<Int_Comparison_Exp>;
  preferences?: Maybe<Jsonb_Comparison_Exp>;
  program?: Maybe<Nabu_Programs_Bool_Exp>;
  program_id?: Maybe<Uuid_Comparison_Exp>;
  segments?: Maybe<Nabu_Segments_Bool_Exp>;
  session_name?: Maybe<String_Comparison_Exp>;
  start?: Maybe<Timestamptz_Comparison_Exp>;
  template_id?: Maybe<Uuid_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Nabu_Sessions_Delete_At_Path_Input = {
  preferences?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Nabu_Sessions_Delete_Elem_Input = {
  preferences?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Nabu_Sessions_Delete_Key_Input = {
  preferences?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "nabu.sessions" */
export type Nabu_Sessions_Inc_Input = {
  max_participant_limit?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "nabu.sessions" */
export type Nabu_Sessions_Insert_Input = {
  company?: Maybe<Nabu_Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_template?: Maybe<Scalars['Boolean']>;
  is_test?: Maybe<Scalars['Boolean']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  program?: Maybe<Nabu_Programs_Obj_Rel_Insert_Input>;
  program_id?: Maybe<Scalars['uuid']>;
  segments?: Maybe<Nabu_Segments_Arr_Rel_Insert_Input>;
  session_name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Sessions_Max_Fields = {
  __typename?: 'nabu_sessions_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Sessions_Min_Fields = {
  __typename?: 'nabu_sessions_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.sessions" */
export type Nabu_Sessions_Mutation_Response = {
  __typename?: 'nabu_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Sessions>;
};

/** input type for inserting object relation for remote table "nabu.sessions" */
export type Nabu_Sessions_Obj_Rel_Insert_Input = {
  data: Nabu_Sessions_Insert_Input;
};

/** Ordering options when selecting data from "nabu.sessions". */
export type Nabu_Sessions_Order_By = {
  company?: Maybe<Nabu_Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_template?: Maybe<Order_By>;
  is_test?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  preferences?: Maybe<Order_By>;
  program?: Maybe<Nabu_Programs_Order_By>;
  program_id?: Maybe<Order_By>;
  segments_aggregate?: Maybe<Nabu_Segments_Aggregate_Order_By>;
  session_name?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Sessions_Prepend_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "nabu.sessions" */
export enum Nabu_Sessions_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  MaxParticipantLimit = 'max_participant_limit',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  SessionName = 'session_name',
  /** column name */
  Start = 'start',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.sessions" */
export type Nabu_Sessions_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_template?: Maybe<Scalars['Boolean']>;
  is_test?: Maybe<Scalars['Boolean']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nabu_Sessions_Stddev_Fields = {
  __typename?: 'nabu_sessions_stddev_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Stddev_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Sessions_Stddev_Pop_Fields = {
  __typename?: 'nabu_sessions_stddev_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Stddev_Pop_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Sessions_Stddev_Samp_Fields = {
  __typename?: 'nabu_sessions_stddev_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Stddev_Samp_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Nabu_Sessions_Sum_Fields = {
  __typename?: 'nabu_sessions_sum_fields';
  max_participant_limit?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Sum_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Nabu_Sessions_Var_Pop_Fields = {
  __typename?: 'nabu_sessions_var_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Var_Pop_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nabu_Sessions_Var_Samp_Fields = {
  __typename?: 'nabu_sessions_var_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Var_Samp_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Nabu_Sessions_Variance_Fields = {
  __typename?: 'nabu_sessions_variance_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nabu.sessions" */
export type Nabu_Sessions_Variance_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** columns and relationships of "nabu.survey_questions" */
export type Nabu_Survey_Questions = {
  __typename?: 'nabu_survey_questions';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "nabu.survey_questions" */
export type Nabu_Survey_Questions_Aggregate = {
  __typename?: 'nabu_survey_questions_aggregate';
  aggregate?: Maybe<Nabu_Survey_Questions_Aggregate_Fields>;
  nodes: Array<Nabu_Survey_Questions>;
};

/** aggregate fields of "nabu.survey_questions" */
export type Nabu_Survey_Questions_Aggregate_Fields = {
  __typename?: 'nabu_survey_questions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Survey_Questions_Max_Fields>;
  min?: Maybe<Nabu_Survey_Questions_Min_Fields>;
};


/** aggregate fields of "nabu.survey_questions" */
export type Nabu_Survey_Questions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Survey_Questions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nabu.survey_questions". All fields are combined with a logical 'AND'. */
export type Nabu_Survey_Questions_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Survey_Questions_Bool_Exp>>;
  _not?: Maybe<Nabu_Survey_Questions_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Survey_Questions_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  question?: Maybe<String_Comparison_Exp>;
  survey_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "nabu.survey_questions" */
export type Nabu_Survey_Questions_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Survey_Questions_Max_Fields = {
  __typename?: 'nabu_survey_questions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabu_Survey_Questions_Min_Fields = {
  __typename?: 'nabu_survey_questions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabu.survey_questions" */
export type Nabu_Survey_Questions_Mutation_Response = {
  __typename?: 'nabu_survey_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Survey_Questions>;
};

/** Ordering options when selecting data from "nabu.survey_questions". */
export type Nabu_Survey_Questions_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  question?: Maybe<Order_By>;
  survey_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "nabu.survey_questions" */
export enum Nabu_Survey_Questions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.survey_questions" */
export type Nabu_Survey_Questions_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "nabu.surveys" */
export type Nabu_Surveys = {
  __typename?: 'nabu_surveys';
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "nabu.surveys" */
export type Nabu_Surveys_Aggregate = {
  __typename?: 'nabu_surveys_aggregate';
  aggregate?: Maybe<Nabu_Surveys_Aggregate_Fields>;
  nodes: Array<Nabu_Surveys>;
};

/** aggregate fields of "nabu.surveys" */
export type Nabu_Surveys_Aggregate_Fields = {
  __typename?: 'nabu_surveys_aggregate_fields';
  avg?: Maybe<Nabu_Surveys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Surveys_Max_Fields>;
  min?: Maybe<Nabu_Surveys_Min_Fields>;
  stddev?: Maybe<Nabu_Surveys_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Surveys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Surveys_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Surveys_Sum_Fields>;
  var_pop?: Maybe<Nabu_Surveys_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Surveys_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Surveys_Variance_Fields>;
};


/** aggregate fields of "nabu.surveys" */
export type Nabu_Surveys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Surveys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Nabu_Surveys_Avg_Fields = {
  __typename?: 'nabu_surveys_avg_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nabu.surveys". All fields are combined with a logical 'AND'. */
export type Nabu_Surveys_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Surveys_Bool_Exp>>;
  _not?: Maybe<Nabu_Surveys_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Surveys_Bool_Exp>>;
  batch?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "nabu.surveys" */
export type Nabu_Surveys_Inc_Input = {
  batch?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "nabu.surveys" */
export type Nabu_Surveys_Insert_Input = {
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Surveys_Max_Fields = {
  __typename?: 'nabu_surveys_max_fields';
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabu_Surveys_Min_Fields = {
  __typename?: 'nabu_surveys_min_fields';
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabu.surveys" */
export type Nabu_Surveys_Mutation_Response = {
  __typename?: 'nabu_surveys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Surveys>;
};

/** Ordering options when selecting data from "nabu.surveys". */
export type Nabu_Surveys_Order_By = {
  batch?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "nabu.surveys" */
export enum Nabu_Surveys_Select_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.surveys" */
export type Nabu_Surveys_Set_Input = {
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nabu_Surveys_Stddev_Fields = {
  __typename?: 'nabu_surveys_stddev_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Surveys_Stddev_Pop_Fields = {
  __typename?: 'nabu_surveys_stddev_pop_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Surveys_Stddev_Samp_Fields = {
  __typename?: 'nabu_surveys_stddev_samp_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Nabu_Surveys_Sum_Fields = {
  __typename?: 'nabu_surveys_sum_fields';
  batch?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Nabu_Surveys_Var_Pop_Fields = {
  __typename?: 'nabu_surveys_var_pop_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Nabu_Surveys_Var_Samp_Fields = {
  __typename?: 'nabu_surveys_var_samp_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Nabu_Surveys_Variance_Fields = {
  __typename?: 'nabu_surveys_variance_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "nabu.turns" */
export type Nabu_Turns = {
  __typename?: 'nabu_turns';
  audio?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  designated_at: Scalars['timestamptz'];
  end: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  quotes: Array<Nabu_Quotes>;
  /** An aggregate relationship */
  quotes_aggregate: Nabu_Quotes_Aggregate;
  secs_allocated: Scalars['float8'];
  /** An object relationship */
  segment?: Maybe<Nabu_Segments>;
  segment_id: Scalars['uuid'];
  start: Scalars['timestamptz'];
  text?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Nabu_Users>;
  /** An array relationship */
  user_feedback: Array<Nabu_Feedback>;
  /** An aggregate relationship */
  user_feedback_aggregate: Nabu_Feedback_Aggregate;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "nabu.turns" */
export type Nabu_TurnsQuotesArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


/** columns and relationships of "nabu.turns" */
export type Nabu_TurnsQuotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


/** columns and relationships of "nabu.turns" */
export type Nabu_TurnsUser_FeedbackArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


/** columns and relationships of "nabu.turns" */
export type Nabu_TurnsUser_Feedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};

/** aggregated selection of "nabu.turns" */
export type Nabu_Turns_Aggregate = {
  __typename?: 'nabu_turns_aggregate';
  aggregate?: Maybe<Nabu_Turns_Aggregate_Fields>;
  nodes: Array<Nabu_Turns>;
};

/** aggregate fields of "nabu.turns" */
export type Nabu_Turns_Aggregate_Fields = {
  __typename?: 'nabu_turns_aggregate_fields';
  avg?: Maybe<Nabu_Turns_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Turns_Max_Fields>;
  min?: Maybe<Nabu_Turns_Min_Fields>;
  stddev?: Maybe<Nabu_Turns_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Turns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Turns_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Turns_Sum_Fields>;
  var_pop?: Maybe<Nabu_Turns_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Turns_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Turns_Variance_Fields>;
};


/** aggregate fields of "nabu.turns" */
export type Nabu_Turns_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Turns_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.turns" */
export type Nabu_Turns_Aggregate_Order_By = {
  avg?: Maybe<Nabu_Turns_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Turns_Max_Order_By>;
  min?: Maybe<Nabu_Turns_Min_Order_By>;
  stddev?: Maybe<Nabu_Turns_Stddev_Order_By>;
  stddev_pop?: Maybe<Nabu_Turns_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Nabu_Turns_Stddev_Samp_Order_By>;
  sum?: Maybe<Nabu_Turns_Sum_Order_By>;
  var_pop?: Maybe<Nabu_Turns_Var_Pop_Order_By>;
  var_samp?: Maybe<Nabu_Turns_Var_Samp_Order_By>;
  variance?: Maybe<Nabu_Turns_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.turns" */
export type Nabu_Turns_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Turns_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Turns_On_Conflict>;
};

/** aggregate avg on columns */
export type Nabu_Turns_Avg_Fields = {
  __typename?: 'nabu_turns_avg_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nabu.turns" */
export type Nabu_Turns_Avg_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nabu.turns". All fields are combined with a logical 'AND'. */
export type Nabu_Turns_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Turns_Bool_Exp>>;
  _not?: Maybe<Nabu_Turns_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Turns_Bool_Exp>>;
  audio?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  designated_at?: Maybe<Timestamptz_Comparison_Exp>;
  end?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  quotes?: Maybe<Nabu_Quotes_Bool_Exp>;
  secs_allocated?: Maybe<Float8_Comparison_Exp>;
  segment?: Maybe<Nabu_Segments_Bool_Exp>;
  segment_id?: Maybe<Uuid_Comparison_Exp>;
  start?: Maybe<Timestamptz_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Nabu_Users_Bool_Exp>;
  user_feedback?: Maybe<Nabu_Feedback_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabu.turns" */
export enum Nabu_Turns_Constraint {
  /** unique or primary key constraint */
  TurnsPkey = 'turns_pkey'
}

/** input type for incrementing numeric columns in table "nabu.turns" */
export type Nabu_Turns_Inc_Input = {
  secs_allocated?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "nabu.turns" */
export type Nabu_Turns_Insert_Input = {
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  designated_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  quotes?: Maybe<Nabu_Quotes_Arr_Rel_Insert_Input>;
  secs_allocated?: Maybe<Scalars['float8']>;
  segment?: Maybe<Nabu_Segments_Obj_Rel_Insert_Input>;
  segment_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Nabu_Users_Obj_Rel_Insert_Input>;
  user_feedback?: Maybe<Nabu_Feedback_Arr_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Nabu_Turns_Max_Fields = {
  __typename?: 'nabu_turns_max_fields';
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  designated_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  secs_allocated?: Maybe<Scalars['float8']>;
  segment_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "nabu.turns" */
export type Nabu_Turns_Max_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  designated_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  secs_allocated?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Turns_Min_Fields = {
  __typename?: 'nabu_turns_min_fields';
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  designated_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  secs_allocated?: Maybe<Scalars['float8']>;
  segment_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "nabu.turns" */
export type Nabu_Turns_Min_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  designated_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  secs_allocated?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.turns" */
export type Nabu_Turns_Mutation_Response = {
  __typename?: 'nabu_turns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Turns>;
};

/** input type for inserting object relation for remote table "nabu.turns" */
export type Nabu_Turns_Obj_Rel_Insert_Input = {
  data: Nabu_Turns_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Turns_On_Conflict>;
};

/** on conflict condition type for table "nabu.turns" */
export type Nabu_Turns_On_Conflict = {
  constraint: Nabu_Turns_Constraint;
  update_columns?: Array<Nabu_Turns_Update_Column>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.turns". */
export type Nabu_Turns_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  designated_at?: Maybe<Order_By>;
  end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  quotes_aggregate?: Maybe<Nabu_Quotes_Aggregate_Order_By>;
  secs_allocated?: Maybe<Order_By>;
  segment?: Maybe<Nabu_Segments_Order_By>;
  segment_id?: Maybe<Order_By>;
  start?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Nabu_Users_Order_By>;
  user_feedback_aggregate?: Maybe<Nabu_Feedback_Aggregate_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: nabu_turns */
export type Nabu_Turns_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nabu.turns" */
export enum Nabu_Turns_Select_Column {
  /** column name */
  Audio = 'audio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DesignatedAt = 'designated_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SecsAllocated = 'secs_allocated',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  Start = 'start',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "nabu.turns" */
export type Nabu_Turns_Set_Input = {
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  designated_at?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  secs_allocated?: Maybe<Scalars['float8']>;
  segment_id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Nabu_Turns_Stddev_Fields = {
  __typename?: 'nabu_turns_stddev_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nabu.turns" */
export type Nabu_Turns_Stddev_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Turns_Stddev_Pop_Fields = {
  __typename?: 'nabu_turns_stddev_pop_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nabu.turns" */
export type Nabu_Turns_Stddev_Pop_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Turns_Stddev_Samp_Fields = {
  __typename?: 'nabu_turns_stddev_samp_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nabu.turns" */
export type Nabu_Turns_Stddev_Samp_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Nabu_Turns_Sum_Fields = {
  __typename?: 'nabu_turns_sum_fields';
  secs_allocated?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "nabu.turns" */
export type Nabu_Turns_Sum_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** update columns of table "nabu.turns" */
export enum Nabu_Turns_Update_Column {
  /** column name */
  Audio = 'audio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DesignatedAt = 'designated_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SecsAllocated = 'secs_allocated',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  Start = 'start',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Nabu_Turns_Var_Pop_Fields = {
  __typename?: 'nabu_turns_var_pop_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nabu.turns" */
export type Nabu_Turns_Var_Pop_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nabu_Turns_Var_Samp_Fields = {
  __typename?: 'nabu_turns_var_samp_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nabu.turns" */
export type Nabu_Turns_Var_Samp_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Nabu_Turns_Variance_Fields = {
  __typename?: 'nabu_turns_variance_fields';
  secs_allocated?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nabu.turns" */
export type Nabu_Turns_Variance_Order_By = {
  secs_allocated?: Maybe<Order_By>;
};

/** columns and relationships of "nabu.users" */
export type Nabu_Users = {
  __typename?: 'nabu_users';
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  feedback: Array<Nabu_Feedback>;
  /** An aggregate relationship */
  feedback_aggregate: Nabu_Feedback_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  /** An array relationship */
  turns: Array<Nabu_Turns>;
  /** An aggregate relationship */
  turns_aggregate: Nabu_Turns_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "nabu.users" */
export type Nabu_UsersFeedbackArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


/** columns and relationships of "nabu.users" */
export type Nabu_UsersFeedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


/** columns and relationships of "nabu.users" */
export type Nabu_UsersMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "nabu.users" */
export type Nabu_UsersTurnsArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


/** columns and relationships of "nabu.users" */
export type Nabu_UsersTurns_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};

/** aggregated selection of "nabu.users" */
export type Nabu_Users_Aggregate = {
  __typename?: 'nabu_users_aggregate';
  aggregate?: Maybe<Nabu_Users_Aggregate_Fields>;
  nodes: Array<Nabu_Users>;
};

/** aggregate fields of "nabu.users" */
export type Nabu_Users_Aggregate_Fields = {
  __typename?: 'nabu_users_aggregate_fields';
  avg?: Maybe<Nabu_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nabu_Users_Max_Fields>;
  min?: Maybe<Nabu_Users_Min_Fields>;
  stddev?: Maybe<Nabu_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Nabu_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nabu_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Nabu_Users_Sum_Fields>;
  var_pop?: Maybe<Nabu_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Nabu_Users_Var_Samp_Fields>;
  variance?: Maybe<Nabu_Users_Variance_Fields>;
};


/** aggregate fields of "nabu.users" */
export type Nabu_Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Users_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Nabu_Users_Avg_Fields = {
  __typename?: 'nabu_users_avg_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nabu.users". All fields are combined with a logical 'AND'. */
export type Nabu_Users_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Users_Bool_Exp>>;
  _not?: Maybe<Nabu_Users_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Users_Bool_Exp>>;
  agora_id?: Maybe<Bigint_Comparison_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  feedback?: Maybe<Nabu_Feedback_Bool_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  group?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name_pronunciation?: Maybe<String_Comparison_Exp>;
  notification_preference?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  preferred_name?: Maybe<String_Comparison_Exp>;
  profile_photo?: Maybe<String_Comparison_Exp>;
  turns?: Maybe<Nabu_Turns_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Nabu_Users_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Nabu_Users_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Nabu_Users_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "nabu.users" */
export type Nabu_Users_Inc_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "nabu.users" */
export type Nabu_Users_Insert_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  feedback?: Maybe<Nabu_Feedback_Arr_Rel_Insert_Input>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  turns?: Maybe<Nabu_Turns_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Users_Max_Fields = {
  __typename?: 'nabu_users_max_fields';
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabu_Users_Min_Fields = {
  __typename?: 'nabu_users_min_fields';
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabu.users" */
export type Nabu_Users_Mutation_Response = {
  __typename?: 'nabu_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Users>;
};

/** input type for inserting object relation for remote table "nabu.users" */
export type Nabu_Users_Obj_Rel_Insert_Input = {
  data: Nabu_Users_Insert_Input;
};

/** Ordering options when selecting data from "nabu.users". */
export type Nabu_Users_Order_By = {
  agora_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  feedback_aggregate?: Maybe<Nabu_Feedback_Aggregate_Order_By>;
  first_name?: Maybe<Order_By>;
  group?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  name_pronunciation?: Maybe<Order_By>;
  notification_preference?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  profile_photo?: Maybe<Order_By>;
  turns_aggregate?: Maybe<Nabu_Turns_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Nabu_Users_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "nabu.users" */
export enum Nabu_Users_Select_Column {
  /** column name */
  AgoraId = 'agora_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NamePronunciation = 'name_pronunciation',
  /** column name */
  NotificationPreference = 'notification_preference',
  /** column name */
  Phone = 'phone',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  ProfilePhoto = 'profile_photo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.users" */
export type Nabu_Users_Set_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nabu_Users_Stddev_Fields = {
  __typename?: 'nabu_users_stddev_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Nabu_Users_Stddev_Pop_Fields = {
  __typename?: 'nabu_users_stddev_pop_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Nabu_Users_Stddev_Samp_Fields = {
  __typename?: 'nabu_users_stddev_samp_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Nabu_Users_Sum_Fields = {
  __typename?: 'nabu_users_sum_fields';
  agora_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Nabu_Users_Var_Pop_Fields = {
  __typename?: 'nabu_users_var_pop_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Nabu_Users_Var_Samp_Fields = {
  __typename?: 'nabu_users_var_samp_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Nabu_Users_Variance_Fields = {
  __typename?: 'nabu_users_variance_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "nabu.voxes" */
export type Nabu_Voxes = {
  __typename?: 'nabu_voxes';
  audio: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  quote: Nabu_Quotes;
  quote_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "nabu.voxes" */
export type Nabu_Voxes_Aggregate = {
  __typename?: 'nabu_voxes_aggregate';
  aggregate?: Maybe<Nabu_Voxes_Aggregate_Fields>;
  nodes: Array<Nabu_Voxes>;
};

/** aggregate fields of "nabu.voxes" */
export type Nabu_Voxes_Aggregate_Fields = {
  __typename?: 'nabu_voxes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabu_Voxes_Max_Fields>;
  min?: Maybe<Nabu_Voxes_Min_Fields>;
};


/** aggregate fields of "nabu.voxes" */
export type Nabu_Voxes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nabu.voxes" */
export type Nabu_Voxes_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Nabu_Voxes_Max_Order_By>;
  min?: Maybe<Nabu_Voxes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "nabu.voxes" */
export type Nabu_Voxes_Arr_Rel_Insert_Input = {
  data: Array<Nabu_Voxes_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Nabu_Voxes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "nabu.voxes". All fields are combined with a logical 'AND'. */
export type Nabu_Voxes_Bool_Exp = {
  _and?: Maybe<Array<Nabu_Voxes_Bool_Exp>>;
  _not?: Maybe<Nabu_Voxes_Bool_Exp>;
  _or?: Maybe<Array<Nabu_Voxes_Bool_Exp>>;
  audio?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  quote?: Maybe<Nabu_Quotes_Bool_Exp>;
  quote_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabu.voxes" */
export enum Nabu_Voxes_Constraint {
  /** unique or primary key constraint */
  VoxesPkey = 'voxes_pkey'
}

/** input type for inserting data into table "nabu.voxes" */
export type Nabu_Voxes_Insert_Input = {
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  quote?: Maybe<Nabu_Quotes_Obj_Rel_Insert_Input>;
  quote_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nabu_Voxes_Max_Fields = {
  __typename?: 'nabu_voxes_max_fields';
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  quote_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "nabu.voxes" */
export type Nabu_Voxes_Max_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  quote_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Nabu_Voxes_Min_Fields = {
  __typename?: 'nabu_voxes_min_fields';
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  quote_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "nabu.voxes" */
export type Nabu_Voxes_Min_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  quote_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "nabu.voxes" */
export type Nabu_Voxes_Mutation_Response = {
  __typename?: 'nabu_voxes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabu_Voxes>;
};

/** on conflict condition type for table "nabu.voxes" */
export type Nabu_Voxes_On_Conflict = {
  constraint: Nabu_Voxes_Constraint;
  update_columns?: Array<Nabu_Voxes_Update_Column>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};

/** Ordering options when selecting data from "nabu.voxes". */
export type Nabu_Voxes_Order_By = {
  audio?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  quote?: Maybe<Nabu_Quotes_Order_By>;
  quote_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: nabu_voxes */
export type Nabu_Voxes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nabu.voxes" */
export enum Nabu_Voxes_Select_Column {
  /** column name */
  Audio = 'audio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nabu.voxes" */
export type Nabu_Voxes_Set_Input = {
  audio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  quote_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "nabu.voxes" */
export enum Nabu_Voxes_Update_Column {
  /** column name */
  Audio = 'audio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "notification_conditions" */
export type Notification_Conditions = {
  __typename?: 'notification_conditions';
  should_filter_confirmed: Scalars['Boolean'];
  value: Notification_Type_Enum;
};

/** aggregated selection of "notification_conditions" */
export type Notification_Conditions_Aggregate = {
  __typename?: 'notification_conditions_aggregate';
  aggregate?: Maybe<Notification_Conditions_Aggregate_Fields>;
  nodes: Array<Notification_Conditions>;
};

/** aggregate fields of "notification_conditions" */
export type Notification_Conditions_Aggregate_Fields = {
  __typename?: 'notification_conditions_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "notification_conditions" */
export type Notification_Conditions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Conditions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_conditions". All fields are combined with a logical 'AND'. */
export type Notification_Conditions_Bool_Exp = {
  _and?: Maybe<Array<Notification_Conditions_Bool_Exp>>;
  _not?: Maybe<Notification_Conditions_Bool_Exp>;
  _or?: Maybe<Array<Notification_Conditions_Bool_Exp>>;
  should_filter_confirmed?: Maybe<Boolean_Comparison_Exp>;
  value?: Maybe<Notification_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_conditions" */
export enum Notification_Conditions_Constraint {
  /** unique or primary key constraint */
  NotificationConditionsPkey = 'notification_conditions_pkey'
}

/** input type for inserting data into table "notification_conditions" */
export type Notification_Conditions_Insert_Input = {
  should_filter_confirmed?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Notification_Type_Enum>;
};

/** response of any mutation on the table "notification_conditions" */
export type Notification_Conditions_Mutation_Response = {
  __typename?: 'notification_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Conditions>;
};

/** input type for inserting object relation for remote table "notification_conditions" */
export type Notification_Conditions_Obj_Rel_Insert_Input = {
  data: Notification_Conditions_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Notification_Conditions_On_Conflict>;
};

/** on conflict condition type for table "notification_conditions" */
export type Notification_Conditions_On_Conflict = {
  constraint: Notification_Conditions_Constraint;
  update_columns?: Array<Notification_Conditions_Update_Column>;
  where?: Maybe<Notification_Conditions_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_conditions". */
export type Notification_Conditions_Order_By = {
  should_filter_confirmed?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: notification_conditions */
export type Notification_Conditions_Pk_Columns_Input = {
  value: Notification_Type_Enum;
};

/** select columns of table "notification_conditions" */
export enum Notification_Conditions_Select_Column {
  /** column name */
  ShouldFilterConfirmed = 'should_filter_confirmed',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_conditions" */
export type Notification_Conditions_Set_Input = {
  should_filter_confirmed?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Notification_Type_Enum>;
};

/** update columns of table "notification_conditions" */
export enum Notification_Conditions_Update_Column {
  /** column name */
  ShouldFilterConfirmed = 'should_filter_confirmed',
  /** column name */
  Value = 'value'
}

/**
 * Due to limitations in Hasura, the offsets for each notification type are stored in a separate table.
 *
 *
 * columns and relationships of "notification_offsets"
 *
 */
export type Notification_Offsets = {
  __typename?: 'notification_offsets';
  offset_type: Scalars['String'];
  offset_unit: Scalars['String'];
  offset_value: Scalars['Int'];
  value: Notification_Type_Enum;
};

/** aggregated selection of "notification_offsets" */
export type Notification_Offsets_Aggregate = {
  __typename?: 'notification_offsets_aggregate';
  aggregate?: Maybe<Notification_Offsets_Aggregate_Fields>;
  nodes: Array<Notification_Offsets>;
};

/** aggregate fields of "notification_offsets" */
export type Notification_Offsets_Aggregate_Fields = {
  __typename?: 'notification_offsets_aggregate_fields';
  avg?: Maybe<Notification_Offsets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Offsets_Max_Fields>;
  min?: Maybe<Notification_Offsets_Min_Fields>;
  stddev?: Maybe<Notification_Offsets_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Offsets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Offsets_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Offsets_Sum_Fields>;
  var_pop?: Maybe<Notification_Offsets_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Offsets_Var_Samp_Fields>;
  variance?: Maybe<Notification_Offsets_Variance_Fields>;
};


/** aggregate fields of "notification_offsets" */
export type Notification_Offsets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Offsets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Notification_Offsets_Avg_Fields = {
  __typename?: 'notification_offsets_avg_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_offsets". All fields are combined with a logical 'AND'. */
export type Notification_Offsets_Bool_Exp = {
  _and?: Maybe<Array<Notification_Offsets_Bool_Exp>>;
  _not?: Maybe<Notification_Offsets_Bool_Exp>;
  _or?: Maybe<Array<Notification_Offsets_Bool_Exp>>;
  offset_type?: Maybe<String_Comparison_Exp>;
  offset_unit?: Maybe<String_Comparison_Exp>;
  offset_value?: Maybe<Int_Comparison_Exp>;
  value?: Maybe<Notification_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_offsets" */
export enum Notification_Offsets_Constraint {
  /** unique or primary key constraint */
  NotificationOffsetsPkey = 'notification_offsets_pkey'
}

/** input type for incrementing numeric columns in table "notification_offsets" */
export type Notification_Offsets_Inc_Input = {
  offset_value?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_offsets" */
export type Notification_Offsets_Insert_Input = {
  offset_type?: Maybe<Scalars['String']>;
  offset_unit?: Maybe<Scalars['String']>;
  offset_value?: Maybe<Scalars['Int']>;
  value?: Maybe<Notification_Type_Enum>;
};

/** aggregate max on columns */
export type Notification_Offsets_Max_Fields = {
  __typename?: 'notification_offsets_max_fields';
  offset_type?: Maybe<Scalars['String']>;
  offset_unit?: Maybe<Scalars['String']>;
  offset_value?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Notification_Offsets_Min_Fields = {
  __typename?: 'notification_offsets_min_fields';
  offset_type?: Maybe<Scalars['String']>;
  offset_unit?: Maybe<Scalars['String']>;
  offset_value?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification_offsets" */
export type Notification_Offsets_Mutation_Response = {
  __typename?: 'notification_offsets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Offsets>;
};

/** input type for inserting object relation for remote table "notification_offsets" */
export type Notification_Offsets_Obj_Rel_Insert_Input = {
  data: Notification_Offsets_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Notification_Offsets_On_Conflict>;
};

/** on conflict condition type for table "notification_offsets" */
export type Notification_Offsets_On_Conflict = {
  constraint: Notification_Offsets_Constraint;
  update_columns?: Array<Notification_Offsets_Update_Column>;
  where?: Maybe<Notification_Offsets_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_offsets". */
export type Notification_Offsets_Order_By = {
  offset_type?: Maybe<Order_By>;
  offset_unit?: Maybe<Order_By>;
  offset_value?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: notification_offsets */
export type Notification_Offsets_Pk_Columns_Input = {
  value: Notification_Type_Enum;
};

/** select columns of table "notification_offsets" */
export enum Notification_Offsets_Select_Column {
  /** column name */
  OffsetType = 'offset_type',
  /** column name */
  OffsetUnit = 'offset_unit',
  /** column name */
  OffsetValue = 'offset_value',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_offsets" */
export type Notification_Offsets_Set_Input = {
  offset_type?: Maybe<Scalars['String']>;
  offset_unit?: Maybe<Scalars['String']>;
  offset_value?: Maybe<Scalars['Int']>;
  value?: Maybe<Notification_Type_Enum>;
};

/** aggregate stddev on columns */
export type Notification_Offsets_Stddev_Fields = {
  __typename?: 'notification_offsets_stddev_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notification_Offsets_Stddev_Pop_Fields = {
  __typename?: 'notification_offsets_stddev_pop_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notification_Offsets_Stddev_Samp_Fields = {
  __typename?: 'notification_offsets_stddev_samp_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Notification_Offsets_Sum_Fields = {
  __typename?: 'notification_offsets_sum_fields';
  offset_value?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_offsets" */
export enum Notification_Offsets_Update_Column {
  /** column name */
  OffsetType = 'offset_type',
  /** column name */
  OffsetUnit = 'offset_unit',
  /** column name */
  OffsetValue = 'offset_value',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type Notification_Offsets_Var_Pop_Fields = {
  __typename?: 'notification_offsets_var_pop_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notification_Offsets_Var_Samp_Fields = {
  __typename?: 'notification_offsets_var_samp_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notification_Offsets_Variance_Fields = {
  __typename?: 'notification_offsets_variance_fields';
  offset_value?: Maybe<Scalars['Float']>;
};

/**
 * Stores the multiple notification templates for the sessions.
 *
 *
 * columns and relationships of "notification_templates"
 *
 */
export type Notification_Templates = {
  __typename?: 'notification_templates';
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  notification_type: Notification_Type;
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  type: Notification_Type_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "notification_templates" */
export type Notification_Templates_Aggregate = {
  __typename?: 'notification_templates_aggregate';
  aggregate?: Maybe<Notification_Templates_Aggregate_Fields>;
  nodes: Array<Notification_Templates>;
};

/** aggregate fields of "notification_templates" */
export type Notification_Templates_Aggregate_Fields = {
  __typename?: 'notification_templates_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Templates_Max_Fields>;
  min?: Maybe<Notification_Templates_Min_Fields>;
};


/** aggregate fields of "notification_templates" */
export type Notification_Templates_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Templates_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_templates" */
export type Notification_Templates_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Notification_Templates_Max_Order_By>;
  min?: Maybe<Notification_Templates_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification_templates" */
export type Notification_Templates_Arr_Rel_Insert_Input = {
  data: Array<Notification_Templates_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Notification_Templates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification_templates". All fields are combined with a logical 'AND'. */
export type Notification_Templates_Bool_Exp = {
  _and?: Maybe<Array<Notification_Templates_Bool_Exp>>;
  _not?: Maybe<Notification_Templates_Bool_Exp>;
  _or?: Maybe<Array<Notification_Templates_Bool_Exp>>;
  content?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  notification_type?: Maybe<Notification_Type_Bool_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Notification_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_templates" */
export enum Notification_Templates_Constraint {
  /** unique or primary key constraint */
  NotificationTemplatesPkey = 'notification_templates_pkey',
  /** unique or primary key constraint */
  NotificationTemplatesTypeSessionIdKey = 'notification_templates_type_session_id_key'
}

/** input type for inserting data into table "notification_templates" */
export type Notification_Templates_Insert_Input = {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Notification_Type_Obj_Rel_Insert_Input>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Notification_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Notification_Templates_Max_Fields = {
  __typename?: 'notification_templates_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "notification_templates" */
export type Notification_Templates_Max_Order_By = {
  content?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Templates_Min_Fields = {
  __typename?: 'notification_templates_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "notification_templates" */
export type Notification_Templates_Min_Order_By = {
  content?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "notification_templates" */
export type Notification_Templates_Mutation_Response = {
  __typename?: 'notification_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Templates>;
};

/** on conflict condition type for table "notification_templates" */
export type Notification_Templates_On_Conflict = {
  constraint: Notification_Templates_Constraint;
  update_columns?: Array<Notification_Templates_Update_Column>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_templates". */
export type Notification_Templates_Order_By = {
  content?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notification_type?: Maybe<Notification_Type_Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: notification_templates */
export type Notification_Templates_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "notification_templates" */
export enum Notification_Templates_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notification_templates" */
export type Notification_Templates_Set_Input = {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Notification_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "notification_templates" */
export enum Notification_Templates_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "notification_type" */
export type Notification_Type = {
  __typename?: 'notification_type';
  comment: Scalars['String'];
  /** An object relationship */
  notification_condition?: Maybe<Notification_Conditions>;
  /** An object relationship */
  notification_offset?: Maybe<Notification_Offsets>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_type" */
export type Notification_Type_Aggregate = {
  __typename?: 'notification_type_aggregate';
  aggregate?: Maybe<Notification_Type_Aggregate_Fields>;
  nodes: Array<Notification_Type>;
};

/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_Fields = {
  __typename?: 'notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Type_Max_Fields>;
  min?: Maybe<Notification_Type_Min_Fields>;
};


/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_type". All fields are combined with a logical 'AND'. */
export type Notification_Type_Bool_Exp = {
  _and?: Maybe<Array<Notification_Type_Bool_Exp>>;
  _not?: Maybe<Notification_Type_Bool_Exp>;
  _or?: Maybe<Array<Notification_Type_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  notification_condition?: Maybe<Notification_Conditions_Bool_Exp>;
  notification_offset?: Maybe<Notification_Offsets_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_type" */
export enum Notification_Type_Constraint {
  /** unique or primary key constraint */
  NotificationTypePkey = 'notification_type_pkey'
}

export enum Notification_Type_Enum {
  /** 4hr Confirmation */
  Confirmation_4Hr = 'CONFIRMATION_4HR',
  /** 24hr Confirmation */
  Confirmation_24Hr = 'CONFIRMATION_24HR',
  /** 10 Minute Reminder */
  Reminder_10Min = 'REMINDER_10MIN',
  /** Unknown notification type */
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "notification_type_enum". All fields are combined with logical 'AND'. */
export type Notification_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Notification_Type_Enum>;
  _in?: Maybe<Array<Notification_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Notification_Type_Enum>;
  _nin?: Maybe<Array<Notification_Type_Enum>>;
};

/** input type for inserting data into table "notification_type" */
export type Notification_Type_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  notification_condition?: Maybe<Notification_Conditions_Obj_Rel_Insert_Input>;
  notification_offset?: Maybe<Notification_Offsets_Obj_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Type_Max_Fields = {
  __typename?: 'notification_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Type_Min_Fields = {
  __typename?: 'notification_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_type" */
export type Notification_Type_Mutation_Response = {
  __typename?: 'notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Type>;
};

/** input type for inserting object relation for remote table "notification_type" */
export type Notification_Type_Obj_Rel_Insert_Input = {
  data: Notification_Type_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Notification_Type_On_Conflict>;
};

/** on conflict condition type for table "notification_type" */
export type Notification_Type_On_Conflict = {
  constraint: Notification_Type_Constraint;
  update_columns?: Array<Notification_Type_Update_Column>;
  where?: Maybe<Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_type". */
export type Notification_Type_Order_By = {
  comment?: Maybe<Order_By>;
  notification_condition?: Maybe<Notification_Conditions_Order_By>;
  notification_offset?: Maybe<Notification_Offsets_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: notification_type */
export type Notification_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "notification_type" */
export enum Notification_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_type" */
export type Notification_Type_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "notification_type" */
export enum Notification_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "participant" */
export type Participant = {
  __typename?: 'participant';
  agora_id: Scalars['bigint'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  group: Scalars['String'];
  id: Scalars['uuid'];
  last_name: Scalars['String'];
  metadata: Scalars['jsonb'];
  name_pronunciation: Scalars['String'];
  notification_preference: Scalars['String'];
  /** An array relationship */
  participant_sessions: Array<Participant_Session>;
  /** An aggregate relationship */
  participant_sessions_aggregate: Participant_Session_Aggregate;
  phone: Scalars['String'];
  preferred_name: Scalars['String'];
  profile_photo?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_presences: Array<User_Presence>;
  /** An aggregate relationship */
  user_presences_aggregate: User_Presence_Aggregate;
};


/** columns and relationships of "participant" */
export type ParticipantMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_SessionsArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_Sessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantUser_PresencesArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantUser_Presences_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};

/** aggregated selection of "participant" */
export type Participant_Aggregate = {
  __typename?: 'participant_aggregate';
  aggregate?: Maybe<Participant_Aggregate_Fields>;
  nodes: Array<Participant>;
};

/** aggregate fields of "participant" */
export type Participant_Aggregate_Fields = {
  __typename?: 'participant_aggregate_fields';
  avg?: Maybe<Participant_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Participant_Max_Fields>;
  min?: Maybe<Participant_Min_Fields>;
  stddev?: Maybe<Participant_Stddev_Fields>;
  stddev_pop?: Maybe<Participant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Participant_Stddev_Samp_Fields>;
  sum?: Maybe<Participant_Sum_Fields>;
  var_pop?: Maybe<Participant_Var_Pop_Fields>;
  var_samp?: Maybe<Participant_Var_Samp_Fields>;
  variance?: Maybe<Participant_Variance_Fields>;
};


/** aggregate fields of "participant" */
export type Participant_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Participant_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "participant" */
export type Participant_Aggregate_Order_By = {
  avg?: Maybe<Participant_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Participant_Max_Order_By>;
  min?: Maybe<Participant_Min_Order_By>;
  stddev?: Maybe<Participant_Stddev_Order_By>;
  stddev_pop?: Maybe<Participant_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Participant_Stddev_Samp_Order_By>;
  sum?: Maybe<Participant_Sum_Order_By>;
  var_pop?: Maybe<Participant_Var_Pop_Order_By>;
  var_samp?: Maybe<Participant_Var_Samp_Order_By>;
  variance?: Maybe<Participant_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Participant_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "participant" */
export type Participant_Arr_Rel_Insert_Input = {
  data: Array<Participant_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Participant_On_Conflict>;
};

/** aggregate avg on columns */
export type Participant_Avg_Fields = {
  __typename?: 'participant_avg_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "participant" */
export type Participant_Avg_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "participant". All fields are combined with a logical 'AND'. */
export type Participant_Bool_Exp = {
  _and?: Maybe<Array<Participant_Bool_Exp>>;
  _not?: Maybe<Participant_Bool_Exp>;
  _or?: Maybe<Array<Participant_Bool_Exp>>;
  agora_id?: Maybe<Bigint_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  group?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name_pronunciation?: Maybe<String_Comparison_Exp>;
  notification_preference?: Maybe<String_Comparison_Exp>;
  participant_sessions?: Maybe<Participant_Session_Bool_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  preferred_name?: Maybe<String_Comparison_Exp>;
  profile_photo?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_presences?: Maybe<User_Presence_Bool_Exp>;
};

/** unique or primary key constraints on table "participant" */
export enum Participant_Constraint {
  /** unique or primary key constraint */
  ParticipantAgoraIdKey = 'participant_agora_id_key',
  /** unique or primary key constraint */
  ParticipantEmailKey = 'participant_email_key',
  /** unique or primary key constraint */
  ParticipantPkey = 'participant_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Participant_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Participant_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Participant_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "participant" */
export type Participant_Inc_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "participant" */
export type Participant_Insert_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  participant_sessions?: Maybe<Participant_Session_Arr_Rel_Insert_Input>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_presences?: Maybe<User_Presence_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Participant_Max_Fields = {
  __typename?: 'participant_max_fields';
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "participant" */
export type Participant_Max_Order_By = {
  agora_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  group?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  name_pronunciation?: Maybe<Order_By>;
  notification_preference?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  profile_photo?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Min_Fields = {
  __typename?: 'participant_min_fields';
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "participant" */
export type Participant_Min_Order_By = {
  agora_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  group?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  name_pronunciation?: Maybe<Order_By>;
  notification_preference?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  profile_photo?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "participant" */
export type Participant_Mutation_Response = {
  __typename?: 'participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant>;
};

/** input type for inserting object relation for remote table "participant" */
export type Participant_Obj_Rel_Insert_Input = {
  data: Participant_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Participant_On_Conflict>;
};

/** on conflict condition type for table "participant" */
export type Participant_On_Conflict = {
  constraint: Participant_Constraint;
  update_columns?: Array<Participant_Update_Column>;
  where?: Maybe<Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "participant". */
export type Participant_Order_By = {
  agora_id?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  group?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  name_pronunciation?: Maybe<Order_By>;
  notification_preference?: Maybe<Order_By>;
  participant_sessions_aggregate?: Maybe<Participant_Session_Aggregate_Order_By>;
  phone?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  profile_photo?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_presences_aggregate?: Maybe<User_Presence_Aggregate_Order_By>;
};

/** primary key columns input for table: participant */
export type Participant_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Participant_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "participant_registration_view" */
export type Participant_Registration_View = {
  __typename?: 'participant_registration_view';
  company?: Maybe<Scalars['String']>;
  next_session_date_time?: Maybe<Scalars['timestamptz']>;
  next_session_name?: Maybe<Scalars['String']>;
  program?: Maybe<Scalars['String']>;
  registration_date?: Maybe<Scalars['timestamptz']>;
  user_email?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "participant_registration_view" */
export type Participant_Registration_View_Aggregate = {
  __typename?: 'participant_registration_view_aggregate';
  aggregate?: Maybe<Participant_Registration_View_Aggregate_Fields>;
  nodes: Array<Participant_Registration_View>;
};

/** aggregate fields of "participant_registration_view" */
export type Participant_Registration_View_Aggregate_Fields = {
  __typename?: 'participant_registration_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Participant_Registration_View_Max_Fields>;
  min?: Maybe<Participant_Registration_View_Min_Fields>;
};


/** aggregate fields of "participant_registration_view" */
export type Participant_Registration_View_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Participant_Registration_View_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "participant_registration_view". All fields are combined with a logical 'AND'. */
export type Participant_Registration_View_Bool_Exp = {
  _and?: Maybe<Array<Participant_Registration_View_Bool_Exp>>;
  _not?: Maybe<Participant_Registration_View_Bool_Exp>;
  _or?: Maybe<Array<Participant_Registration_View_Bool_Exp>>;
  company?: Maybe<String_Comparison_Exp>;
  next_session_date_time?: Maybe<Timestamptz_Comparison_Exp>;
  next_session_name?: Maybe<String_Comparison_Exp>;
  program?: Maybe<String_Comparison_Exp>;
  registration_date?: Maybe<Timestamptz_Comparison_Exp>;
  user_email?: Maybe<String_Comparison_Exp>;
  user_name?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Participant_Registration_View_Max_Fields = {
  __typename?: 'participant_registration_view_max_fields';
  company?: Maybe<Scalars['String']>;
  next_session_date_time?: Maybe<Scalars['timestamptz']>;
  next_session_name?: Maybe<Scalars['String']>;
  program?: Maybe<Scalars['String']>;
  registration_date?: Maybe<Scalars['timestamptz']>;
  user_email?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Participant_Registration_View_Min_Fields = {
  __typename?: 'participant_registration_view_min_fields';
  company?: Maybe<Scalars['String']>;
  next_session_date_time?: Maybe<Scalars['timestamptz']>;
  next_session_name?: Maybe<Scalars['String']>;
  program?: Maybe<Scalars['String']>;
  registration_date?: Maybe<Scalars['timestamptz']>;
  user_email?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "participant_registration_view". */
export type Participant_Registration_View_Order_By = {
  company?: Maybe<Order_By>;
  next_session_date_time?: Maybe<Order_By>;
  next_session_name?: Maybe<Order_By>;
  program?: Maybe<Order_By>;
  registration_date?: Maybe<Order_By>;
  user_email?: Maybe<Order_By>;
  user_name?: Maybe<Order_By>;
};

/** select columns of table "participant_registration_view" */
export enum Participant_Registration_View_Select_Column {
  /** column name */
  Company = 'company',
  /** column name */
  NextSessionDateTime = 'next_session_date_time',
  /** column name */
  NextSessionName = 'next_session_name',
  /** column name */
  Program = 'program',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserName = 'user_name'
}

/** select columns of table "participant" */
export enum Participant_Select_Column {
  /** column name */
  AgoraId = 'agora_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NamePronunciation = 'name_pronunciation',
  /** column name */
  NotificationPreference = 'notification_preference',
  /** column name */
  Phone = 'phone',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  ProfilePhoto = 'profile_photo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "participant_session" */
export type Participant_Session = {
  __typename?: 'participant_session';
  confirmation_status?: Maybe<Confirmation_Status_Enum>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  last_notification?: Maybe<Notification_Type_Enum>;
  /** An object relationship */
  participant?: Maybe<Participant>;
  participant_id: Scalars['uuid'];
  /** An array relationship */
  session: Array<Session>;
  /** An aggregate relationship */
  session_aggregate: Session_Aggregate;
  session_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "participant_session" */
export type Participant_SessionSessionArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


/** columns and relationships of "participant_session" */
export type Participant_SessionSession_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};

/** aggregated selection of "participant_session" */
export type Participant_Session_Aggregate = {
  __typename?: 'participant_session_aggregate';
  aggregate?: Maybe<Participant_Session_Aggregate_Fields>;
  nodes: Array<Participant_Session>;
};

/** aggregate fields of "participant_session" */
export type Participant_Session_Aggregate_Fields = {
  __typename?: 'participant_session_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Participant_Session_Max_Fields>;
  min?: Maybe<Participant_Session_Min_Fields>;
};


/** aggregate fields of "participant_session" */
export type Participant_Session_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Participant_Session_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "participant_session" */
export type Participant_Session_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Participant_Session_Max_Order_By>;
  min?: Maybe<Participant_Session_Min_Order_By>;
};

/** input type for inserting array relation for remote table "participant_session" */
export type Participant_Session_Arr_Rel_Insert_Input = {
  data: Array<Participant_Session_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Participant_Session_On_Conflict>;
};

/** Boolean expression to filter rows from the table "participant_session". All fields are combined with a logical 'AND'. */
export type Participant_Session_Bool_Exp = {
  _and?: Maybe<Array<Participant_Session_Bool_Exp>>;
  _not?: Maybe<Participant_Session_Bool_Exp>;
  _or?: Maybe<Array<Participant_Session_Bool_Exp>>;
  confirmation_status?: Maybe<Confirmation_Status_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_notification?: Maybe<Notification_Type_Enum_Comparison_Exp>;
  participant?: Maybe<Participant_Bool_Exp>;
  participant_id?: Maybe<Uuid_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant_session" */
export enum Participant_Session_Constraint {
  /** unique or primary key constraint */
  ParticipantSessionPkey = 'participant_session_pkey',
  /** unique or primary key constraint */
  ParticipantSessionSessionIdParticipantIdKey = 'participant_session_session_id_participant_id_key'
}

/** input type for inserting data into table "participant_session" */
export type Participant_Session_Insert_Input = {
  confirmation_status?: Maybe<Confirmation_Status_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_notification?: Maybe<Notification_Type_Enum>;
  participant?: Maybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: Maybe<Scalars['uuid']>;
  session?: Maybe<Session_Arr_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Participant_Session_Max_Fields = {
  __typename?: 'participant_session_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participant_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "participant_session" */
export type Participant_Session_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  participant_id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Session_Min_Fields = {
  __typename?: 'participant_session_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participant_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "participant_session" */
export type Participant_Session_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  participant_id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "participant_session" */
export type Participant_Session_Mutation_Response = {
  __typename?: 'participant_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant_Session>;
};

/** on conflict condition type for table "participant_session" */
export type Participant_Session_On_Conflict = {
  constraint: Participant_Session_Constraint;
  update_columns?: Array<Participant_Session_Update_Column>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "participant_session". */
export type Participant_Session_Order_By = {
  confirmation_status?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_notification?: Maybe<Order_By>;
  participant?: Maybe<Participant_Order_By>;
  participant_id?: Maybe<Order_By>;
  session_aggregate?: Maybe<Session_Aggregate_Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: participant_session */
export type Participant_Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "participant_session" */
export enum Participant_Session_Select_Column {
  /** column name */
  ConfirmationStatus = 'confirmation_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNotification = 'last_notification',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "participant_session" */
export type Participant_Session_Set_Input = {
  confirmation_status?: Maybe<Confirmation_Status_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_notification?: Maybe<Notification_Type_Enum>;
  participant_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "participant_session" */
export enum Participant_Session_Update_Column {
  /** column name */
  ConfirmationStatus = 'confirmation_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastNotification = 'last_notification',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "participant" */
export type Participant_Set_Input = {
  agora_id?: Maybe<Scalars['bigint']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_pronunciation?: Maybe<Scalars['String']>;
  notification_preference?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  profile_photo?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Participant_Stddev_Fields = {
  __typename?: 'participant_stddev_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "participant" */
export type Participant_Stddev_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Participant_Stddev_Pop_Fields = {
  __typename?: 'participant_stddev_pop_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "participant" */
export type Participant_Stddev_Pop_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Participant_Stddev_Samp_Fields = {
  __typename?: 'participant_stddev_samp_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "participant" */
export type Participant_Stddev_Samp_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Participant_Sum_Fields = {
  __typename?: 'participant_sum_fields';
  agora_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "participant" */
export type Participant_Sum_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** update columns of table "participant" */
export enum Participant_Update_Column {
  /** column name */
  AgoraId = 'agora_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NamePronunciation = 'name_pronunciation',
  /** column name */
  NotificationPreference = 'notification_preference',
  /** column name */
  Phone = 'phone',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  ProfilePhoto = 'profile_photo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Participant_Var_Pop_Fields = {
  __typename?: 'participant_var_pop_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "participant" */
export type Participant_Var_Pop_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Participant_Var_Samp_Fields = {
  __typename?: 'participant_var_samp_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "participant" */
export type Participant_Var_Samp_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Participant_Variance_Fields = {
  __typename?: 'participant_variance_fields';
  agora_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "participant" */
export type Participant_Variance_Order_By = {
  agora_id?: Maybe<Order_By>;
};

/** columns and relationships of "program" */
export type Program = {
  __typename?: 'program';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "program" */
export type Program_Aggregate = {
  __typename?: 'program_aggregate';
  aggregate?: Maybe<Program_Aggregate_Fields>;
  nodes: Array<Program>;
};

/** aggregate fields of "program" */
export type Program_Aggregate_Fields = {
  __typename?: 'program_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Program_Max_Fields>;
  min?: Maybe<Program_Min_Fields>;
};


/** aggregate fields of "program" */
export type Program_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Program_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "program". All fields are combined with a logical 'AND'. */
export type Program_Bool_Exp = {
  _and?: Maybe<Array<Program_Bool_Exp>>;
  _not?: Maybe<Program_Bool_Exp>;
  _or?: Maybe<Array<Program_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "program" */
export enum Program_Constraint {
  /** unique or primary key constraint */
  ProgramPkey = 'program_pkey'
}

/** input type for inserting data into table "program" */
export type Program_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Program_Max_Fields = {
  __typename?: 'program_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Program_Min_Fields = {
  __typename?: 'program_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "program" */
export type Program_Mutation_Response = {
  __typename?: 'program_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Program>;
};

/** input type for inserting object relation for remote table "program" */
export type Program_Obj_Rel_Insert_Input = {
  data: Program_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Program_On_Conflict>;
};

/** on conflict condition type for table "program" */
export type Program_On_Conflict = {
  constraint: Program_Constraint;
  update_columns?: Array<Program_Update_Column>;
  where?: Maybe<Program_Bool_Exp>;
};

/** Ordering options when selecting data from "program". */
export type Program_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: program */
export type Program_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "program" */
export enum Program_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "program" */
export type Program_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "program" */
export enum Program_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "prompts" */
export type Prompts = {
  __typename?: 'prompts';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  segment: Scripts;
  segment_id: Scalars['uuid'];
  text: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "prompts" */
export type Prompts_Aggregate = {
  __typename?: 'prompts_aggregate';
  aggregate?: Maybe<Prompts_Aggregate_Fields>;
  nodes: Array<Prompts>;
};

/** aggregate fields of "prompts" */
export type Prompts_Aggregate_Fields = {
  __typename?: 'prompts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Prompts_Max_Fields>;
  min?: Maybe<Prompts_Min_Fields>;
};


/** aggregate fields of "prompts" */
export type Prompts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Prompts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "prompts" */
export type Prompts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Prompts_Max_Order_By>;
  min?: Maybe<Prompts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "prompts" */
export type Prompts_Arr_Rel_Insert_Input = {
  data: Array<Prompts_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Prompts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "prompts". All fields are combined with a logical 'AND'. */
export type Prompts_Bool_Exp = {
  _and?: Maybe<Array<Prompts_Bool_Exp>>;
  _not?: Maybe<Prompts_Bool_Exp>;
  _or?: Maybe<Array<Prompts_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  segment?: Maybe<Scripts_Bool_Exp>;
  segment_id?: Maybe<Uuid_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prompts" */
export enum Prompts_Constraint {
  /** unique or primary key constraint */
  PromptsPkey = 'prompts_pkey'
}

/** input type for inserting data into table "prompts" */
export type Prompts_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment?: Maybe<Scripts_Obj_Rel_Insert_Input>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Prompts_Max_Fields = {
  __typename?: 'prompts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "prompts" */
export type Prompts_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Prompts_Min_Fields = {
  __typename?: 'prompts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "prompts" */
export type Prompts_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "prompts" */
export type Prompts_Mutation_Response = {
  __typename?: 'prompts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prompts>;
};

/** on conflict condition type for table "prompts" */
export type Prompts_On_Conflict = {
  constraint: Prompts_Constraint;
  update_columns?: Array<Prompts_Update_Column>;
  where?: Maybe<Prompts_Bool_Exp>;
};

/** Ordering options when selecting data from "prompts". */
export type Prompts_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  segment?: Maybe<Scripts_Order_By>;
  segment_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: prompts */
export type Prompts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "prompts" */
export enum Prompts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "prompts" */
export type Prompts_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "prompts" */
export enum Prompts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentId = 'segment_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_contact" */
  company_contact: Array<Company_Contact>;
  /** fetch aggregated fields from the table: "company_contact" */
  company_contact_aggregate: Company_Contact_Aggregate;
  /** fetch data from the table: "company_contact" using primary key columns */
  company_contact_by_pk?: Maybe<Company_Contact>;
  /** fetch data from the table: "confirmation_status" */
  confirmation_status: Array<Confirmation_Status>;
  /** fetch aggregated fields from the table: "confirmation_status" */
  confirmation_status_aggregate: Confirmation_Status_Aggregate;
  /** fetch data from the table: "confirmation_status" using primary key columns */
  confirmation_status_by_pk?: Maybe<Confirmation_Status>;
  /** An array relationship */
  event: Array<Event>;
  /** An aggregate relationship */
  event_aggregate: Event_Aggregate;
  /** fetch data from the table: "event" using primary key columns */
  event_by_pk?: Maybe<Event>;
  /** fetch data from the table: "event_type" */
  event_type: Array<Event_Type>;
  /** fetch aggregated fields from the table: "event_type" */
  event_type_aggregate: Event_Type_Aggregate;
  /** fetch data from the table: "event_type" using primary key columns */
  event_type_by_pk?: Maybe<Event_Type>;
  getAgoraTempToken?: Maybe<GetAgoraTempTokenOutput>;
  /** fetch data from the table: "historic_events" */
  historic_events: Array<Historic_Events>;
  /** fetch aggregated fields from the table: "historic_events" */
  historic_events_aggregate: Historic_Events_Aggregate;
  /** fetch data from the table: "historic_events" using primary key columns */
  historic_events_by_pk?: Maybe<Historic_Events>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch data from the table: "logs_action" */
  logs_action: Array<Logs_Action>;
  /** fetch aggregated fields from the table: "logs_action" */
  logs_action_aggregate: Logs_Action_Aggregate;
  /** fetch data from the table: "logs_action" using primary key columns */
  logs_action_by_pk?: Maybe<Logs_Action>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table: "nabu.companies" */
  nabu_companies: Array<Nabu_Companies>;
  /** fetch aggregated fields from the table: "nabu.companies" */
  nabu_companies_aggregate: Nabu_Companies_Aggregate;
  /** fetch data from the table: "nabu.feedback" */
  nabu_feedback: Array<Nabu_Feedback>;
  /** fetch aggregated fields from the table: "nabu.feedback" */
  nabu_feedback_aggregate: Nabu_Feedback_Aggregate;
  /** fetch data from the table: "nabu.feedback" using primary key columns */
  nabu_feedback_by_pk?: Maybe<Nabu_Feedback>;
  /** fetch data from the table: "nabu.feedback_type" */
  nabu_feedback_type: Array<Nabu_Feedback_Type>;
  /** fetch aggregated fields from the table: "nabu.feedback_type" */
  nabu_feedback_type_aggregate: Nabu_Feedback_Type_Aggregate;
  /** fetch data from the table: "nabu.feedback_type" using primary key columns */
  nabu_feedback_type_by_pk?: Maybe<Nabu_Feedback_Type>;
  /** fetch data from the table: "nabu.prevalence_score_classification_runs" */
  nabu_prevalence_score_classification_runs: Array<Nabu_Prevalence_Score_Classification_Runs>;
  /** fetch aggregated fields from the table: "nabu.prevalence_score_classification_runs" */
  nabu_prevalence_score_classification_runs_aggregate: Nabu_Prevalence_Score_Classification_Runs_Aggregate;
  /** fetch data from the table: "nabu.prevalence_score_classification_runs" using primary key columns */
  nabu_prevalence_score_classification_runs_by_pk?: Maybe<Nabu_Prevalence_Score_Classification_Runs>;
  /** fetch data from the table: "nabu.programs" */
  nabu_programs: Array<Nabu_Programs>;
  /** fetch aggregated fields from the table: "nabu.programs" */
  nabu_programs_aggregate: Nabu_Programs_Aggregate;
  /** fetch data from the table: "nabu.prompts" */
  nabu_prompts: Array<Nabu_Prompts>;
  /** fetch aggregated fields from the table: "nabu.prompts" */
  nabu_prompts_aggregate: Nabu_Prompts_Aggregate;
  /** fetch data from the table: "nabu.quotes" */
  nabu_quotes: Array<Nabu_Quotes>;
  /** fetch aggregated fields from the table: "nabu.quotes" */
  nabu_quotes_aggregate: Nabu_Quotes_Aggregate;
  /** fetch data from the table: "nabu.quotes" using primary key columns */
  nabu_quotes_by_pk?: Maybe<Nabu_Quotes>;
  /** fetch data from the table: "nabu.segments" */
  nabu_segments: Array<Nabu_Segments>;
  /** fetch aggregated fields from the table: "nabu.segments" */
  nabu_segments_aggregate: Nabu_Segments_Aggregate;
  /** fetch data from the table: "nabu.sessions" */
  nabu_sessions: Array<Nabu_Sessions>;
  /** fetch aggregated fields from the table: "nabu.sessions" */
  nabu_sessions_aggregate: Nabu_Sessions_Aggregate;
  /** fetch data from the table: "nabu.survey_questions" */
  nabu_survey_questions: Array<Nabu_Survey_Questions>;
  /** fetch aggregated fields from the table: "nabu.survey_questions" */
  nabu_survey_questions_aggregate: Nabu_Survey_Questions_Aggregate;
  /** fetch data from the table: "nabu.surveys" */
  nabu_surveys: Array<Nabu_Surveys>;
  /** fetch aggregated fields from the table: "nabu.surveys" */
  nabu_surveys_aggregate: Nabu_Surveys_Aggregate;
  /** fetch data from the table: "nabu.turns" */
  nabu_turns: Array<Nabu_Turns>;
  /** fetch aggregated fields from the table: "nabu.turns" */
  nabu_turns_aggregate: Nabu_Turns_Aggregate;
  /** fetch data from the table: "nabu.turns" using primary key columns */
  nabu_turns_by_pk?: Maybe<Nabu_Turns>;
  /** fetch data from the table: "nabu.users" */
  nabu_users: Array<Nabu_Users>;
  /** fetch aggregated fields from the table: "nabu.users" */
  nabu_users_aggregate: Nabu_Users_Aggregate;
  /** fetch data from the table: "nabu.voxes" */
  nabu_voxes: Array<Nabu_Voxes>;
  /** fetch aggregated fields from the table: "nabu.voxes" */
  nabu_voxes_aggregate: Nabu_Voxes_Aggregate;
  /** fetch data from the table: "nabu.voxes" using primary key columns */
  nabu_voxes_by_pk?: Maybe<Nabu_Voxes>;
  /** fetch data from the table: "notification_conditions" */
  notification_conditions: Array<Notification_Conditions>;
  /** fetch aggregated fields from the table: "notification_conditions" */
  notification_conditions_aggregate: Notification_Conditions_Aggregate;
  /** fetch data from the table: "notification_conditions" using primary key columns */
  notification_conditions_by_pk?: Maybe<Notification_Conditions>;
  /** fetch data from the table: "notification_offsets" */
  notification_offsets: Array<Notification_Offsets>;
  /** fetch aggregated fields from the table: "notification_offsets" */
  notification_offsets_aggregate: Notification_Offsets_Aggregate;
  /** fetch data from the table: "notification_offsets" using primary key columns */
  notification_offsets_by_pk?: Maybe<Notification_Offsets>;
  /** An array relationship */
  notification_templates: Array<Notification_Templates>;
  /** An aggregate relationship */
  notification_templates_aggregate: Notification_Templates_Aggregate;
  /** fetch data from the table: "notification_templates" using primary key columns */
  notification_templates_by_pk?: Maybe<Notification_Templates>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table: "participant" */
  participant: Array<Participant>;
  /** fetch aggregated fields from the table: "participant" */
  participant_aggregate: Participant_Aggregate;
  /** fetch data from the table: "participant" using primary key columns */
  participant_by_pk?: Maybe<Participant>;
  /** fetch data from the table: "participant_registration_view" */
  participant_registration_view: Array<Participant_Registration_View>;
  /** fetch aggregated fields from the table: "participant_registration_view" */
  participant_registration_view_aggregate: Participant_Registration_View_Aggregate;
  /** An array relationship */
  participant_session: Array<Participant_Session>;
  /** An aggregate relationship */
  participant_session_aggregate: Participant_Session_Aggregate;
  /** fetch data from the table: "participant_session" using primary key columns */
  participant_session_by_pk?: Maybe<Participant_Session>;
  /** fetch data from the table: "program" */
  program: Array<Program>;
  /** fetch aggregated fields from the table: "program" */
  program_aggregate: Program_Aggregate;
  /** fetch data from the table: "program" using primary key columns */
  program_by_pk?: Maybe<Program>;
  /** An array relationship */
  prompts: Array<Prompts>;
  /** An aggregate relationship */
  prompts_aggregate: Prompts_Aggregate;
  /** fetch data from the table: "prompts" using primary key columns */
  prompts_by_pk?: Maybe<Prompts>;
  /** fetch data from the table: "question_type" */
  question_type: Array<Question_Type>;
  /** fetch aggregated fields from the table: "question_type" */
  question_type_aggregate: Question_Type_Aggregate;
  /** fetch data from the table: "question_type" using primary key columns */
  question_type_by_pk?: Maybe<Question_Type>;
  /** fetch data from the table: "recording_session" */
  recording_session: Array<Recording_Session>;
  /** fetch aggregated fields from the table: "recording_session" */
  recording_session_aggregate: Recording_Session_Aggregate;
  /** fetch data from the table: "recording_session" using primary key columns */
  recording_session_by_pk?: Maybe<Recording_Session>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "scripts" */
  scripts: Array<Scripts>;
  /** fetch aggregated fields from the table: "scripts" */
  scripts_aggregate: Scripts_Aggregate;
  /** fetch data from the table: "scripts" using primary key columns */
  scripts_by_pk?: Maybe<Scripts>;
  /** An array relationship */
  session: Array<Session>;
  /** An aggregate relationship */
  session_aggregate: Session_Aggregate;
  /** fetch data from the table: "session" using primary key columns */
  session_by_pk?: Maybe<Session>;
  /** fetch data from the table: "session_with_participant_count" */
  session_with_participant_count: Array<Session_With_Participant_Count>;
  /** fetch aggregated fields from the table: "session_with_participant_count" */
  session_with_participant_count_aggregate: Session_With_Participant_Count_Aggregate;
  /** fetch data from the table: "sessions_info_view" */
  sessions_info_view: Array<Sessions_Info_View>;
  /** fetch aggregated fields from the table: "sessions_info_view" */
  sessions_info_view_aggregate: Sessions_Info_View_Aggregate;
  /** fetch data from the table: "speech_phrases" */
  speech_phrases: Array<Speech_Phrases>;
  /** fetch aggregated fields from the table: "speech_phrases" */
  speech_phrases_aggregate: Speech_Phrases_Aggregate;
  /** fetch data from the table: "speech_phrases" using primary key columns */
  speech_phrases_by_pk?: Maybe<Speech_Phrases>;
  /** fetch data from the table: "speech_phrases_session" */
  speech_phrases_session: Array<Speech_Phrases_Session>;
  /** fetch aggregated fields from the table: "speech_phrases_session" */
  speech_phrases_session_aggregate: Speech_Phrases_Session_Aggregate;
  /** fetch data from the table: "speech_phrases_session" using primary key columns */
  speech_phrases_session_by_pk?: Maybe<Speech_Phrases_Session>;
  /** An array relationship */
  survey_questions: Array<Survey_Questions>;
  /** An aggregate relationship */
  survey_questions_aggregate: Survey_Questions_Aggregate;
  /** fetch data from the table: "survey_questions" using primary key columns */
  survey_questions_by_pk?: Maybe<Survey_Questions>;
  /** fetch data from the table: "surveys" */
  surveys: Array<Surveys>;
  /** An aggregate relationship */
  surveys_aggregate: Surveys_Aggregate;
  /** fetch data from the table: "surveys" using primary key columns */
  surveys_by_pk?: Maybe<Surveys>;
  /** fetch data from the table: "user_login" */
  user_login: Array<User_Login>;
  /** fetch aggregated fields from the table: "user_login" */
  user_login_aggregate: User_Login_Aggregate;
  /** fetch data from the table: "user_login" using primary key columns */
  user_login_by_pk?: Maybe<User_Login>;
  /** fetch data from the table: "user_presence" */
  user_presence: Array<User_Presence>;
  /** fetch aggregated fields from the table: "user_presence" */
  user_presence_aggregate: User_Presence_Aggregate;
  /** fetch data from the table: "user_presence" using primary key columns */
  user_presence_by_pk?: Maybe<User_Presence>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table: "video_session" */
  video_session: Array<Video_Session>;
  /** fetch aggregated fields from the table: "video_session" */
  video_session_aggregate: Video_Session_Aggregate;
  /** fetch data from the table: "video_session" using primary key columns */
  video_session_by_pk?: Maybe<Video_Session>;
};


export type Query_RootAddressArgs = {
  distinct_on?: Maybe<Array<Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Address_Order_By>>;
  where?: Maybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: Maybe<Array<Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Address_Order_By>>;
  where?: Maybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Query_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Query_RootCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_ContactArgs = {
  distinct_on?: Maybe<Array<Company_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Contact_Order_By>>;
  where?: Maybe<Company_Contact_Bool_Exp>;
};


export type Query_RootCompany_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Contact_Order_By>>;
  where?: Maybe<Company_Contact_Bool_Exp>;
};


export type Query_RootCompany_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConfirmation_StatusArgs = {
  distinct_on?: Maybe<Array<Confirmation_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Confirmation_Status_Order_By>>;
  where?: Maybe<Confirmation_Status_Bool_Exp>;
};


export type Query_RootConfirmation_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Confirmation_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Confirmation_Status_Order_By>>;
  where?: Maybe<Confirmation_Status_Bool_Exp>;
};


export type Query_RootConfirmation_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


export type Query_RootEvent_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


export type Query_RootEvent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_TypeArgs = {
  distinct_on?: Maybe<Array<Event_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Type_Order_By>>;
  where?: Maybe<Event_Type_Bool_Exp>;
};


export type Query_RootEvent_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Type_Order_By>>;
  where?: Maybe<Event_Type_Bool_Exp>;
};


export type Query_RootEvent_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGetAgoraTempTokenArgs = {
  sessionId: Scalars['String'];
};


export type Query_RootHistoric_EventsArgs = {
  distinct_on?: Maybe<Array<Historic_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historic_Events_Order_By>>;
  where?: Maybe<Historic_Events_Bool_Exp>;
};


export type Query_RootHistoric_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Historic_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historic_Events_Order_By>>;
  where?: Maybe<Historic_Events_Bool_Exp>;
};


export type Query_RootHistoric_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLogsArgs = {
  distinct_on?: Maybe<Array<Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Order_By>>;
  where?: Maybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_ActionArgs = {
  distinct_on?: Maybe<Array<Logs_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Action_Order_By>>;
  where?: Maybe<Logs_Action_Bool_Exp>;
};


export type Query_RootLogs_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Logs_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Action_Order_By>>;
  where?: Maybe<Logs_Action_Bool_Exp>;
};


export type Query_RootLogs_Action_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootLogs_AggregateArgs = {
  distinct_on?: Maybe<Array<Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Order_By>>;
  where?: Maybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMediaArgs = {
  distinct_on?: Maybe<Array<Media_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Media_Order_By>>;
  where?: Maybe<Media_Bool_Exp>;
};


export type Query_RootMedia_AggregateArgs = {
  distinct_on?: Maybe<Array<Media_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Media_Order_By>>;
  where?: Maybe<Media_Bool_Exp>;
};


export type Query_RootMedia_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNabu_CompaniesArgs = {
  distinct_on?: Maybe<Array<Nabu_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Companies_Order_By>>;
  where?: Maybe<Nabu_Companies_Bool_Exp>;
};


export type Query_RootNabu_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Companies_Order_By>>;
  where?: Maybe<Nabu_Companies_Bool_Exp>;
};


export type Query_RootNabu_FeedbackArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


export type Query_RootNabu_Feedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


export type Query_RootNabu_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNabu_Feedback_TypeArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Type_Order_By>>;
  where?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
};


export type Query_RootNabu_Feedback_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Type_Order_By>>;
  where?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
};


export type Query_RootNabu_Feedback_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootNabu_Prevalence_Score_Classification_RunsArgs = {
  distinct_on?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Order_By>>;
  where?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
};


export type Query_RootNabu_Prevalence_Score_Classification_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Order_By>>;
  where?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
};


export type Query_RootNabu_Prevalence_Score_Classification_Runs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNabu_ProgramsArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


export type Query_RootNabu_Programs_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


export type Query_RootNabu_PromptsArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


export type Query_RootNabu_Prompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


export type Query_RootNabu_QuotesArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


export type Query_RootNabu_Quotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


export type Query_RootNabu_Quotes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNabu_SegmentsArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};


export type Query_RootNabu_Segments_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};


export type Query_RootNabu_SessionsArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};


export type Query_RootNabu_Sessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};


export type Query_RootNabu_Survey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Nabu_Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Survey_Questions_Order_By>>;
  where?: Maybe<Nabu_Survey_Questions_Bool_Exp>;
};


export type Query_RootNabu_Survey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Survey_Questions_Order_By>>;
  where?: Maybe<Nabu_Survey_Questions_Bool_Exp>;
};


export type Query_RootNabu_SurveysArgs = {
  distinct_on?: Maybe<Array<Nabu_Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Surveys_Order_By>>;
  where?: Maybe<Nabu_Surveys_Bool_Exp>;
};


export type Query_RootNabu_Surveys_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Surveys_Order_By>>;
  where?: Maybe<Nabu_Surveys_Bool_Exp>;
};


export type Query_RootNabu_TurnsArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


export type Query_RootNabu_Turns_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


export type Query_RootNabu_Turns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNabu_UsersArgs = {
  distinct_on?: Maybe<Array<Nabu_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Users_Order_By>>;
  where?: Maybe<Nabu_Users_Bool_Exp>;
};


export type Query_RootNabu_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Users_Order_By>>;
  where?: Maybe<Nabu_Users_Bool_Exp>;
};


export type Query_RootNabu_VoxesArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};


export type Query_RootNabu_Voxes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};


export type Query_RootNabu_Voxes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_ConditionsArgs = {
  distinct_on?: Maybe<Array<Notification_Conditions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Conditions_Order_By>>;
  where?: Maybe<Notification_Conditions_Bool_Exp>;
};


export type Query_RootNotification_Conditions_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Conditions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Conditions_Order_By>>;
  where?: Maybe<Notification_Conditions_Bool_Exp>;
};


export type Query_RootNotification_Conditions_By_PkArgs = {
  value: Notification_Type_Enum;
};


export type Query_RootNotification_OffsetsArgs = {
  distinct_on?: Maybe<Array<Notification_Offsets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Offsets_Order_By>>;
  where?: Maybe<Notification_Offsets_Bool_Exp>;
};


export type Query_RootNotification_Offsets_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Offsets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Offsets_Order_By>>;
  where?: Maybe<Notification_Offsets_Bool_Exp>;
};


export type Query_RootNotification_Offsets_By_PkArgs = {
  value: Notification_Type_Enum;
};


export type Query_RootNotification_TemplatesArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


export type Query_RootNotification_Templates_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


export type Query_RootNotification_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_TypeArgs = {
  distinct_on?: Maybe<Array<Notification_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Type_Order_By>>;
  where?: Maybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Type_Order_By>>;
  where?: Maybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootParticipantArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParticipant_Registration_ViewArgs = {
  distinct_on?: Maybe<Array<Participant_Registration_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Registration_View_Order_By>>;
  where?: Maybe<Participant_Registration_View_Bool_Exp>;
};


export type Query_RootParticipant_Registration_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Registration_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Registration_View_Order_By>>;
  where?: Maybe<Participant_Registration_View_Bool_Exp>;
};


export type Query_RootParticipant_SessionArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


export type Query_RootParticipant_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


export type Query_RootParticipant_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProgramArgs = {
  distinct_on?: Maybe<Array<Program_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Program_Order_By>>;
  where?: Maybe<Program_Bool_Exp>;
};


export type Query_RootProgram_AggregateArgs = {
  distinct_on?: Maybe<Array<Program_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Program_Order_By>>;
  where?: Maybe<Program_Bool_Exp>;
};


export type Query_RootProgram_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPromptsArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};


export type Query_RootPrompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};


export type Query_RootPrompts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuestion_TypeArgs = {
  distinct_on?: Maybe<Array<Question_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Type_Order_By>>;
  where?: Maybe<Question_Type_Bool_Exp>;
};


export type Query_RootQuestion_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Type_Order_By>>;
  where?: Maybe<Question_Type_Bool_Exp>;
};


export type Query_RootQuestion_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootRecording_SessionArgs = {
  distinct_on?: Maybe<Array<Recording_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recording_Session_Order_By>>;
  where?: Maybe<Recording_Session_Bool_Exp>;
};


export type Query_RootRecording_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Recording_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recording_Session_Order_By>>;
  where?: Maybe<Recording_Session_Bool_Exp>;
};


export type Query_RootRecording_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRoleArgs = {
  distinct_on?: Maybe<Array<Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Role_Order_By>>;
  where?: Maybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: Maybe<Array<Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Role_Order_By>>;
  where?: Maybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScriptsArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


export type Query_RootScripts_AggregateArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


export type Query_RootScripts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSessionArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


export type Query_RootSession_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


export type Query_RootSession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSession_With_Participant_CountArgs = {
  distinct_on?: Maybe<Array<Session_With_Participant_Count_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_With_Participant_Count_Order_By>>;
  where?: Maybe<Session_With_Participant_Count_Bool_Exp>;
};


export type Query_RootSession_With_Participant_Count_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_With_Participant_Count_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_With_Participant_Count_Order_By>>;
  where?: Maybe<Session_With_Participant_Count_Bool_Exp>;
};


export type Query_RootSessions_Info_ViewArgs = {
  distinct_on?: Maybe<Array<Sessions_Info_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Info_View_Order_By>>;
  where?: Maybe<Sessions_Info_View_Bool_Exp>;
};


export type Query_RootSessions_Info_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Info_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Info_View_Order_By>>;
  where?: Maybe<Sessions_Info_View_Bool_Exp>;
};


export type Query_RootSpeech_PhrasesArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Order_By>>;
  where?: Maybe<Speech_Phrases_Bool_Exp>;
};


export type Query_RootSpeech_Phrases_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Order_By>>;
  where?: Maybe<Speech_Phrases_Bool_Exp>;
};


export type Query_RootSpeech_Phrases_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSpeech_Phrases_SessionArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


export type Query_RootSpeech_Phrases_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


export type Query_RootSpeech_Phrases_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSurvey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


export type Query_RootSurvey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


export type Query_RootSurvey_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSurveysArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};


export type Query_RootSurveys_AggregateArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};


export type Query_RootSurveys_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_LoginArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};


export type Query_RootUser_Login_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};


export type Query_RootUser_Login_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_PresenceArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


export type Query_RootUser_Presence_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


export type Query_RootUser_Presence_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_RoleArgs = {
  distinct_on?: Maybe<Array<User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Role_Order_By>>;
  where?: Maybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Role_Order_By>>;
  where?: Maybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideo_SessionArgs = {
  distinct_on?: Maybe<Array<Video_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Video_Session_Order_By>>;
  where?: Maybe<Video_Session_Bool_Exp>;
};


export type Query_RootVideo_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Video_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Video_Session_Order_By>>;
  where?: Maybe<Video_Session_Bool_Exp>;
};


export type Query_RootVideo_Session_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "question_type" */
export type Question_Type = {
  __typename?: 'question_type';
  comment?: Maybe<Scalars['String']>;
  /** An array relationship */
  survey_questions: Array<Survey_Questions>;
  /** An aggregate relationship */
  survey_questions_aggregate: Survey_Questions_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "question_type" */
export type Question_TypeSurvey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


/** columns and relationships of "question_type" */
export type Question_TypeSurvey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};

/** aggregated selection of "question_type" */
export type Question_Type_Aggregate = {
  __typename?: 'question_type_aggregate';
  aggregate?: Maybe<Question_Type_Aggregate_Fields>;
  nodes: Array<Question_Type>;
};

/** aggregate fields of "question_type" */
export type Question_Type_Aggregate_Fields = {
  __typename?: 'question_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Question_Type_Max_Fields>;
  min?: Maybe<Question_Type_Min_Fields>;
};


/** aggregate fields of "question_type" */
export type Question_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Question_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_type". All fields are combined with a logical 'AND'. */
export type Question_Type_Bool_Exp = {
  _and?: Maybe<Array<Question_Type_Bool_Exp>>;
  _not?: Maybe<Question_Type_Bool_Exp>;
  _or?: Maybe<Array<Question_Type_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  survey_questions?: Maybe<Survey_Questions_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_type" */
export enum Question_Type_Constraint {
  /** unique or primary key constraint */
  QuestionTypePkey = 'question_type_pkey'
}

export enum Question_Type_Enum {
  /** A yes–no question */
  BinaryQuestion = 'BINARY_QUESTION',
  /** Question that has a five point scale as answer */
  FivePointScale = 'FIVE_POINT_SCALE'
}

/** Boolean expression to compare columns of type "question_type_enum". All fields are combined with logical 'AND'. */
export type Question_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Question_Type_Enum>;
  _in?: Maybe<Array<Question_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Question_Type_Enum>;
  _nin?: Maybe<Array<Question_Type_Enum>>;
};

/** input type for inserting data into table "question_type" */
export type Question_Type_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  survey_questions?: Maybe<Survey_Questions_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Type_Max_Fields = {
  __typename?: 'question_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Question_Type_Min_Fields = {
  __typename?: 'question_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_type" */
export type Question_Type_Mutation_Response = {
  __typename?: 'question_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Type>;
};

/** input type for inserting object relation for remote table "question_type" */
export type Question_Type_Obj_Rel_Insert_Input = {
  data: Question_Type_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Question_Type_On_Conflict>;
};

/** on conflict condition type for table "question_type" */
export type Question_Type_On_Conflict = {
  constraint: Question_Type_Constraint;
  update_columns?: Array<Question_Type_Update_Column>;
  where?: Maybe<Question_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "question_type". */
export type Question_Type_Order_By = {
  comment?: Maybe<Order_By>;
  survey_questions_aggregate?: Maybe<Survey_Questions_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: question_type */
export type Question_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "question_type" */
export enum Question_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "question_type" */
export type Question_Type_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "question_type" */
export enum Question_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "recording_session" */
export type Recording_Session = {
  __typename?: 'recording_session';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  output_directory?: Maybe<Scalars['String']>;
  resource_id: Scalars['String'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  sid: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "recording_session" */
export type Recording_Session_Aggregate = {
  __typename?: 'recording_session_aggregate';
  aggregate?: Maybe<Recording_Session_Aggregate_Fields>;
  nodes: Array<Recording_Session>;
};

/** aggregate fields of "recording_session" */
export type Recording_Session_Aggregate_Fields = {
  __typename?: 'recording_session_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Recording_Session_Max_Fields>;
  min?: Maybe<Recording_Session_Min_Fields>;
};


/** aggregate fields of "recording_session" */
export type Recording_Session_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Recording_Session_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "recording_session". All fields are combined with a logical 'AND'. */
export type Recording_Session_Bool_Exp = {
  _and?: Maybe<Array<Recording_Session_Bool_Exp>>;
  _not?: Maybe<Recording_Session_Bool_Exp>;
  _or?: Maybe<Array<Recording_Session_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  output_directory?: Maybe<String_Comparison_Exp>;
  resource_id?: Maybe<String_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  sid?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "recording_session" */
export enum Recording_Session_Constraint {
  /** unique or primary key constraint */
  RecordingSessionPkey = 'recording_session_pkey',
  /** unique or primary key constraint */
  RecordingSessionSessionIdKey = 'recording_session_session_id_key'
}

/** input type for inserting data into table "recording_session" */
export type Recording_Session_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  output_directory?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  sid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Recording_Session_Max_Fields = {
  __typename?: 'recording_session_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  output_directory?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  sid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Recording_Session_Min_Fields = {
  __typename?: 'recording_session_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  output_directory?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  sid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "recording_session" */
export type Recording_Session_Mutation_Response = {
  __typename?: 'recording_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recording_Session>;
};

/** input type for inserting object relation for remote table "recording_session" */
export type Recording_Session_Obj_Rel_Insert_Input = {
  data: Recording_Session_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Recording_Session_On_Conflict>;
};

/** on conflict condition type for table "recording_session" */
export type Recording_Session_On_Conflict = {
  constraint: Recording_Session_Constraint;
  update_columns?: Array<Recording_Session_Update_Column>;
  where?: Maybe<Recording_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "recording_session". */
export type Recording_Session_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  output_directory?: Maybe<Order_By>;
  resource_id?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  sid?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: recording_session */
export type Recording_Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "recording_session" */
export enum Recording_Session_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OutputDirectory = 'output_directory',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Sid = 'sid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "recording_session" */
export type Recording_Session_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  output_directory?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  sid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "recording_session" */
export enum Recording_Session_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OutputDirectory = 'output_directory',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Sid = 'sid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: Maybe<Array<Role_Bool_Exp>>;
  _not?: Maybe<Role_Bool_Exp>;
  _or?: Maybe<Array<Role_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "role" */
export enum Role_Constraint {
  /** unique or primary key constraint */
  RolePkey = 'role_pkey'
}

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** on conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: Maybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "role" */
export enum Role_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "role" */
export enum Role_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "scripts" */
export type Scripts = {
  __typename?: 'scripts';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  media?: Maybe<Media>;
  media_id?: Maybe<Scalars['uuid']>;
  order: Scalars['Int'];
  preferences?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  prompts: Array<Prompts>;
  /** An aggregate relationship */
  prompts_aggregate: Prompts_Aggregate;
  segment_name: Scalars['String'];
  segment_type: Scalars['String'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "scripts" */
export type ScriptsPreferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "scripts" */
export type ScriptsPromptsArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsPrompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};

/** aggregated selection of "scripts" */
export type Scripts_Aggregate = {
  __typename?: 'scripts_aggregate';
  aggregate?: Maybe<Scripts_Aggregate_Fields>;
  nodes: Array<Scripts>;
};

/** aggregate fields of "scripts" */
export type Scripts_Aggregate_Fields = {
  __typename?: 'scripts_aggregate_fields';
  avg?: Maybe<Scripts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Scripts_Max_Fields>;
  min?: Maybe<Scripts_Min_Fields>;
  stddev?: Maybe<Scripts_Stddev_Fields>;
  stddev_pop?: Maybe<Scripts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scripts_Stddev_Samp_Fields>;
  sum?: Maybe<Scripts_Sum_Fields>;
  var_pop?: Maybe<Scripts_Var_Pop_Fields>;
  var_samp?: Maybe<Scripts_Var_Samp_Fields>;
  variance?: Maybe<Scripts_Variance_Fields>;
};


/** aggregate fields of "scripts" */
export type Scripts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Scripts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scripts" */
export type Scripts_Aggregate_Order_By = {
  avg?: Maybe<Scripts_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Scripts_Max_Order_By>;
  min?: Maybe<Scripts_Min_Order_By>;
  stddev?: Maybe<Scripts_Stddev_Order_By>;
  stddev_pop?: Maybe<Scripts_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Scripts_Stddev_Samp_Order_By>;
  sum?: Maybe<Scripts_Sum_Order_By>;
  var_pop?: Maybe<Scripts_Var_Pop_Order_By>;
  var_samp?: Maybe<Scripts_Var_Samp_Order_By>;
  variance?: Maybe<Scripts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scripts_Append_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "scripts" */
export type Scripts_Arr_Rel_Insert_Input = {
  data: Array<Scripts_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Scripts_On_Conflict>;
};

/** aggregate avg on columns */
export type Scripts_Avg_Fields = {
  __typename?: 'scripts_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scripts" */
export type Scripts_Avg_Order_By = {
  order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scripts". All fields are combined with a logical 'AND'. */
export type Scripts_Bool_Exp = {
  _and?: Maybe<Array<Scripts_Bool_Exp>>;
  _not?: Maybe<Scripts_Bool_Exp>;
  _or?: Maybe<Array<Scripts_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  media?: Maybe<Media_Bool_Exp>;
  media_id?: Maybe<Uuid_Comparison_Exp>;
  order?: Maybe<Int_Comparison_Exp>;
  preferences?: Maybe<Jsonb_Comparison_Exp>;
  prompts?: Maybe<Prompts_Bool_Exp>;
  segment_name?: Maybe<String_Comparison_Exp>;
  segment_type?: Maybe<String_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scripts" */
export enum Scripts_Constraint {
  /** unique or primary key constraint */
  ScriptsPkey = 'scripts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scripts_Delete_At_Path_Input = {
  preferences?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scripts_Delete_Elem_Input = {
  preferences?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scripts_Delete_Key_Input = {
  preferences?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "scripts" */
export type Scripts_Inc_Input = {
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "scripts" */
export type Scripts_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media?: Maybe<Media_Obj_Rel_Insert_Input>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  prompts?: Maybe<Prompts_Arr_Rel_Insert_Input>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Scripts_Max_Fields = {
  __typename?: 'scripts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "scripts" */
export type Scripts_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Scripts_Min_Fields = {
  __typename?: 'scripts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "scripts" */
export type Scripts_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "scripts" */
export type Scripts_Mutation_Response = {
  __typename?: 'scripts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scripts>;
};

/** input type for inserting object relation for remote table "scripts" */
export type Scripts_Obj_Rel_Insert_Input = {
  data: Scripts_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Scripts_On_Conflict>;
};

/** on conflict condition type for table "scripts" */
export type Scripts_On_Conflict = {
  constraint: Scripts_Constraint;
  update_columns?: Array<Scripts_Update_Column>;
  where?: Maybe<Scripts_Bool_Exp>;
};

/** Ordering options when selecting data from "scripts". */
export type Scripts_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  media?: Maybe<Media_Order_By>;
  media_id?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  preferences?: Maybe<Order_By>;
  prompts_aggregate?: Maybe<Prompts_Aggregate_Order_By>;
  segment_name?: Maybe<Order_By>;
  segment_type?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: scripts */
export type Scripts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scripts_Prepend_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "scripts" */
export enum Scripts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  Order = 'order',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  SegmentName = 'segment_name',
  /** column name */
  SegmentType = 'segment_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "scripts" */
export type Scripts_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  media_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  segment_name?: Maybe<Scalars['String']>;
  segment_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Scripts_Stddev_Fields = {
  __typename?: 'scripts_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scripts" */
export type Scripts_Stddev_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scripts_Stddev_Pop_Fields = {
  __typename?: 'scripts_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "scripts" */
export type Scripts_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scripts_Stddev_Samp_Fields = {
  __typename?: 'scripts_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "scripts" */
export type Scripts_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Scripts_Sum_Fields = {
  __typename?: 'scripts_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scripts" */
export type Scripts_Sum_Order_By = {
  order?: Maybe<Order_By>;
};

/** update columns of table "scripts" */
export enum Scripts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  Order = 'order',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  SegmentName = 'segment_name',
  /** column name */
  SegmentType = 'segment_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Scripts_Var_Pop_Fields = {
  __typename?: 'scripts_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "scripts" */
export type Scripts_Var_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scripts_Var_Samp_Fields = {
  __typename?: 'scripts_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "scripts" */
export type Scripts_Var_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Scripts_Variance_Fields = {
  __typename?: 'scripts_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scripts" */
export type Scripts_Variance_Order_By = {
  order?: Maybe<Order_By>;
};

/** columns and relationships of "session" */
export type Session = {
  __typename?: 'session';
  /** An array relationship */
  active_participants: Array<User_Presence>;
  /** An aggregate relationship */
  active_participants_aggregate: User_Presence_Aggregate;
  /** An object relationship */
  base_session?: Maybe<Session>;
  base_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  date_time: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  event: Array<Event>;
  /** An aggregate relationship */
  event_aggregate: Event_Aggregate;
  id: Scalars['uuid'];
  is_multigroup: Scalars['Boolean'];
  is_template: Scalars['Boolean'];
  is_test: Scalars['Boolean'];
  max_participant_limit: Scalars['Int'];
  /** An array relationship */
  notification_templates: Array<Notification_Templates>;
  /** An aggregate relationship */
  notification_templates_aggregate: Notification_Templates_Aggregate;
  /** An array relationship */
  participant_session: Array<Participant_Session>;
  /** An aggregate relationship */
  participant_session_aggregate: Participant_Session_Aggregate;
  preferences?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  program?: Maybe<Program>;
  program_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recording_session?: Maybe<Recording_Session>;
  /** An array relationship */
  script: Array<Scripts>;
  /** An aggregate relationship */
  script_aggregate: Scripts_Aggregate;
  session_name: Scalars['String'];
  /** An array relationship */
  session_phrases: Array<Speech_Phrases_Session>;
  /** An aggregate relationship */
  session_phrases_aggregate: Speech_Phrases_Session_Aggregate;
  /** An array relationship */
  subgroups: Array<Session>;
  /** An aggregate relationship */
  subgroups_aggregate: Session_Aggregate;
  /** fetch data from the table: "surveys" */
  surveys: Array<Surveys>;
  /** An aggregate relationship */
  surveys_aggregate: Surveys_Aggregate;
  /** An object relationship */
  template?: Maybe<Session>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "session" */
export type SessionActive_ParticipantsArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionActive_Participants_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionEventArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionEvent_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionNotification_TemplatesArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionNotification_Templates_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionParticipant_SessionArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionParticipant_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionPreferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "session" */
export type SessionScriptArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionScript_AggregateArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSession_PhrasesArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSession_Phrases_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSubgroupsArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSubgroups_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSurveysArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};


/** columns and relationships of "session" */
export type SessionSurveys_AggregateArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};

/** aggregated selection of "session" */
export type Session_Aggregate = {
  __typename?: 'session_aggregate';
  aggregate?: Maybe<Session_Aggregate_Fields>;
  nodes: Array<Session>;
};

/** aggregate fields of "session" */
export type Session_Aggregate_Fields = {
  __typename?: 'session_aggregate_fields';
  avg?: Maybe<Session_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Session_Max_Fields>;
  min?: Maybe<Session_Min_Fields>;
  stddev?: Maybe<Session_Stddev_Fields>;
  stddev_pop?: Maybe<Session_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Session_Stddev_Samp_Fields>;
  sum?: Maybe<Session_Sum_Fields>;
  var_pop?: Maybe<Session_Var_Pop_Fields>;
  var_samp?: Maybe<Session_Var_Samp_Fields>;
  variance?: Maybe<Session_Variance_Fields>;
};


/** aggregate fields of "session" */
export type Session_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Session_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "session" */
export type Session_Aggregate_Order_By = {
  avg?: Maybe<Session_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Session_Max_Order_By>;
  min?: Maybe<Session_Min_Order_By>;
  stddev?: Maybe<Session_Stddev_Order_By>;
  stddev_pop?: Maybe<Session_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Session_Stddev_Samp_Order_By>;
  sum?: Maybe<Session_Sum_Order_By>;
  var_pop?: Maybe<Session_Var_Pop_Order_By>;
  var_samp?: Maybe<Session_Var_Samp_Order_By>;
  variance?: Maybe<Session_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Session_Append_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "session" */
export type Session_Arr_Rel_Insert_Input = {
  data: Array<Session_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Session_On_Conflict>;
};

/** aggregate avg on columns */
export type Session_Avg_Fields = {
  __typename?: 'session_avg_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "session" */
export type Session_Avg_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "session". All fields are combined with a logical 'AND'. */
export type Session_Bool_Exp = {
  _and?: Maybe<Array<Session_Bool_Exp>>;
  _not?: Maybe<Session_Bool_Exp>;
  _or?: Maybe<Array<Session_Bool_Exp>>;
  active_participants?: Maybe<User_Presence_Bool_Exp>;
  base_session?: Maybe<Session_Bool_Exp>;
  base_session_id?: Maybe<Uuid_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  date_time?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  event?: Maybe<Event_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_multigroup?: Maybe<Boolean_Comparison_Exp>;
  is_template?: Maybe<Boolean_Comparison_Exp>;
  is_test?: Maybe<Boolean_Comparison_Exp>;
  max_participant_limit?: Maybe<Int_Comparison_Exp>;
  notification_templates?: Maybe<Notification_Templates_Bool_Exp>;
  participant_session?: Maybe<Participant_Session_Bool_Exp>;
  preferences?: Maybe<Jsonb_Comparison_Exp>;
  program?: Maybe<Program_Bool_Exp>;
  program_id?: Maybe<Uuid_Comparison_Exp>;
  recording_session?: Maybe<Recording_Session_Bool_Exp>;
  script?: Maybe<Scripts_Bool_Exp>;
  session_name?: Maybe<String_Comparison_Exp>;
  session_phrases?: Maybe<Speech_Phrases_Session_Bool_Exp>;
  subgroups?: Maybe<Session_Bool_Exp>;
  surveys?: Maybe<Surveys_Bool_Exp>;
  template?: Maybe<Session_Bool_Exp>;
  template_id?: Maybe<Uuid_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "session" */
export enum Session_Constraint {
  /** unique or primary key constraint */
  SessionPkey = 'session_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Session_Delete_At_Path_Input = {
  preferences?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Session_Delete_Elem_Input = {
  preferences?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Session_Delete_Key_Input = {
  preferences?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "session" */
export type Session_Inc_Input = {
  max_participant_limit?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "session" */
export type Session_Insert_Input = {
  active_participants?: Maybe<User_Presence_Arr_Rel_Insert_Input>;
  base_session?: Maybe<Session_Obj_Rel_Insert_Input>;
  base_session_id?: Maybe<Scalars['uuid']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Event_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  is_multigroup?: Maybe<Scalars['Boolean']>;
  is_template?: Maybe<Scalars['Boolean']>;
  is_test?: Maybe<Scalars['Boolean']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  notification_templates?: Maybe<Notification_Templates_Arr_Rel_Insert_Input>;
  participant_session?: Maybe<Participant_Session_Arr_Rel_Insert_Input>;
  preferences?: Maybe<Scalars['jsonb']>;
  program?: Maybe<Program_Obj_Rel_Insert_Input>;
  program_id?: Maybe<Scalars['uuid']>;
  recording_session?: Maybe<Recording_Session_Obj_Rel_Insert_Input>;
  script?: Maybe<Scripts_Arr_Rel_Insert_Input>;
  session_name?: Maybe<Scalars['String']>;
  session_phrases?: Maybe<Speech_Phrases_Session_Arr_Rel_Insert_Input>;
  subgroups?: Maybe<Session_Arr_Rel_Insert_Input>;
  surveys?: Maybe<Surveys_Arr_Rel_Insert_Input>;
  template?: Maybe<Session_Obj_Rel_Insert_Input>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Session_Max_Fields = {
  __typename?: 'session_max_fields';
  base_session_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "session" */
export type Session_Max_Order_By = {
  base_session_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Session_Min_Fields = {
  __typename?: 'session_min_fields';
  base_session_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "session" */
export type Session_Min_Order_By = {
  base_session_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "session" */
export type Session_Mutation_Response = {
  __typename?: 'session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Session>;
};

/** input type for inserting object relation for remote table "session" */
export type Session_Obj_Rel_Insert_Input = {
  data: Session_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Session_On_Conflict>;
};

/** on conflict condition type for table "session" */
export type Session_On_Conflict = {
  constraint: Session_Constraint;
  update_columns?: Array<Session_Update_Column>;
  where?: Maybe<Session_Bool_Exp>;
};

/** Ordering options when selecting data from "session". */
export type Session_Order_By = {
  active_participants_aggregate?: Maybe<User_Presence_Aggregate_Order_By>;
  base_session?: Maybe<Session_Order_By>;
  base_session_id?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event_aggregate?: Maybe<Event_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  is_multigroup?: Maybe<Order_By>;
  is_template?: Maybe<Order_By>;
  is_test?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  notification_templates_aggregate?: Maybe<Notification_Templates_Aggregate_Order_By>;
  participant_session_aggregate?: Maybe<Participant_Session_Aggregate_Order_By>;
  preferences?: Maybe<Order_By>;
  program?: Maybe<Program_Order_By>;
  program_id?: Maybe<Order_By>;
  recording_session?: Maybe<Recording_Session_Order_By>;
  script_aggregate?: Maybe<Scripts_Aggregate_Order_By>;
  session_name?: Maybe<Order_By>;
  session_phrases_aggregate?: Maybe<Speech_Phrases_Session_Aggregate_Order_By>;
  subgroups_aggregate?: Maybe<Session_Aggregate_Order_By>;
  surveys_aggregate?: Maybe<Surveys_Aggregate_Order_By>;
  template?: Maybe<Session_Order_By>;
  template_id?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: session */
export type Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Session_Prepend_Input = {
  preferences?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "session" */
export enum Session_Select_Column {
  /** column name */
  BaseSessionId = 'base_session_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultigroup = 'is_multigroup',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  MaxParticipantLimit = 'max_participant_limit',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  SessionName = 'session_name',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "session" */
export type Session_Set_Input = {
  base_session_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_multigroup?: Maybe<Scalars['Boolean']>;
  is_template?: Maybe<Scalars['Boolean']>;
  is_test?: Maybe<Scalars['Boolean']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['jsonb']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Session_Stddev_Fields = {
  __typename?: 'session_stddev_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "session" */
export type Session_Stddev_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Session_Stddev_Pop_Fields = {
  __typename?: 'session_stddev_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "session" */
export type Session_Stddev_Pop_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Session_Stddev_Samp_Fields = {
  __typename?: 'session_stddev_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "session" */
export type Session_Stddev_Samp_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Session_Sum_Fields = {
  __typename?: 'session_sum_fields';
  max_participant_limit?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "session" */
export type Session_Sum_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** update columns of table "session" */
export enum Session_Update_Column {
  /** column name */
  BaseSessionId = 'base_session_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultigroup = 'is_multigroup',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  MaxParticipantLimit = 'max_participant_limit',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  SessionName = 'session_name',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Session_Var_Pop_Fields = {
  __typename?: 'session_var_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "session" */
export type Session_Var_Pop_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Session_Var_Samp_Fields = {
  __typename?: 'session_var_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "session" */
export type Session_Var_Samp_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Session_Variance_Fields = {
  __typename?: 'session_variance_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "session" */
export type Session_Variance_Order_By = {
  max_participant_limit?: Maybe<Order_By>;
};

/** columns and relationships of "session_with_participant_count" */
export type Session_With_Participant_Count = {
  __typename?: 'session_with_participant_count';
  company_id?: Maybe<Scalars['uuid']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  has_space?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "session_with_participant_count" */
export type Session_With_Participant_Count_Aggregate = {
  __typename?: 'session_with_participant_count_aggregate';
  aggregate?: Maybe<Session_With_Participant_Count_Aggregate_Fields>;
  nodes: Array<Session_With_Participant_Count>;
};

/** aggregate fields of "session_with_participant_count" */
export type Session_With_Participant_Count_Aggregate_Fields = {
  __typename?: 'session_with_participant_count_aggregate_fields';
  avg?: Maybe<Session_With_Participant_Count_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Session_With_Participant_Count_Max_Fields>;
  min?: Maybe<Session_With_Participant_Count_Min_Fields>;
  stddev?: Maybe<Session_With_Participant_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Session_With_Participant_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Session_With_Participant_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Session_With_Participant_Count_Sum_Fields>;
  var_pop?: Maybe<Session_With_Participant_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Session_With_Participant_Count_Var_Samp_Fields>;
  variance?: Maybe<Session_With_Participant_Count_Variance_Fields>;
};


/** aggregate fields of "session_with_participant_count" */
export type Session_With_Participant_Count_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Session_With_Participant_Count_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Session_With_Participant_Count_Avg_Fields = {
  __typename?: 'session_with_participant_count_avg_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "session_with_participant_count". All fields are combined with a logical 'AND'. */
export type Session_With_Participant_Count_Bool_Exp = {
  _and?: Maybe<Array<Session_With_Participant_Count_Bool_Exp>>;
  _not?: Maybe<Session_With_Participant_Count_Bool_Exp>;
  _or?: Maybe<Array<Session_With_Participant_Count_Bool_Exp>>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  date_time?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  has_space?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  max_participant_limit?: Maybe<Int_Comparison_Exp>;
  participant_count?: Maybe<Bigint_Comparison_Exp>;
  program_id?: Maybe<Uuid_Comparison_Exp>;
  session_name?: Maybe<String_Comparison_Exp>;
  spots_remaining?: Maybe<Bigint_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Session_With_Participant_Count_Max_Fields = {
  __typename?: 'session_with_participant_count_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Session_With_Participant_Count_Min_Fields = {
  __typename?: 'session_with_participant_count_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "session_with_participant_count". */
export type Session_With_Participant_Count_Order_By = {
  company_id?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  has_space?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  participant_count?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  spots_remaining?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
};

/** select columns of table "session_with_participant_count" */
export enum Session_With_Participant_Count_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HasSpace = 'has_space',
  /** column name */
  Id = 'id',
  /** column name */
  MaxParticipantLimit = 'max_participant_limit',
  /** column name */
  ParticipantCount = 'participant_count',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  SessionName = 'session_name',
  /** column name */
  SpotsRemaining = 'spots_remaining',
  /** column name */
  Timezone = 'timezone'
}

/** aggregate stddev on columns */
export type Session_With_Participant_Count_Stddev_Fields = {
  __typename?: 'session_with_participant_count_stddev_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Session_With_Participant_Count_Stddev_Pop_Fields = {
  __typename?: 'session_with_participant_count_stddev_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Session_With_Participant_Count_Stddev_Samp_Fields = {
  __typename?: 'session_with_participant_count_stddev_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Session_With_Participant_Count_Sum_Fields = {
  __typename?: 'session_with_participant_count_sum_fields';
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Session_With_Participant_Count_Var_Pop_Fields = {
  __typename?: 'session_with_participant_count_var_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Session_With_Participant_Count_Var_Samp_Fields = {
  __typename?: 'session_with_participant_count_var_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Session_With_Participant_Count_Variance_Fields = {
  __typename?: 'session_with_participant_count_variance_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sessions_info_view" */
export type Sessions_Info_View = {
  __typename?: 'sessions_info_view';
  company_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  has_space?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  program_name?: Maybe<Scalars['String']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "sessions_info_view" */
export type Sessions_Info_View_Aggregate = {
  __typename?: 'sessions_info_view_aggregate';
  aggregate?: Maybe<Sessions_Info_View_Aggregate_Fields>;
  nodes: Array<Sessions_Info_View>;
};

/** aggregate fields of "sessions_info_view" */
export type Sessions_Info_View_Aggregate_Fields = {
  __typename?: 'sessions_info_view_aggregate_fields';
  avg?: Maybe<Sessions_Info_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sessions_Info_View_Max_Fields>;
  min?: Maybe<Sessions_Info_View_Min_Fields>;
  stddev?: Maybe<Sessions_Info_View_Stddev_Fields>;
  stddev_pop?: Maybe<Sessions_Info_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sessions_Info_View_Stddev_Samp_Fields>;
  sum?: Maybe<Sessions_Info_View_Sum_Fields>;
  var_pop?: Maybe<Sessions_Info_View_Var_Pop_Fields>;
  var_samp?: Maybe<Sessions_Info_View_Var_Samp_Fields>;
  variance?: Maybe<Sessions_Info_View_Variance_Fields>;
};


/** aggregate fields of "sessions_info_view" */
export type Sessions_Info_View_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Sessions_Info_View_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sessions_Info_View_Avg_Fields = {
  __typename?: 'sessions_info_view_avg_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sessions_info_view". All fields are combined with a logical 'AND'. */
export type Sessions_Info_View_Bool_Exp = {
  _and?: Maybe<Array<Sessions_Info_View_Bool_Exp>>;
  _not?: Maybe<Sessions_Info_View_Bool_Exp>;
  _or?: Maybe<Array<Sessions_Info_View_Bool_Exp>>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  company_name?: Maybe<String_Comparison_Exp>;
  date_time?: Maybe<Timestamptz_Comparison_Exp>;
  finished_at?: Maybe<Timestamptz_Comparison_Exp>;
  has_space?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  max_participant_limit?: Maybe<Int_Comparison_Exp>;
  participant_count?: Maybe<Bigint_Comparison_Exp>;
  program_id?: Maybe<Uuid_Comparison_Exp>;
  program_name?: Maybe<String_Comparison_Exp>;
  session_name?: Maybe<String_Comparison_Exp>;
  spots_remaining?: Maybe<Bigint_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Sessions_Info_View_Max_Fields = {
  __typename?: 'sessions_info_view_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  program_name?: Maybe<Scalars['String']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sessions_Info_View_Min_Fields = {
  __typename?: 'sessions_info_view_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  program_id?: Maybe<Scalars['uuid']>;
  program_name?: Maybe<Scalars['String']>;
  session_name?: Maybe<Scalars['String']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
  timezone?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "sessions_info_view". */
export type Sessions_Info_View_Order_By = {
  company_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  date_time?: Maybe<Order_By>;
  finished_at?: Maybe<Order_By>;
  has_space?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  max_participant_limit?: Maybe<Order_By>;
  participant_count?: Maybe<Order_By>;
  program_id?: Maybe<Order_By>;
  program_name?: Maybe<Order_By>;
  session_name?: Maybe<Order_By>;
  spots_remaining?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
};

/** select columns of table "sessions_info_view" */
export enum Sessions_Info_View_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  HasSpace = 'has_space',
  /** column name */
  Id = 'id',
  /** column name */
  MaxParticipantLimit = 'max_participant_limit',
  /** column name */
  ParticipantCount = 'participant_count',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  ProgramName = 'program_name',
  /** column name */
  SessionName = 'session_name',
  /** column name */
  SpotsRemaining = 'spots_remaining',
  /** column name */
  Timezone = 'timezone'
}

/** aggregate stddev on columns */
export type Sessions_Info_View_Stddev_Fields = {
  __typename?: 'sessions_info_view_stddev_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sessions_Info_View_Stddev_Pop_Fields = {
  __typename?: 'sessions_info_view_stddev_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sessions_Info_View_Stddev_Samp_Fields = {
  __typename?: 'sessions_info_view_stddev_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Sessions_Info_View_Sum_Fields = {
  __typename?: 'sessions_info_view_sum_fields';
  max_participant_limit?: Maybe<Scalars['Int']>;
  participant_count?: Maybe<Scalars['bigint']>;
  spots_remaining?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Sessions_Info_View_Var_Pop_Fields = {
  __typename?: 'sessions_info_view_var_pop_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sessions_Info_View_Var_Samp_Fields = {
  __typename?: 'sessions_info_view_var_samp_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sessions_Info_View_Variance_Fields = {
  __typename?: 'sessions_info_view_variance_fields';
  max_participant_limit?: Maybe<Scalars['Float']>;
  participant_count?: Maybe<Scalars['Float']>;
  spots_remaining?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "speech_phrases" */
export type Speech_Phrases = {
  __typename?: 'speech_phrases';
  category: Scalars['String'];
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_shared: Scalars['Boolean'];
  preload?: Maybe<Scalars['Boolean']>;
  priority: Scalars['Int'];
  /** An array relationship */
  speech_phrases_sessions: Array<Speech_Phrases_Session>;
  /** An aggregate relationship */
  speech_phrases_sessions_aggregate: Speech_Phrases_Session_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "speech_phrases" */
export type Speech_PhrasesSpeech_Phrases_SessionsArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


/** columns and relationships of "speech_phrases" */
export type Speech_PhrasesSpeech_Phrases_Sessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};

/** aggregated selection of "speech_phrases" */
export type Speech_Phrases_Aggregate = {
  __typename?: 'speech_phrases_aggregate';
  aggregate?: Maybe<Speech_Phrases_Aggregate_Fields>;
  nodes: Array<Speech_Phrases>;
};

/** aggregate fields of "speech_phrases" */
export type Speech_Phrases_Aggregate_Fields = {
  __typename?: 'speech_phrases_aggregate_fields';
  avg?: Maybe<Speech_Phrases_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Speech_Phrases_Max_Fields>;
  min?: Maybe<Speech_Phrases_Min_Fields>;
  stddev?: Maybe<Speech_Phrases_Stddev_Fields>;
  stddev_pop?: Maybe<Speech_Phrases_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Speech_Phrases_Stddev_Samp_Fields>;
  sum?: Maybe<Speech_Phrases_Sum_Fields>;
  var_pop?: Maybe<Speech_Phrases_Var_Pop_Fields>;
  var_samp?: Maybe<Speech_Phrases_Var_Samp_Fields>;
  variance?: Maybe<Speech_Phrases_Variance_Fields>;
};


/** aggregate fields of "speech_phrases" */
export type Speech_Phrases_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Speech_Phrases_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Speech_Phrases_Avg_Fields = {
  __typename?: 'speech_phrases_avg_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "speech_phrases". All fields are combined with a logical 'AND'. */
export type Speech_Phrases_Bool_Exp = {
  _and?: Maybe<Array<Speech_Phrases_Bool_Exp>>;
  _not?: Maybe<Speech_Phrases_Bool_Exp>;
  _or?: Maybe<Array<Speech_Phrases_Bool_Exp>>;
  category?: Maybe<String_Comparison_Exp>;
  content?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_shared?: Maybe<Boolean_Comparison_Exp>;
  preload?: Maybe<Boolean_Comparison_Exp>;
  priority?: Maybe<Int_Comparison_Exp>;
  speech_phrases_sessions?: Maybe<Speech_Phrases_Session_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "speech_phrases" */
export enum Speech_Phrases_Constraint {
  /** unique or primary key constraint */
  SpeechPhrasesPkey = 'speech_phrases_pkey'
}

/** input type for incrementing numeric columns in table "speech_phrases" */
export type Speech_Phrases_Inc_Input = {
  priority?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "speech_phrases" */
export type Speech_Phrases_Insert_Input = {
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_shared?: Maybe<Scalars['Boolean']>;
  preload?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
  speech_phrases_sessions?: Maybe<Speech_Phrases_Session_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Speech_Phrases_Max_Fields = {
  __typename?: 'speech_phrases_max_fields';
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Speech_Phrases_Min_Fields = {
  __typename?: 'speech_phrases_min_fields';
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "speech_phrases" */
export type Speech_Phrases_Mutation_Response = {
  __typename?: 'speech_phrases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Speech_Phrases>;
};

/** input type for inserting object relation for remote table "speech_phrases" */
export type Speech_Phrases_Obj_Rel_Insert_Input = {
  data: Speech_Phrases_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Speech_Phrases_On_Conflict>;
};

/** on conflict condition type for table "speech_phrases" */
export type Speech_Phrases_On_Conflict = {
  constraint: Speech_Phrases_Constraint;
  update_columns?: Array<Speech_Phrases_Update_Column>;
  where?: Maybe<Speech_Phrases_Bool_Exp>;
};

/** Ordering options when selecting data from "speech_phrases". */
export type Speech_Phrases_Order_By = {
  category?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_shared?: Maybe<Order_By>;
  preload?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  speech_phrases_sessions_aggregate?: Maybe<Speech_Phrases_Session_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: speech_phrases */
export type Speech_Phrases_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "speech_phrases" */
export enum Speech_Phrases_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  Preload = 'preload',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "speech_phrases_session" */
export type Speech_Phrases_Session = {
  __typename?: 'speech_phrases_session';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  /** An object relationship */
  speech_phrase: Speech_Phrases;
  speech_phrase_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "speech_phrases_session" */
export type Speech_Phrases_Session_Aggregate = {
  __typename?: 'speech_phrases_session_aggregate';
  aggregate?: Maybe<Speech_Phrases_Session_Aggregate_Fields>;
  nodes: Array<Speech_Phrases_Session>;
};

/** aggregate fields of "speech_phrases_session" */
export type Speech_Phrases_Session_Aggregate_Fields = {
  __typename?: 'speech_phrases_session_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Speech_Phrases_Session_Max_Fields>;
  min?: Maybe<Speech_Phrases_Session_Min_Fields>;
};


/** aggregate fields of "speech_phrases_session" */
export type Speech_Phrases_Session_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "speech_phrases_session" */
export type Speech_Phrases_Session_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Speech_Phrases_Session_Max_Order_By>;
  min?: Maybe<Speech_Phrases_Session_Min_Order_By>;
};

/** input type for inserting array relation for remote table "speech_phrases_session" */
export type Speech_Phrases_Session_Arr_Rel_Insert_Input = {
  data: Array<Speech_Phrases_Session_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Speech_Phrases_Session_On_Conflict>;
};

/** Boolean expression to filter rows from the table "speech_phrases_session". All fields are combined with a logical 'AND'. */
export type Speech_Phrases_Session_Bool_Exp = {
  _and?: Maybe<Array<Speech_Phrases_Session_Bool_Exp>>;
  _not?: Maybe<Speech_Phrases_Session_Bool_Exp>;
  _or?: Maybe<Array<Speech_Phrases_Session_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  speech_phrase?: Maybe<Speech_Phrases_Bool_Exp>;
  speech_phrase_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "speech_phrases_session" */
export enum Speech_Phrases_Session_Constraint {
  /** unique or primary key constraint */
  SpeechPhrasesSessionPkey = 'speech_phrases_session_pkey'
}

/** input type for inserting data into table "speech_phrases_session" */
export type Speech_Phrases_Session_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  speech_phrase?: Maybe<Speech_Phrases_Obj_Rel_Insert_Input>;
  speech_phrase_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Speech_Phrases_Session_Max_Fields = {
  __typename?: 'speech_phrases_session_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  speech_phrase_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "speech_phrases_session" */
export type Speech_Phrases_Session_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  speech_phrase_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Speech_Phrases_Session_Min_Fields = {
  __typename?: 'speech_phrases_session_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  speech_phrase_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "speech_phrases_session" */
export type Speech_Phrases_Session_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  speech_phrase_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "speech_phrases_session" */
export type Speech_Phrases_Session_Mutation_Response = {
  __typename?: 'speech_phrases_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Speech_Phrases_Session>;
};

/** on conflict condition type for table "speech_phrases_session" */
export type Speech_Phrases_Session_On_Conflict = {
  constraint: Speech_Phrases_Session_Constraint;
  update_columns?: Array<Speech_Phrases_Session_Update_Column>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "speech_phrases_session". */
export type Speech_Phrases_Session_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  speech_phrase?: Maybe<Speech_Phrases_Order_By>;
  speech_phrase_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: speech_phrases_session */
export type Speech_Phrases_Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "speech_phrases_session" */
export enum Speech_Phrases_Session_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SpeechPhraseId = 'speech_phrase_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "speech_phrases_session" */
export type Speech_Phrases_Session_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  speech_phrase_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "speech_phrases_session" */
export enum Speech_Phrases_Session_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SpeechPhraseId = 'speech_phrase_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "speech_phrases" */
export type Speech_Phrases_Set_Input = {
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_shared?: Maybe<Scalars['Boolean']>;
  preload?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Speech_Phrases_Stddev_Fields = {
  __typename?: 'speech_phrases_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Speech_Phrases_Stddev_Pop_Fields = {
  __typename?: 'speech_phrases_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Speech_Phrases_Stddev_Samp_Fields = {
  __typename?: 'speech_phrases_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Speech_Phrases_Sum_Fields = {
  __typename?: 'speech_phrases_sum_fields';
  priority?: Maybe<Scalars['Int']>;
};

/** update columns of table "speech_phrases" */
export enum Speech_Phrases_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  Preload = 'preload',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Speech_Phrases_Var_Pop_Fields = {
  __typename?: 'speech_phrases_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Speech_Phrases_Var_Samp_Fields = {
  __typename?: 'speech_phrases_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Speech_Phrases_Variance_Fields = {
  __typename?: 'speech_phrases_variance_fields';
  priority?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_contact" */
  company_contact: Array<Company_Contact>;
  /** fetch aggregated fields from the table: "company_contact" */
  company_contact_aggregate: Company_Contact_Aggregate;
  /** fetch data from the table: "company_contact" using primary key columns */
  company_contact_by_pk?: Maybe<Company_Contact>;
  /** fetch data from the table: "confirmation_status" */
  confirmation_status: Array<Confirmation_Status>;
  /** fetch aggregated fields from the table: "confirmation_status" */
  confirmation_status_aggregate: Confirmation_Status_Aggregate;
  /** fetch data from the table: "confirmation_status" using primary key columns */
  confirmation_status_by_pk?: Maybe<Confirmation_Status>;
  /** An array relationship */
  event: Array<Event>;
  /** An aggregate relationship */
  event_aggregate: Event_Aggregate;
  /** fetch data from the table: "event" using primary key columns */
  event_by_pk?: Maybe<Event>;
  /** fetch data from the table: "event_type" */
  event_type: Array<Event_Type>;
  /** fetch aggregated fields from the table: "event_type" */
  event_type_aggregate: Event_Type_Aggregate;
  /** fetch data from the table: "event_type" using primary key columns */
  event_type_by_pk?: Maybe<Event_Type>;
  /** fetch data from the table: "historic_events" */
  historic_events: Array<Historic_Events>;
  /** fetch aggregated fields from the table: "historic_events" */
  historic_events_aggregate: Historic_Events_Aggregate;
  /** fetch data from the table: "historic_events" using primary key columns */
  historic_events_by_pk?: Maybe<Historic_Events>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch data from the table: "logs_action" */
  logs_action: Array<Logs_Action>;
  /** fetch aggregated fields from the table: "logs_action" */
  logs_action_aggregate: Logs_Action_Aggregate;
  /** fetch data from the table: "logs_action" using primary key columns */
  logs_action_by_pk?: Maybe<Logs_Action>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table: "nabu.companies" */
  nabu_companies: Array<Nabu_Companies>;
  /** fetch aggregated fields from the table: "nabu.companies" */
  nabu_companies_aggregate: Nabu_Companies_Aggregate;
  /** fetch data from the table: "nabu.feedback" */
  nabu_feedback: Array<Nabu_Feedback>;
  /** fetch aggregated fields from the table: "nabu.feedback" */
  nabu_feedback_aggregate: Nabu_Feedback_Aggregate;
  /** fetch data from the table: "nabu.feedback" using primary key columns */
  nabu_feedback_by_pk?: Maybe<Nabu_Feedback>;
  /** fetch data from the table: "nabu.feedback_type" */
  nabu_feedback_type: Array<Nabu_Feedback_Type>;
  /** fetch aggregated fields from the table: "nabu.feedback_type" */
  nabu_feedback_type_aggregate: Nabu_Feedback_Type_Aggregate;
  /** fetch data from the table: "nabu.feedback_type" using primary key columns */
  nabu_feedback_type_by_pk?: Maybe<Nabu_Feedback_Type>;
  /** fetch data from the table: "nabu.prevalence_score_classification_runs" */
  nabu_prevalence_score_classification_runs: Array<Nabu_Prevalence_Score_Classification_Runs>;
  /** fetch aggregated fields from the table: "nabu.prevalence_score_classification_runs" */
  nabu_prevalence_score_classification_runs_aggregate: Nabu_Prevalence_Score_Classification_Runs_Aggregate;
  /** fetch data from the table: "nabu.prevalence_score_classification_runs" using primary key columns */
  nabu_prevalence_score_classification_runs_by_pk?: Maybe<Nabu_Prevalence_Score_Classification_Runs>;
  /** fetch data from the table: "nabu.programs" */
  nabu_programs: Array<Nabu_Programs>;
  /** fetch aggregated fields from the table: "nabu.programs" */
  nabu_programs_aggregate: Nabu_Programs_Aggregate;
  /** fetch data from the table: "nabu.prompts" */
  nabu_prompts: Array<Nabu_Prompts>;
  /** fetch aggregated fields from the table: "nabu.prompts" */
  nabu_prompts_aggregate: Nabu_Prompts_Aggregate;
  /** fetch data from the table: "nabu.quotes" */
  nabu_quotes: Array<Nabu_Quotes>;
  /** fetch aggregated fields from the table: "nabu.quotes" */
  nabu_quotes_aggregate: Nabu_Quotes_Aggregate;
  /** fetch data from the table: "nabu.quotes" using primary key columns */
  nabu_quotes_by_pk?: Maybe<Nabu_Quotes>;
  /** fetch data from the table: "nabu.segments" */
  nabu_segments: Array<Nabu_Segments>;
  /** fetch aggregated fields from the table: "nabu.segments" */
  nabu_segments_aggregate: Nabu_Segments_Aggregate;
  /** fetch data from the table: "nabu.sessions" */
  nabu_sessions: Array<Nabu_Sessions>;
  /** fetch aggregated fields from the table: "nabu.sessions" */
  nabu_sessions_aggregate: Nabu_Sessions_Aggregate;
  /** fetch data from the table: "nabu.survey_questions" */
  nabu_survey_questions: Array<Nabu_Survey_Questions>;
  /** fetch aggregated fields from the table: "nabu.survey_questions" */
  nabu_survey_questions_aggregate: Nabu_Survey_Questions_Aggregate;
  /** fetch data from the table: "nabu.surveys" */
  nabu_surveys: Array<Nabu_Surveys>;
  /** fetch aggregated fields from the table: "nabu.surveys" */
  nabu_surveys_aggregate: Nabu_Surveys_Aggregate;
  /** fetch data from the table: "nabu.turns" */
  nabu_turns: Array<Nabu_Turns>;
  /** fetch aggregated fields from the table: "nabu.turns" */
  nabu_turns_aggregate: Nabu_Turns_Aggregate;
  /** fetch data from the table: "nabu.turns" using primary key columns */
  nabu_turns_by_pk?: Maybe<Nabu_Turns>;
  /** fetch data from the table: "nabu.users" */
  nabu_users: Array<Nabu_Users>;
  /** fetch aggregated fields from the table: "nabu.users" */
  nabu_users_aggregate: Nabu_Users_Aggregate;
  /** fetch data from the table: "nabu.voxes" */
  nabu_voxes: Array<Nabu_Voxes>;
  /** fetch aggregated fields from the table: "nabu.voxes" */
  nabu_voxes_aggregate: Nabu_Voxes_Aggregate;
  /** fetch data from the table: "nabu.voxes" using primary key columns */
  nabu_voxes_by_pk?: Maybe<Nabu_Voxes>;
  /** fetch data from the table: "notification_conditions" */
  notification_conditions: Array<Notification_Conditions>;
  /** fetch aggregated fields from the table: "notification_conditions" */
  notification_conditions_aggregate: Notification_Conditions_Aggregate;
  /** fetch data from the table: "notification_conditions" using primary key columns */
  notification_conditions_by_pk?: Maybe<Notification_Conditions>;
  /** fetch data from the table: "notification_offsets" */
  notification_offsets: Array<Notification_Offsets>;
  /** fetch aggregated fields from the table: "notification_offsets" */
  notification_offsets_aggregate: Notification_Offsets_Aggregate;
  /** fetch data from the table: "notification_offsets" using primary key columns */
  notification_offsets_by_pk?: Maybe<Notification_Offsets>;
  /** An array relationship */
  notification_templates: Array<Notification_Templates>;
  /** An aggregate relationship */
  notification_templates_aggregate: Notification_Templates_Aggregate;
  /** fetch data from the table: "notification_templates" using primary key columns */
  notification_templates_by_pk?: Maybe<Notification_Templates>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table: "participant" */
  participant: Array<Participant>;
  /** fetch aggregated fields from the table: "participant" */
  participant_aggregate: Participant_Aggregate;
  /** fetch data from the table: "participant" using primary key columns */
  participant_by_pk?: Maybe<Participant>;
  /** fetch data from the table: "participant_registration_view" */
  participant_registration_view: Array<Participant_Registration_View>;
  /** fetch aggregated fields from the table: "participant_registration_view" */
  participant_registration_view_aggregate: Participant_Registration_View_Aggregate;
  /** An array relationship */
  participant_session: Array<Participant_Session>;
  /** An aggregate relationship */
  participant_session_aggregate: Participant_Session_Aggregate;
  /** fetch data from the table: "participant_session" using primary key columns */
  participant_session_by_pk?: Maybe<Participant_Session>;
  /** fetch data from the table: "program" */
  program: Array<Program>;
  /** fetch aggregated fields from the table: "program" */
  program_aggregate: Program_Aggregate;
  /** fetch data from the table: "program" using primary key columns */
  program_by_pk?: Maybe<Program>;
  /** An array relationship */
  prompts: Array<Prompts>;
  /** An aggregate relationship */
  prompts_aggregate: Prompts_Aggregate;
  /** fetch data from the table: "prompts" using primary key columns */
  prompts_by_pk?: Maybe<Prompts>;
  /** fetch data from the table: "question_type" */
  question_type: Array<Question_Type>;
  /** fetch aggregated fields from the table: "question_type" */
  question_type_aggregate: Question_Type_Aggregate;
  /** fetch data from the table: "question_type" using primary key columns */
  question_type_by_pk?: Maybe<Question_Type>;
  /** fetch data from the table: "recording_session" */
  recording_session: Array<Recording_Session>;
  /** fetch aggregated fields from the table: "recording_session" */
  recording_session_aggregate: Recording_Session_Aggregate;
  /** fetch data from the table: "recording_session" using primary key columns */
  recording_session_by_pk?: Maybe<Recording_Session>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "scripts" */
  scripts: Array<Scripts>;
  /** fetch aggregated fields from the table: "scripts" */
  scripts_aggregate: Scripts_Aggregate;
  /** fetch data from the table: "scripts" using primary key columns */
  scripts_by_pk?: Maybe<Scripts>;
  /** An array relationship */
  session: Array<Session>;
  /** An aggregate relationship */
  session_aggregate: Session_Aggregate;
  /** fetch data from the table: "session" using primary key columns */
  session_by_pk?: Maybe<Session>;
  /** fetch data from the table: "session_with_participant_count" */
  session_with_participant_count: Array<Session_With_Participant_Count>;
  /** fetch aggregated fields from the table: "session_with_participant_count" */
  session_with_participant_count_aggregate: Session_With_Participant_Count_Aggregate;
  /** fetch data from the table: "sessions_info_view" */
  sessions_info_view: Array<Sessions_Info_View>;
  /** fetch aggregated fields from the table: "sessions_info_view" */
  sessions_info_view_aggregate: Sessions_Info_View_Aggregate;
  /** fetch data from the table: "speech_phrases" */
  speech_phrases: Array<Speech_Phrases>;
  /** fetch aggregated fields from the table: "speech_phrases" */
  speech_phrases_aggregate: Speech_Phrases_Aggregate;
  /** fetch data from the table: "speech_phrases" using primary key columns */
  speech_phrases_by_pk?: Maybe<Speech_Phrases>;
  /** fetch data from the table: "speech_phrases_session" */
  speech_phrases_session: Array<Speech_Phrases_Session>;
  /** fetch aggregated fields from the table: "speech_phrases_session" */
  speech_phrases_session_aggregate: Speech_Phrases_Session_Aggregate;
  /** fetch data from the table: "speech_phrases_session" using primary key columns */
  speech_phrases_session_by_pk?: Maybe<Speech_Phrases_Session>;
  /** An array relationship */
  survey_questions: Array<Survey_Questions>;
  /** An aggregate relationship */
  survey_questions_aggregate: Survey_Questions_Aggregate;
  /** fetch data from the table: "survey_questions" using primary key columns */
  survey_questions_by_pk?: Maybe<Survey_Questions>;
  /** fetch data from the table: "surveys" */
  surveys: Array<Surveys>;
  /** An aggregate relationship */
  surveys_aggregate: Surveys_Aggregate;
  /** fetch data from the table: "surveys" using primary key columns */
  surveys_by_pk?: Maybe<Surveys>;
  /** fetch data from the table: "user_login" */
  user_login: Array<User_Login>;
  /** fetch aggregated fields from the table: "user_login" */
  user_login_aggregate: User_Login_Aggregate;
  /** fetch data from the table: "user_login" using primary key columns */
  user_login_by_pk?: Maybe<User_Login>;
  /** fetch data from the table: "user_presence" */
  user_presence: Array<User_Presence>;
  /** fetch aggregated fields from the table: "user_presence" */
  user_presence_aggregate: User_Presence_Aggregate;
  /** fetch data from the table: "user_presence" using primary key columns */
  user_presence_by_pk?: Maybe<User_Presence>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table: "video_session" */
  video_session: Array<Video_Session>;
  /** fetch aggregated fields from the table: "video_session" */
  video_session_aggregate: Video_Session_Aggregate;
  /** fetch data from the table: "video_session" using primary key columns */
  video_session_by_pk?: Maybe<Video_Session>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: Maybe<Array<Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Address_Order_By>>;
  where?: Maybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: Maybe<Array<Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Address_Order_By>>;
  where?: Maybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_ContactArgs = {
  distinct_on?: Maybe<Array<Company_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Contact_Order_By>>;
  where?: Maybe<Company_Contact_Bool_Exp>;
};


export type Subscription_RootCompany_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Contact_Order_By>>;
  where?: Maybe<Company_Contact_Bool_Exp>;
};


export type Subscription_RootCompany_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConfirmation_StatusArgs = {
  distinct_on?: Maybe<Array<Confirmation_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Confirmation_Status_Order_By>>;
  where?: Maybe<Confirmation_Status_Bool_Exp>;
};


export type Subscription_RootConfirmation_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Confirmation_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Confirmation_Status_Order_By>>;
  where?: Maybe<Confirmation_Status_Bool_Exp>;
};


export type Subscription_RootConfirmation_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


export type Subscription_RootEvent_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Order_By>>;
  where?: Maybe<Event_Bool_Exp>;
};


export type Subscription_RootEvent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_TypeArgs = {
  distinct_on?: Maybe<Array<Event_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Type_Order_By>>;
  where?: Maybe<Event_Type_Bool_Exp>;
};


export type Subscription_RootEvent_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Type_Order_By>>;
  where?: Maybe<Event_Type_Bool_Exp>;
};


export type Subscription_RootEvent_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHistoric_EventsArgs = {
  distinct_on?: Maybe<Array<Historic_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historic_Events_Order_By>>;
  where?: Maybe<Historic_Events_Bool_Exp>;
};


export type Subscription_RootHistoric_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Historic_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historic_Events_Order_By>>;
  where?: Maybe<Historic_Events_Bool_Exp>;
};


export type Subscription_RootHistoric_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLogsArgs = {
  distinct_on?: Maybe<Array<Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Order_By>>;
  where?: Maybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_ActionArgs = {
  distinct_on?: Maybe<Array<Logs_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Action_Order_By>>;
  where?: Maybe<Logs_Action_Bool_Exp>;
};


export type Subscription_RootLogs_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Logs_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Action_Order_By>>;
  where?: Maybe<Logs_Action_Bool_Exp>;
};


export type Subscription_RootLogs_Action_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLogs_AggregateArgs = {
  distinct_on?: Maybe<Array<Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Logs_Order_By>>;
  where?: Maybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMediaArgs = {
  distinct_on?: Maybe<Array<Media_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Media_Order_By>>;
  where?: Maybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_AggregateArgs = {
  distinct_on?: Maybe<Array<Media_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Media_Order_By>>;
  where?: Maybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNabu_CompaniesArgs = {
  distinct_on?: Maybe<Array<Nabu_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Companies_Order_By>>;
  where?: Maybe<Nabu_Companies_Bool_Exp>;
};


export type Subscription_RootNabu_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Companies_Order_By>>;
  where?: Maybe<Nabu_Companies_Bool_Exp>;
};


export type Subscription_RootNabu_FeedbackArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


export type Subscription_RootNabu_Feedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Order_By>>;
  where?: Maybe<Nabu_Feedback_Bool_Exp>;
};


export type Subscription_RootNabu_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNabu_Feedback_TypeArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Type_Order_By>>;
  where?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
};


export type Subscription_RootNabu_Feedback_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Feedback_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Feedback_Type_Order_By>>;
  where?: Maybe<Nabu_Feedback_Type_Bool_Exp>;
};


export type Subscription_RootNabu_Feedback_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNabu_Prevalence_Score_Classification_RunsArgs = {
  distinct_on?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Order_By>>;
  where?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
};


export type Subscription_RootNabu_Prevalence_Score_Classification_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prevalence_Score_Classification_Runs_Order_By>>;
  where?: Maybe<Nabu_Prevalence_Score_Classification_Runs_Bool_Exp>;
};


export type Subscription_RootNabu_Prevalence_Score_Classification_Runs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNabu_ProgramsArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


export type Subscription_RootNabu_Programs_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Programs_Order_By>>;
  where?: Maybe<Nabu_Programs_Bool_Exp>;
};


export type Subscription_RootNabu_PromptsArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


export type Subscription_RootNabu_Prompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Prompts_Order_By>>;
  where?: Maybe<Nabu_Prompts_Bool_Exp>;
};


export type Subscription_RootNabu_QuotesArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


export type Subscription_RootNabu_Quotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Quotes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Quotes_Order_By>>;
  where?: Maybe<Nabu_Quotes_Bool_Exp>;
};


export type Subscription_RootNabu_Quotes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNabu_SegmentsArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};


export type Subscription_RootNabu_Segments_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Segments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Segments_Order_By>>;
  where?: Maybe<Nabu_Segments_Bool_Exp>;
};


export type Subscription_RootNabu_SessionsArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};


export type Subscription_RootNabu_Sessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Sessions_Order_By>>;
  where?: Maybe<Nabu_Sessions_Bool_Exp>;
};


export type Subscription_RootNabu_Survey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Nabu_Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Survey_Questions_Order_By>>;
  where?: Maybe<Nabu_Survey_Questions_Bool_Exp>;
};


export type Subscription_RootNabu_Survey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Survey_Questions_Order_By>>;
  where?: Maybe<Nabu_Survey_Questions_Bool_Exp>;
};


export type Subscription_RootNabu_SurveysArgs = {
  distinct_on?: Maybe<Array<Nabu_Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Surveys_Order_By>>;
  where?: Maybe<Nabu_Surveys_Bool_Exp>;
};


export type Subscription_RootNabu_Surveys_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Surveys_Order_By>>;
  where?: Maybe<Nabu_Surveys_Bool_Exp>;
};


export type Subscription_RootNabu_TurnsArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


export type Subscription_RootNabu_Turns_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Turns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Turns_Order_By>>;
  where?: Maybe<Nabu_Turns_Bool_Exp>;
};


export type Subscription_RootNabu_Turns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNabu_UsersArgs = {
  distinct_on?: Maybe<Array<Nabu_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Users_Order_By>>;
  where?: Maybe<Nabu_Users_Bool_Exp>;
};


export type Subscription_RootNabu_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Users_Order_By>>;
  where?: Maybe<Nabu_Users_Bool_Exp>;
};


export type Subscription_RootNabu_VoxesArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};


export type Subscription_RootNabu_Voxes_AggregateArgs = {
  distinct_on?: Maybe<Array<Nabu_Voxes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nabu_Voxes_Order_By>>;
  where?: Maybe<Nabu_Voxes_Bool_Exp>;
};


export type Subscription_RootNabu_Voxes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_ConditionsArgs = {
  distinct_on?: Maybe<Array<Notification_Conditions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Conditions_Order_By>>;
  where?: Maybe<Notification_Conditions_Bool_Exp>;
};


export type Subscription_RootNotification_Conditions_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Conditions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Conditions_Order_By>>;
  where?: Maybe<Notification_Conditions_Bool_Exp>;
};


export type Subscription_RootNotification_Conditions_By_PkArgs = {
  value: Notification_Type_Enum;
};


export type Subscription_RootNotification_OffsetsArgs = {
  distinct_on?: Maybe<Array<Notification_Offsets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Offsets_Order_By>>;
  where?: Maybe<Notification_Offsets_Bool_Exp>;
};


export type Subscription_RootNotification_Offsets_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Offsets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Offsets_Order_By>>;
  where?: Maybe<Notification_Offsets_Bool_Exp>;
};


export type Subscription_RootNotification_Offsets_By_PkArgs = {
  value: Notification_Type_Enum;
};


export type Subscription_RootNotification_TemplatesArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


export type Subscription_RootNotification_Templates_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Templates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Templates_Order_By>>;
  where?: Maybe<Notification_Templates_Bool_Exp>;
};


export type Subscription_RootNotification_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_TypeArgs = {
  distinct_on?: Maybe<Array<Notification_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Type_Order_By>>;
  where?: Maybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Type_Order_By>>;
  where?: Maybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootParticipantArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Order_By>>;
  where?: Maybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParticipant_Registration_ViewArgs = {
  distinct_on?: Maybe<Array<Participant_Registration_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Registration_View_Order_By>>;
  where?: Maybe<Participant_Registration_View_Bool_Exp>;
};


export type Subscription_RootParticipant_Registration_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Registration_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Registration_View_Order_By>>;
  where?: Maybe<Participant_Registration_View_Bool_Exp>;
};


export type Subscription_RootParticipant_SessionArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


export type Subscription_RootParticipant_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Participant_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Participant_Session_Order_By>>;
  where?: Maybe<Participant_Session_Bool_Exp>;
};


export type Subscription_RootParticipant_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProgramArgs = {
  distinct_on?: Maybe<Array<Program_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Program_Order_By>>;
  where?: Maybe<Program_Bool_Exp>;
};


export type Subscription_RootProgram_AggregateArgs = {
  distinct_on?: Maybe<Array<Program_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Program_Order_By>>;
  where?: Maybe<Program_Bool_Exp>;
};


export type Subscription_RootProgram_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPromptsArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};


export type Subscription_RootPrompts_AggregateArgs = {
  distinct_on?: Maybe<Array<Prompts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Prompts_Order_By>>;
  where?: Maybe<Prompts_Bool_Exp>;
};


export type Subscription_RootPrompts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQuestion_TypeArgs = {
  distinct_on?: Maybe<Array<Question_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Type_Order_By>>;
  where?: Maybe<Question_Type_Bool_Exp>;
};


export type Subscription_RootQuestion_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Type_Order_By>>;
  where?: Maybe<Question_Type_Bool_Exp>;
};


export type Subscription_RootQuestion_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRecording_SessionArgs = {
  distinct_on?: Maybe<Array<Recording_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recording_Session_Order_By>>;
  where?: Maybe<Recording_Session_Bool_Exp>;
};


export type Subscription_RootRecording_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Recording_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recording_Session_Order_By>>;
  where?: Maybe<Recording_Session_Bool_Exp>;
};


export type Subscription_RootRecording_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoleArgs = {
  distinct_on?: Maybe<Array<Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Role_Order_By>>;
  where?: Maybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: Maybe<Array<Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Role_Order_By>>;
  where?: Maybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootScriptsArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


export type Subscription_RootScripts_AggregateArgs = {
  distinct_on?: Maybe<Array<Scripts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scripts_Order_By>>;
  where?: Maybe<Scripts_Bool_Exp>;
};


export type Subscription_RootScripts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSessionArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


export type Subscription_RootSession_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_Order_By>>;
  where?: Maybe<Session_Bool_Exp>;
};


export type Subscription_RootSession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSession_With_Participant_CountArgs = {
  distinct_on?: Maybe<Array<Session_With_Participant_Count_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_With_Participant_Count_Order_By>>;
  where?: Maybe<Session_With_Participant_Count_Bool_Exp>;
};


export type Subscription_RootSession_With_Participant_Count_AggregateArgs = {
  distinct_on?: Maybe<Array<Session_With_Participant_Count_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Session_With_Participant_Count_Order_By>>;
  where?: Maybe<Session_With_Participant_Count_Bool_Exp>;
};


export type Subscription_RootSessions_Info_ViewArgs = {
  distinct_on?: Maybe<Array<Sessions_Info_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Info_View_Order_By>>;
  where?: Maybe<Sessions_Info_View_Bool_Exp>;
};


export type Subscription_RootSessions_Info_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Info_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Info_View_Order_By>>;
  where?: Maybe<Sessions_Info_View_Bool_Exp>;
};


export type Subscription_RootSpeech_PhrasesArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Order_By>>;
  where?: Maybe<Speech_Phrases_Bool_Exp>;
};


export type Subscription_RootSpeech_Phrases_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Order_By>>;
  where?: Maybe<Speech_Phrases_Bool_Exp>;
};


export type Subscription_RootSpeech_Phrases_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSpeech_Phrases_SessionArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


export type Subscription_RootSpeech_Phrases_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Speech_Phrases_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Speech_Phrases_Session_Order_By>>;
  where?: Maybe<Speech_Phrases_Session_Bool_Exp>;
};


export type Subscription_RootSpeech_Phrases_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSurvey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


export type Subscription_RootSurvey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


export type Subscription_RootSurvey_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSurveysArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};


export type Subscription_RootSurveys_AggregateArgs = {
  distinct_on?: Maybe<Array<Surveys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Surveys_Order_By>>;
  where?: Maybe<Surveys_Bool_Exp>;
};


export type Subscription_RootSurveys_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_LoginArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};


export type Subscription_RootUser_Login_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Login_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Login_Order_By>>;
  where?: Maybe<User_Login_Bool_Exp>;
};


export type Subscription_RootUser_Login_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_PresenceArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


export type Subscription_RootUser_Presence_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Presence_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Presence_Order_By>>;
  where?: Maybe<User_Presence_Bool_Exp>;
};


export type Subscription_RootUser_Presence_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_RoleArgs = {
  distinct_on?: Maybe<Array<User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Role_Order_By>>;
  where?: Maybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Role_Order_By>>;
  where?: Maybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideo_SessionArgs = {
  distinct_on?: Maybe<Array<Video_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Video_Session_Order_By>>;
  where?: Maybe<Video_Session_Bool_Exp>;
};


export type Subscription_RootVideo_Session_AggregateArgs = {
  distinct_on?: Maybe<Array<Video_Session_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Video_Session_Order_By>>;
  where?: Maybe<Video_Session_Bool_Exp>;
};


export type Subscription_RootVideo_Session_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "survey_questions" */
export type Survey_Questions = {
  __typename?: 'survey_questions';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  question: Scalars['String'];
  /** An object relationship */
  question_type: Question_Type;
  /** An object relationship */
  survey: Surveys;
  survey_id: Scalars['uuid'];
  type: Question_Type_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "survey_questions" */
export type Survey_Questions_Aggregate = {
  __typename?: 'survey_questions_aggregate';
  aggregate?: Maybe<Survey_Questions_Aggregate_Fields>;
  nodes: Array<Survey_Questions>;
};

/** aggregate fields of "survey_questions" */
export type Survey_Questions_Aggregate_Fields = {
  __typename?: 'survey_questions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Survey_Questions_Max_Fields>;
  min?: Maybe<Survey_Questions_Min_Fields>;
};


/** aggregate fields of "survey_questions" */
export type Survey_Questions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Survey_Questions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "survey_questions" */
export type Survey_Questions_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Survey_Questions_Max_Order_By>;
  min?: Maybe<Survey_Questions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "survey_questions" */
export type Survey_Questions_Arr_Rel_Insert_Input = {
  data: Array<Survey_Questions_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Survey_Questions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "survey_questions". All fields are combined with a logical 'AND'. */
export type Survey_Questions_Bool_Exp = {
  _and?: Maybe<Array<Survey_Questions_Bool_Exp>>;
  _not?: Maybe<Survey_Questions_Bool_Exp>;
  _or?: Maybe<Array<Survey_Questions_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  question?: Maybe<String_Comparison_Exp>;
  question_type?: Maybe<Question_Type_Bool_Exp>;
  survey?: Maybe<Surveys_Bool_Exp>;
  survey_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Question_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "survey_questions" */
export enum Survey_Questions_Constraint {
  /** unique or primary key constraint */
  SurveyQuestionsPkey = 'survey_questions_pkey'
}

/** input type for inserting data into table "survey_questions" */
export type Survey_Questions_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  question_type?: Maybe<Question_Type_Obj_Rel_Insert_Input>;
  survey?: Maybe<Surveys_Obj_Rel_Insert_Input>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Question_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Survey_Questions_Max_Fields = {
  __typename?: 'survey_questions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "survey_questions" */
export type Survey_Questions_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  question?: Maybe<Order_By>;
  survey_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Survey_Questions_Min_Fields = {
  __typename?: 'survey_questions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "survey_questions" */
export type Survey_Questions_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  question?: Maybe<Order_By>;
  survey_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "survey_questions" */
export type Survey_Questions_Mutation_Response = {
  __typename?: 'survey_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Questions>;
};

/** on conflict condition type for table "survey_questions" */
export type Survey_Questions_On_Conflict = {
  constraint: Survey_Questions_Constraint;
  update_columns?: Array<Survey_Questions_Update_Column>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_questions". */
export type Survey_Questions_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  question?: Maybe<Order_By>;
  question_type?: Maybe<Question_Type_Order_By>;
  survey?: Maybe<Surveys_Order_By>;
  survey_id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: survey_questions */
export type Survey_Questions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "survey_questions" */
export enum Survey_Questions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "survey_questions" */
export type Survey_Questions_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Question_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "survey_questions" */
export enum Survey_Questions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "surveys" */
export type Surveys = {
  __typename?: 'surveys';
  batch: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  /** An array relationship */
  survey_questions: Array<Survey_Questions>;
  /** An aggregate relationship */
  survey_questions_aggregate: Survey_Questions_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "surveys" */
export type SurveysSurvey_QuestionsArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};


/** columns and relationships of "surveys" */
export type SurveysSurvey_Questions_AggregateArgs = {
  distinct_on?: Maybe<Array<Survey_Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Survey_Questions_Order_By>>;
  where?: Maybe<Survey_Questions_Bool_Exp>;
};

/** aggregated selection of "surveys" */
export type Surveys_Aggregate = {
  __typename?: 'surveys_aggregate';
  aggregate?: Maybe<Surveys_Aggregate_Fields>;
  nodes: Array<Surveys>;
};

/** aggregate fields of "surveys" */
export type Surveys_Aggregate_Fields = {
  __typename?: 'surveys_aggregate_fields';
  avg?: Maybe<Surveys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Surveys_Max_Fields>;
  min?: Maybe<Surveys_Min_Fields>;
  stddev?: Maybe<Surveys_Stddev_Fields>;
  stddev_pop?: Maybe<Surveys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Surveys_Stddev_Samp_Fields>;
  sum?: Maybe<Surveys_Sum_Fields>;
  var_pop?: Maybe<Surveys_Var_Pop_Fields>;
  var_samp?: Maybe<Surveys_Var_Samp_Fields>;
  variance?: Maybe<Surveys_Variance_Fields>;
};


/** aggregate fields of "surveys" */
export type Surveys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Surveys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "surveys" */
export type Surveys_Aggregate_Order_By = {
  avg?: Maybe<Surveys_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Surveys_Max_Order_By>;
  min?: Maybe<Surveys_Min_Order_By>;
  stddev?: Maybe<Surveys_Stddev_Order_By>;
  stddev_pop?: Maybe<Surveys_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Surveys_Stddev_Samp_Order_By>;
  sum?: Maybe<Surveys_Sum_Order_By>;
  var_pop?: Maybe<Surveys_Var_Pop_Order_By>;
  var_samp?: Maybe<Surveys_Var_Samp_Order_By>;
  variance?: Maybe<Surveys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "surveys" */
export type Surveys_Arr_Rel_Insert_Input = {
  data: Array<Surveys_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<Surveys_On_Conflict>;
};

/** aggregate avg on columns */
export type Surveys_Avg_Fields = {
  __typename?: 'surveys_avg_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "surveys" */
export type Surveys_Avg_Order_By = {
  batch?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "surveys". All fields are combined with a logical 'AND'. */
export type Surveys_Bool_Exp = {
  _and?: Maybe<Array<Surveys_Bool_Exp>>;
  _not?: Maybe<Surveys_Bool_Exp>;
  _or?: Maybe<Array<Surveys_Bool_Exp>>;
  batch?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  survey_questions?: Maybe<Survey_Questions_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "surveys" */
export enum Surveys_Constraint {
  /** unique or primary key constraint */
  SurveysPkey = 'surveys_pkey'
}

/** input type for incrementing numeric columns in table "surveys" */
export type Surveys_Inc_Input = {
  batch?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "surveys" */
export type Surveys_Insert_Input = {
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  survey_questions?: Maybe<Survey_Questions_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Surveys_Max_Fields = {
  __typename?: 'surveys_max_fields';
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "surveys" */
export type Surveys_Max_Order_By = {
  batch?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Surveys_Min_Fields = {
  __typename?: 'surveys_min_fields';
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "surveys" */
export type Surveys_Min_Order_By = {
  batch?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "surveys" */
export type Surveys_Mutation_Response = {
  __typename?: 'surveys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Surveys>;
};

/** input type for inserting object relation for remote table "surveys" */
export type Surveys_Obj_Rel_Insert_Input = {
  data: Surveys_Insert_Input;
  /** on conflict condition */
  on_conflict?: Maybe<Surveys_On_Conflict>;
};

/** on conflict condition type for table "surveys" */
export type Surveys_On_Conflict = {
  constraint: Surveys_Constraint;
  update_columns?: Array<Surveys_Update_Column>;
  where?: Maybe<Surveys_Bool_Exp>;
};

/** Ordering options when selecting data from "surveys". */
export type Surveys_Order_By = {
  batch?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  survey_questions_aggregate?: Maybe<Survey_Questions_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: surveys */
export type Surveys_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "surveys" */
export enum Surveys_Select_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "surveys" */
export type Surveys_Set_Input = {
  batch?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Surveys_Stddev_Fields = {
  __typename?: 'surveys_stddev_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "surveys" */
export type Surveys_Stddev_Order_By = {
  batch?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Surveys_Stddev_Pop_Fields = {
  __typename?: 'surveys_stddev_pop_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "surveys" */
export type Surveys_Stddev_Pop_Order_By = {
  batch?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Surveys_Stddev_Samp_Fields = {
  __typename?: 'surveys_stddev_samp_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "surveys" */
export type Surveys_Stddev_Samp_Order_By = {
  batch?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Surveys_Sum_Fields = {
  __typename?: 'surveys_sum_fields';
  batch?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "surveys" */
export type Surveys_Sum_Order_By = {
  batch?: Maybe<Order_By>;
};

/** update columns of table "surveys" */
export enum Surveys_Update_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Surveys_Var_Pop_Fields = {
  __typename?: 'surveys_var_pop_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "surveys" */
export type Surveys_Var_Pop_Order_By = {
  batch?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Surveys_Var_Samp_Fields = {
  __typename?: 'surveys_var_samp_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "surveys" */
export type Surveys_Var_Samp_Order_By = {
  batch?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Surveys_Variance_Fields = {
  __typename?: 'surveys_variance_fields';
  batch?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "surveys" */
export type Surveys_Variance_Order_By = {
  batch?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_login" */
export type User_Login = {
  __typename?: 'user_login';
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "user_login" */
export type User_Login_Aggregate = {
  __typename?: 'user_login_aggregate';
  aggregate?: Maybe<User_Login_Aggregate_Fields>;
  nodes: Array<User_Login>;
};

/** aggregate fields of "user_login" */
export type User_Login_Aggregate_Fields = {
  __typename?: 'user_login_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Login_Max_Fields>;
  min?: Maybe<User_Login_Min_Fields>;
};


/** aggregate fields of "user_login" */
export type User_Login_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Login_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_login" */
export type User_Login_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Login_Max_Order_By>;
  min?: Maybe<User_Login_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_login" */
export type User_Login_Arr_Rel_Insert_Input = {
  data: Array<User_Login_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<User_Login_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_login". All fields are combined with a logical 'AND'. */
export type User_Login_Bool_Exp = {
  _and?: Maybe<Array<User_Login_Bool_Exp>>;
  _not?: Maybe<User_Login_Bool_Exp>;
  _or?: Maybe<Array<User_Login_Bool_Exp>>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_login" */
export enum User_Login_Constraint {
  /** unique or primary key constraint */
  UserLoginPkey = 'user_login_pkey'
}

/** input type for inserting data into table "user_login" */
export type User_Login_Insert_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type User_Login_Max_Fields = {
  __typename?: 'user_login_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_login" */
export type User_Login_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Login_Min_Fields = {
  __typename?: 'user_login_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_login" */
export type User_Login_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_login" */
export type User_Login_Mutation_Response = {
  __typename?: 'user_login_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Login>;
};

/** on conflict condition type for table "user_login" */
export type User_Login_On_Conflict = {
  constraint: User_Login_Constraint;
  update_columns?: Array<User_Login_Update_Column>;
  where?: Maybe<User_Login_Bool_Exp>;
};

/** Ordering options when selecting data from "user_login". */
export type User_Login_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: user_login */
export type User_Login_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_login" */
export enum User_Login_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_login" */
export type User_Login_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "user_login" */
export enum User_Login_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "user_presence" */
export type User_Presence = {
  __typename?: 'user_presence';
  created_at: Scalars['timestamptz'];
  device?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_seen_at: Scalars['timestamptz'];
  /** An object relationship */
  session: Session;
  session_id: Scalars['uuid'];
  /** A computed field, executes function "user_presence_computed_status" */
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Participant;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_presence" */
export type User_Presence_Aggregate = {
  __typename?: 'user_presence_aggregate';
  aggregate?: Maybe<User_Presence_Aggregate_Fields>;
  nodes: Array<User_Presence>;
};

/** aggregate fields of "user_presence" */
export type User_Presence_Aggregate_Fields = {
  __typename?: 'user_presence_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Presence_Max_Fields>;
  min?: Maybe<User_Presence_Min_Fields>;
};


/** aggregate fields of "user_presence" */
export type User_Presence_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Presence_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_presence" */
export type User_Presence_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Presence_Max_Order_By>;
  min?: Maybe<User_Presence_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_presence" */
export type User_Presence_Arr_Rel_Insert_Input = {
  data: Array<User_Presence_Insert_Input>;
  /** on conflict condition */
  on_conflict?: Maybe<User_Presence_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_presence". All fields are combined with a logical 'AND'. */
export type User_Presence_Bool_Exp = {
  _and?: Maybe<Array<User_Presence_Bool_Exp>>;
  _not?: Maybe<User_Presence_Bool_Exp>;
  _or?: Maybe<Array<User_Presence_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  device?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_seen_at?: Maybe<Timestamptz_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Participant_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_presence" */
export enum User_Presence_Constraint {
  /** unique or primary key constraint */
  UserPresencePkey = 'user_presence_pkey',
  /** unique or primary key constraint */
  UserPresenceUserIdSessionIdKey = 'user_presence_user_id_session_id_key'
}

/** input type for inserting data into table "user_presence" */
export type User_Presence_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen_at?: Maybe<Scalars['timestamptz']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Participant_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Presence_Max_Fields = {
  __typename?: 'user_presence_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen_at?: Maybe<Scalars['timestamptz']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_presence" */
export type User_Presence_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  device?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_seen_at?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Presence_Min_Fields = {
  __typename?: 'user_presence_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen_at?: Maybe<Scalars['timestamptz']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_presence" */
export type User_Presence_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  device?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_seen_at?: Maybe<Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_presence" */
export type User_Presence_Mutation_Response = {
  __typename?: 'user_presence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Presence>;
};

/** on conflict condition type for table "user_presence" */
export type User_Presence_On_Conflict = {
  constraint: User_Presence_Constraint;
  update_columns?: Array<User_Presence_Update_Column>;
  where?: Maybe<User_Presence_Bool_Exp>;
};

/** Ordering options when selecting data from "user_presence". */
export type User_Presence_Order_By = {
  created_at?: Maybe<Order_By>;
  device?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_seen_at?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Participant_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_presence */
export type User_Presence_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_presence" */
export enum User_Presence_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Device = 'device',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'last_seen_at',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_presence" */
export type User_Presence_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen_at?: Maybe<Scalars['timestamptz']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_presence" */
export enum User_Presence_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Device = 'device',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'last_seen_at',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "user_role" */
export type User_Role = {
  __typename?: 'user_role';
  id: Scalars['uuid'];
  role_id: Scalars['uuid'];
  user_login_id: Scalars['uuid'];
};

/** aggregated selection of "user_role" */
export type User_Role_Aggregate = {
  __typename?: 'user_role_aggregate';
  aggregate?: Maybe<User_Role_Aggregate_Fields>;
  nodes: Array<User_Role>;
};

/** aggregate fields of "user_role" */
export type User_Role_Aggregate_Fields = {
  __typename?: 'user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Role_Max_Fields>;
  min?: Maybe<User_Role_Min_Fields>;
};


/** aggregate fields of "user_role" */
export type User_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_role". All fields are combined with a logical 'AND'. */
export type User_Role_Bool_Exp = {
  _and?: Maybe<Array<User_Role_Bool_Exp>>;
  _not?: Maybe<User_Role_Bool_Exp>;
  _or?: Maybe<Array<User_Role_Bool_Exp>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  role_id?: Maybe<Uuid_Comparison_Exp>;
  user_login_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_role" */
export enum User_Role_Constraint {
  /** unique or primary key constraint */
  UserRolePkey = 'user_role_pkey',
  /** unique or primary key constraint */
  UserRoleUserLoginIdRoleIdKey = 'user_role_user_login_id_role_id_key'
}

/** input type for inserting data into table "user_role" */
export type User_Role_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_login_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Role_Max_Fields = {
  __typename?: 'user_role_max_fields';
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_login_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Role_Min_Fields = {
  __typename?: 'user_role_min_fields';
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_login_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_role" */
export type User_Role_Mutation_Response = {
  __typename?: 'user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Role>;
};

/** on conflict condition type for table "user_role" */
export type User_Role_On_Conflict = {
  constraint: User_Role_Constraint;
  update_columns?: Array<User_Role_Update_Column>;
  where?: Maybe<User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "user_role". */
export type User_Role_Order_By = {
  id?: Maybe<Order_By>;
  role_id?: Maybe<Order_By>;
  user_login_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_role */
export type User_Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_role" */
export enum User_Role_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserLoginId = 'user_login_id'
}

/** input type for updating data in table "user_role" */
export type User_Role_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_login_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_role" */
export enum User_Role_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserLoginId = 'user_login_id'
}


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "video_session" */
export type Video_Session = {
  __typename?: 'video_session';
  created_at: Scalars['timestamp'];
  deleted_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  path: Scalars['String'];
  /** An object relationship */
  session?: Maybe<Session>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "video_session" */
export type Video_Session_Aggregate = {
  __typename?: 'video_session_aggregate';
  aggregate?: Maybe<Video_Session_Aggregate_Fields>;
  nodes: Array<Video_Session>;
};

/** aggregate fields of "video_session" */
export type Video_Session_Aggregate_Fields = {
  __typename?: 'video_session_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Video_Session_Max_Fields>;
  min?: Maybe<Video_Session_Min_Fields>;
};


/** aggregate fields of "video_session" */
export type Video_Session_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Video_Session_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "video_session". All fields are combined with a logical 'AND'. */
export type Video_Session_Bool_Exp = {
  _and?: Maybe<Array<Video_Session_Bool_Exp>>;
  _not?: Maybe<Video_Session_Bool_Exp>;
  _or?: Maybe<Array<Video_Session_Bool_Exp>>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  deleted_at?: Maybe<Timestamp_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  path?: Maybe<String_Comparison_Exp>;
  session?: Maybe<Session_Bool_Exp>;
  session_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "video_session" */
export enum Video_Session_Constraint {
  /** unique or primary key constraint */
  VideoSessionPkey = 'video_session_pkey'
}

/** input type for inserting data into table "video_session" */
export type Video_Session_Insert_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  session?: Maybe<Session_Obj_Rel_Insert_Input>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Video_Session_Max_Fields = {
  __typename?: 'video_session_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Video_Session_Min_Fields = {
  __typename?: 'video_session_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "video_session" */
export type Video_Session_Mutation_Response = {
  __typename?: 'video_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Video_Session>;
};

/** on conflict condition type for table "video_session" */
export type Video_Session_On_Conflict = {
  constraint: Video_Session_Constraint;
  update_columns?: Array<Video_Session_Update_Column>;
  where?: Maybe<Video_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "video_session". */
export type Video_Session_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  path?: Maybe<Order_By>;
  session?: Maybe<Session_Order_By>;
  session_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: video_session */
export type Video_Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "video_session" */
export enum Video_Session_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "video_session" */
export type Video_Session_Set_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** update columns of table "video_session" */
export enum Video_Session_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type TempAgoraTokenFragment = { __typename?: 'GetAgoraTempTokenOutput', channelName: string, token: string, participantAgoraId: number };

export type AgoraRecordingFragmentFragment = { __typename?: 'StartRecordingOutput', resourceId: string, sid: string, sessionId: string };

export type GetAgoraTempTokenQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetAgoraTempTokenQuery = { __typename?: 'query_root', getAgoraTempToken?: Maybe<{ __typename?: 'GetAgoraTempTokenOutput', channelName: string, token: string, participantAgoraId: number }> };

export type StartRecordingMutationVariables = Exact<{
  token: Scalars['String'];
  sessionId: Scalars['String'];
}>;


export type StartRecordingMutation = { __typename?: 'mutation_root', startRecording?: Maybe<{ __typename?: 'StartRecordingOutput', resourceId: string, sid: string, sessionId: string }> };

export type CompanyFragment = { __typename?: 'company', id: any, name: string };

export type GetCompaniesQueryVariables = Exact<{
  order_by?: Maybe<Array<Company_Order_By> | Company_Order_By>;
}>;


export type GetCompaniesQuery = { __typename?: 'query_root', company: Array<{ __typename?: 'company', id: any, name: string }> };

export type EventsSubscriptionVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type EventsSubscription = { __typename?: 'subscription_root', event: Array<{ __typename?: 'event', id: any, email: string, metadata: any, created_at: any, event_type: { __typename?: 'event_type', name: string } }> };

export type RegisterEventMutationVariables = Exact<{
  sessionId: Scalars['String'];
  eventTypeName: Scalars['String'];
  metadata: Scalars['String'];
  clientTimestamp: Scalars['String'];
}>;


export type RegisterEventMutation = { __typename?: 'mutation_root', registerEvent?: Maybe<{ __typename?: 'RegisterEventOutput', id: string }> };

export type SendTalkTimeMessageMutationVariables = Exact<{
  sessionId: Scalars['String'];
  segmentName: Scalars['String'];
  segmentType: Scalars['String'];
}>;


export type SendTalkTimeMessageMutation = { __typename?: 'mutation_root', sendTalkTimeMessage?: Maybe<{ __typename?: 'TalkTimeMessageEventOutput', id: string }> };

export type LogAuthSignInMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type LogAuthSignInMutation = { __typename?: 'mutation_root', insert_logs_one?: Maybe<{ __typename?: 'logs', id: any, email: string, action: Logs_Action_Enum }> };

export type LogAuthSignOutMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type LogAuthSignOutMutation = { __typename?: 'mutation_root', insert_logs_one?: Maybe<{ __typename?: 'logs', id: any, email: string, action: Logs_Action_Enum }> };

export type MediaSummaryFragment = { __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string };

export type GetAllMediaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMediaQuery = { __typename?: 'query_root', media: Array<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }> };

export type InsertMediaOneMutationVariables = Exact<{
  object: Media_Insert_Input;
}>;


export type InsertMediaOneMutation = { __typename?: 'mutation_root', insert_media_one?: Maybe<{ __typename?: 'media', name: string, storage_key: string, content_type?: Maybe<string>, id: any }> };

export type NotificationTemplateFragment = { __typename?: 'notification_templates', id: any, content: string, type: Notification_Type_Enum, notification_type: { __typename?: 'notification_type', value: string, comment: string, notification_offset?: Maybe<{ __typename?: 'notification_offsets', offset_type: string, offset_unit: string, offset_value: number }> } };

export type GetNotificationTemplatesBySessionIdQueryVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type GetNotificationTemplatesBySessionIdQuery = { __typename?: 'query_root', notification_templates: Array<{ __typename?: 'notification_templates', id: any, content: string, type: Notification_Type_Enum, notification_type: { __typename?: 'notification_type', value: string, comment: string, notification_offset?: Maybe<{ __typename?: 'notification_offsets', offset_type: string, offset_unit: string, offset_value: number }> } }> };

export type AddNotificationTemplatesToSessionMutationVariables = Exact<{
  objects: Array<Notification_Templates_Insert_Input> | Notification_Templates_Insert_Input;
}>;


export type AddNotificationTemplatesToSessionMutation = { __typename?: 'mutation_root', insert_notification_templates?: Maybe<{ __typename?: 'notification_templates_mutation_response', returning: Array<{ __typename?: 'notification_templates', id: any, content: string, type: Notification_Type_Enum, notification_type: { __typename?: 'notification_type', value: string, comment: string, notification_offset?: Maybe<{ __typename?: 'notification_offsets', offset_type: string, offset_unit: string, offset_value: number }> } }> }> };

export type UpdateNotificationTemplateMutationVariables = Exact<{
  id: Scalars['uuid'];
  notificationTemplate: Notification_Templates_Set_Input;
}>;


export type UpdateNotificationTemplateMutation = { __typename?: 'mutation_root', update_notification_templates_by_pk?: Maybe<{ __typename?: 'notification_templates', id: any, content: string, type: Notification_Type_Enum, notification_type: { __typename?: 'notification_type', value: string, comment: string, notification_offset?: Maybe<{ __typename?: 'notification_offsets', offset_type: string, offset_unit: string, offset_value: number }> } }> };

export type DeleteNotificationTemplateMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteNotificationTemplateMutation = { __typename?: 'mutation_root', delete_notification_templates_by_pk?: Maybe<{ __typename?: 'notification_templates', id: any }> };

export type UpdateConfirmationStatusMutationVariables = Exact<{
  confirmation_status: Confirmation_Status_Enum;
  id: Scalars['uuid'];
}>;


export type UpdateConfirmationStatusMutation = { __typename?: 'mutation_root', update_participant_session_by_pk?: Maybe<{ __typename?: 'participant_session', id: any, participant_id: any }> };

export type ParticipantFragment = { __typename?: 'participant', id: any, email: string, first_name: string, group: string, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any, participant_sessions: Array<{ __typename?: 'participant_session', id: any, session_id: any, deleted_at?: Maybe<any>, last_notification?: Maybe<Notification_Type_Enum>, confirmation_status?: Maybe<Confirmation_Status_Enum> }> };

export type ParticipantSessionFragment = { __typename?: 'participant_session', id: any, last_notification?: Maybe<Notification_Type_Enum>, confirmation_status?: Maybe<Confirmation_Status_Enum>, participant?: Maybe<{ __typename?: 'participant', email: string, first_name: string, group: string, id: any, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any }> };

export type GetParticipantsBySessionIdQueryVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type GetParticipantsBySessionIdQuery = { __typename?: 'query_root', participant_session: Array<{ __typename?: 'participant_session', id: any, last_notification?: Maybe<Notification_Type_Enum>, confirmation_status?: Maybe<Confirmation_Status_Enum>, participant?: Maybe<{ __typename?: 'participant', email: string, first_name: string, group: string, id: any, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any }> }> };

export type GetParticipantsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type GetParticipantsByCompanyIdQuery = { __typename?: 'query_root', participant: Array<{ __typename?: 'participant', id: any, email: string, first_name: string, group: string, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any, participant_sessions: Array<{ __typename?: 'participant_session', id: any, session_id: any, deleted_at?: Maybe<any>, last_notification?: Maybe<Notification_Type_Enum>, confirmation_status?: Maybe<Confirmation_Status_Enum> }> }> };

export type DeleteSessionParticipantByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type DeleteSessionParticipantByIdMutation = { __typename?: 'mutation_root', update_participant_session_by_pk?: Maybe<{ __typename?: 'participant_session', id: any }> };

export type AddSessionParticipantMutationVariables = Exact<{
  sessionId: Scalars['uuid'];
  participantId: Scalars['uuid'];
}>;


export type AddSessionParticipantMutation = { __typename?: 'mutation_root', insert_participant_session_one?: Maybe<{ __typename?: 'participant_session', id: any }> };

export type UpdateSessionParticipantStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
}>;


export type UpdateSessionParticipantStatusMutation = { __typename?: 'mutation_root', update_participant_session_by_pk?: Maybe<{ __typename?: 'participant_session', id: any }> };

export type SendRegistrationMailMutationVariables = Exact<{
  participantEmail: Scalars['String'];
  participantId: Scalars['String'];
  participantFirstName: Scalars['String'];
  participantLastName: Scalars['String'];
  sessionDateTime: Scalars['String'];
  sessionId: Scalars['String'];
  sessionName: Scalars['String'];
  companyName: Scalars['String'];
  sessionTimezone: Scalars['String'];
  participantPreferredName?: Maybe<Scalars['String']>;
}>;


export type SendRegistrationMailMutation = { __typename?: 'mutation_root', emailRegisterSession?: Maybe<{ __typename?: 'EmailResponseOutput', success: boolean }> };

export type UserPresenceParticipantFragment = { __typename?: 'participant', id: any, email: string, first_name: string, group: string, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any };

export type ObserveActiveParticipantsBySessionIdSubscriptionVariables = Exact<{
  sessionId: Scalars['uuid'];
}>;


export type ObserveActiveParticipantsBySessionIdSubscription = { __typename?: 'subscription_root', user_presence: Array<{ __typename?: 'user_presence', id: any, created_at: any, last_seen_at: any, device?: Maybe<string>, status?: Maybe<string>, user: { __typename?: 'participant', id: any, email: string, first_name: string, group: string, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any } }> };

export type UserPresenceFragment = { __typename?: 'user_presence', id: any, created_at: any, last_seen_at: any, device?: Maybe<string>, status?: Maybe<string>, user: { __typename?: 'participant', id: any, email: string, first_name: string, group: string, last_name: string, metadata: any, name_pronunciation: string, notification_preference: string, phone: string, preferred_name: string, profile_photo?: Maybe<string>, agora_id: any } };

export type MoveParticipantToSubgroupMutationVariables = Exact<{
  userId: Scalars['uuid'];
  newSessionId: Scalars['uuid'];
  oldSessionId: Scalars['uuid'];
}>;


export type MoveParticipantToSubgroupMutation = { __typename?: 'mutation_root', update_participant_session?: Maybe<{ __typename?: 'participant_session_mutation_response', affected_rows: number }>, update_user_presence?: Maybe<{ __typename?: 'user_presence_mutation_response', affected_rows: number }> };

export type AddPrevalenceScoreRunMutationVariables = Exact<{
  object: Nabu_Prevalence_Score_Classification_Runs_Insert_Input;
}>;


export type AddPrevalenceScoreRunMutation = { __typename?: 'mutation_root', insert_nabu_prevalence_score_classification_runs_one?: Maybe<{ __typename?: 'nabu_prevalence_score_classification_runs', id: any, owner: string, program_id: any, status: string, storage_path: string, created_at: any }> };

export type GetPrevalenceScoreRunsQueryVariables = Exact<{
  program_id: Scalars['uuid'];
}>;


export type GetPrevalenceScoreRunsQuery = { __typename?: 'query_root', nabu_prevalence_score_classification_runs: Array<{ __typename?: 'nabu_prevalence_score_classification_runs', id: any, owner: string, program_id: any, status: string, storage_path: string, created_at: any }> };

export type ProgramFragment = { __typename?: 'program', id: any, name: string, company_id?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }> };

export type GetCompanyProgramsQueryVariables = Exact<{
  company_id: Scalars['uuid'];
  order_by?: Maybe<Array<Program_Order_By> | Program_Order_By>;
}>;


export type GetCompanyProgramsQuery = { __typename?: 'query_root', program: Array<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }> }> };

export type GetProgramQueryVariables = Exact<{
  program_id: Scalars['uuid'];
}>;


export type GetProgramQuery = { __typename?: 'query_root', program_by_pk?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }> }> };

export type CreateProgramMutationVariables = Exact<{
  company_id: Scalars['uuid'];
  name: Scalars['String'];
}>;


export type CreateProgramMutation = { __typename?: 'mutation_root', insert_program_one?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }> }> };

export type UpdateProgramMutationVariables = Exact<{
  program_id: Scalars['uuid'];
  name: Scalars['String'];
}>;


export type UpdateProgramMutation = { __typename?: 'mutation_root', update_program_by_pk?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }> }> };

export type GetRegistrationLinkMutationVariables = Exact<{
  programId: Scalars['String'];
}>;


export type GetRegistrationLinkMutation = { __typename?: 'mutation_root', getProgramRegistrationLink?: Maybe<{ __typename?: 'GetProgramRegistrationLinkOutput', link: string }> };

export type PromptFragment = { __typename?: 'prompts', id: any, text: string, segment_id: any };

export type GetSegmentPromptsQueryVariables = Exact<{
  segmentId?: Maybe<Scalars['uuid']>;
}>;


export type GetSegmentPromptsQuery = { __typename?: 'query_root', prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> };

export type InsertPromptMutationVariables = Exact<{
  object: Prompts_Insert_Input;
}>;


export type InsertPromptMutation = { __typename?: 'mutation_root', insert_prompts_one?: Maybe<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> };

export type UpdatePromptMutationVariables = Exact<{
  id: Scalars['uuid'];
  text: Scalars['String'];
}>;


export type UpdatePromptMutation = { __typename?: 'mutation_root', update_prompts_by_pk?: Maybe<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> };

export type DeletePromptMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeletePromptMutation = { __typename?: 'mutation_root', delete_prompts_by_pk?: Maybe<{ __typename?: 'prompts', id: any }> };

export type SegmentFragment = { __typename?: 'scripts', id: any, segment_type: string, segment_name: string, order: number, preferences?: Maybe<any>, media_id?: Maybe<any>, media?: Maybe<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }>, prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> };

export type GetSessionScriptQueryVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type GetSessionScriptQuery = { __typename?: 'query_root', scripts: Array<{ __typename?: 'scripts', id: any, segment_type: string, segment_name: string, order: number, preferences?: Maybe<any>, media_id?: Maybe<any>, media?: Maybe<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }>, prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> }> };

export type InsertScriptMutationVariables = Exact<{
  objects: Array<Scripts_Insert_Input> | Scripts_Insert_Input;
}>;


export type InsertScriptMutation = { __typename?: 'mutation_root', insert_scripts?: Maybe<{ __typename?: 'scripts_mutation_response', returning: Array<{ __typename?: 'scripts', id: any, segment_type: string, segment_name: string, order: number, preferences?: Maybe<any>, media_id?: Maybe<any>, media?: Maybe<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }>, prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> }> }> };

export type UpdateScriptInfoMutationVariables = Exact<{
  id: Scalars['uuid'];
  segment_name: Scalars['String'];
  segment_media?: Maybe<Scalars['uuid']>;
}>;


export type UpdateScriptInfoMutation = { __typename?: 'mutation_root', update_scripts?: Maybe<{ __typename?: 'scripts_mutation_response', returning: Array<{ __typename?: 'scripts', id: any, segment_type: string, segment_name: string, order: number, preferences?: Maybe<any>, media_id?: Maybe<any>, media?: Maybe<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }>, prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> }> }> };

export type UpdateScriptPreferencesMutationVariables = Exact<{
  id: Scalars['uuid'];
  preferences?: Maybe<Scalars['jsonb']>;
}>;


export type UpdateScriptPreferencesMutation = { __typename?: 'mutation_root', update_scripts?: Maybe<{ __typename?: 'scripts_mutation_response', returning: Array<{ __typename?: 'scripts', id: any, segment_type: string, segment_name: string, order: number, preferences?: Maybe<any>, media_id?: Maybe<any>, media?: Maybe<{ __typename?: 'media', id: any, name: string, content_type?: Maybe<string>, storage_key: string }>, prompts: Array<{ __typename?: 'prompts', id: any, text: string, segment_id: any }> }> }> };

export type DeleteSessionScriptMutationVariables = Exact<{
  sessionId: Scalars['uuid'];
}>;


export type DeleteSessionScriptMutation = { __typename?: 'mutation_root', delete_scripts?: Maybe<{ __typename?: 'scripts_mutation_response', affected_rows: number }> };

export type DeleteScriptSegmentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteScriptSegmentMutation = { __typename?: 'mutation_root', delete_scripts_by_pk?: Maybe<{ __typename?: 'scripts', segment_name: string }> };

export type SessionFragment = { __typename?: 'session', id: any, session_name: string, date_time: any, preferences?: Maybe<any>, deleted_at?: Maybe<any>, timezone: string, is_template: boolean, is_multigroup: boolean, max_participant_limit: number, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, template?: Maybe<{ __typename?: 'session', id: any, session_name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session_aggregate: { __typename?: 'participant_session_aggregate', aggregate?: Maybe<{ __typename?: 'participant_session_aggregate_fields', count: number }> }, subgroups: Array<{ __typename?: 'session', id: any, session_name: string }> };

export type SessionByIdSubscriptionVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type SessionByIdSubscription = { __typename?: 'subscription_root', session: Array<{ __typename?: 'session', id: any, session_name: string, date_time: any, preferences?: Maybe<any>, deleted_at?: Maybe<any>, timezone: string, is_template: boolean, is_multigroup: boolean, max_participant_limit: number, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, template?: Maybe<{ __typename?: 'session', id: any, session_name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session_aggregate: { __typename?: 'participant_session_aggregate', aggregate?: Maybe<{ __typename?: 'participant_session_aggregate_fields', count: number }> }, subgroups: Array<{ __typename?: 'session', id: any, session_name: string }> }> };

export type GetSessionsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<Session_Order_By> | Session_Order_By>;
  where?: Maybe<Session_Bool_Exp>;
}>;


export type GetSessionsQuery = { __typename?: 'query_root', session: Array<{ __typename?: 'session', id: any, session_name: string, date_time: any, preferences?: Maybe<any>, deleted_at?: Maybe<any>, timezone: string, is_template: boolean, is_multigroup: boolean, max_participant_limit: number, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, template?: Maybe<{ __typename?: 'session', id: any, session_name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session_aggregate: { __typename?: 'participant_session_aggregate', aggregate?: Maybe<{ __typename?: 'participant_session_aggregate_fields', count: number }> }, subgroups: Array<{ __typename?: 'session', id: any, session_name: string }> }>, session_aggregate: { __typename?: 'session_aggregate', aggregate?: Maybe<{ __typename?: 'session_aggregate_fields', count: number }> } };

export type GetSessionByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type GetSessionByIdQuery = { __typename?: 'query_root', session: Array<{ __typename?: 'session', id: any, session_name: string, date_time: any, preferences?: Maybe<any>, deleted_at?: Maybe<any>, timezone: string, is_template: boolean, is_multigroup: boolean, max_participant_limit: number, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, template?: Maybe<{ __typename?: 'session', id: any, session_name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session_aggregate: { __typename?: 'participant_session_aggregate', aggregate?: Maybe<{ __typename?: 'participant_session_aggregate_fields', count: number }> }, subgroups: Array<{ __typename?: 'session', id: any, session_name: string }> }> };

export type FinishSessionMutationVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type FinishSessionMutation = { __typename?: 'mutation_root', finishSession?: Maybe<{ __typename?: 'FinishSessionOutput', sessionId: string }> };

export type ChangePreferencesMutationVariables = Exact<{
  sessionId: Scalars['String'];
  preferences: Scalars['String'];
}>;


export type ChangePreferencesMutation = { __typename?: 'mutation_root', changePreferences?: Maybe<{ __typename?: 'ChangePreferencesOutput', id: string }> };

export type SoftDeleteSessionMutationVariables = Exact<{
  sessionId: Scalars['uuid'];
  deletedAtTimestamp: Scalars['timestamptz'];
}>;


export type SoftDeleteSessionMutation = { __typename?: 'mutation_root', update_session?: Maybe<{ __typename?: 'session_mutation_response', returning: Array<{ __typename?: 'session', id: any }> }> };

export type InsertSessionMutationVariables = Exact<{
  session_name: Scalars['String'];
  program_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  date_time: Scalars['timestamptz'];
  timezone: Scalars['String'];
  is_template: Scalars['Boolean'];
  template_id?: Maybe<Scalars['uuid']>;
  is_multigroup: Scalars['Boolean'];
  max_participant_limit: Scalars['Int'];
}>;


export type InsertSessionMutation = { __typename?: 'mutation_root', insert_session_one?: Maybe<{ __typename?: 'session', id: any }> };

export type UpdateSessionByIdMutationVariables = Exact<{
  session_id: Scalars['uuid'];
  session_name: Scalars['String'];
  company_id?: Maybe<Scalars['uuid']>;
  program_id: Scalars['uuid'];
  date_time: Scalars['timestamptz'];
  timezone: Scalars['String'];
  template_id?: Maybe<Scalars['uuid']>;
  is_multigroup: Scalars['Boolean'];
}>;


export type UpdateSessionByIdMutation = { __typename?: 'mutation_root', update_session_by_pk?: Maybe<{ __typename?: 'session', id: any }> };

export type UpdateSessionMaxParticipantLimitMutationVariables = Exact<{
  session_id: Scalars['uuid'];
  max_participant_limit: Scalars['Int'];
}>;


export type UpdateSessionMaxParticipantLimitMutation = { __typename?: 'mutation_root', update_session_by_pk?: Maybe<{ __typename?: 'session', id: any }> };

export type SessionGroupFragment = { __typename?: 'session', id: any, session_name: string, is_multigroup: boolean, max_participant_limit: number, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session: Array<{ __typename?: 'participant_session', deleted_at?: Maybe<any>, participant?: Maybe<{ __typename?: 'participant', id: any, first_name: string, last_name: string, preferred_name: string, group: string, metadata: any }> }> };

export type SessionGroupParticipantFragment = { __typename?: 'participant', id: any, first_name: string, last_name: string, preferred_name: string, group: string, metadata: any };

export type ObserveSessionGroupsSubscriptionVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type ObserveSessionGroupsSubscription = { __typename?: 'subscription_root', session: Array<{ __typename?: 'session', id: any, session_name: string, is_multigroup: boolean, max_participant_limit: number, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session: Array<{ __typename?: 'participant_session', deleted_at?: Maybe<any>, participant?: Maybe<{ __typename?: 'participant', id: any, first_name: string, last_name: string, preferred_name: string, group: string, metadata: any }> }> }> };

export type GetSessionsByProgramIdQueryVariables = Exact<{
  programId: Scalars['uuid'];
  includeMultigroup?: Maybe<Scalars['Boolean']>;
}>;


export type GetSessionsByProgramIdQuery = { __typename?: 'query_root', session: Array<{ __typename?: 'session', id: any, session_name: string, is_multigroup: boolean, max_participant_limit: number, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, participant_session: Array<{ __typename?: 'participant_session', deleted_at?: Maybe<any>, participant?: Maybe<{ __typename?: 'participant', id: any, first_name: string, last_name: string, preferred_name: string, group: string, metadata: any }> }> }> };

export type UpdateBaseSessionMutationVariables = Exact<{
  session_id: Scalars['uuid'];
  base_session_id: Scalars['uuid'];
}>;


export type UpdateBaseSessionMutation = { __typename?: 'mutation_root', update_session_by_pk?: Maybe<{ __typename?: 'session', id: any }> };

export type SessionTemplateFragment = { __typename?: 'session', id: any, session_name: string, preferences?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, script: Array<{ __typename?: 'scripts', id: any, media_id?: Maybe<any>, order: number, preferences?: Maybe<any>, segment_name: string, segment_type: string, prompts: Array<{ __typename?: 'prompts', id: any, segment_id: any, text: string }> }>, session_phrases: Array<{ __typename?: 'speech_phrases_session', speech_phrase: { __typename?: 'speech_phrases', id: any, priority: number, preload?: Maybe<boolean>, is_shared: boolean, category: string, content: string } }>, surveys: Array<{ __typename?: 'surveys', batch: number, description: string, survey_questions: Array<{ __typename?: 'survey_questions', question: string, type: Question_Type_Enum }> }> };

export type SessionTemplateSummaryFragment = { __typename?: 'session', id: any, session_name: string, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }> };

export type GetSessionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionTemplatesQuery = { __typename?: 'query_root', session: Array<{ __typename?: 'session', id: any, session_name: string, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }> }> };

export type GetSessionTemplateByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type GetSessionTemplateByIdQuery = { __typename?: 'query_root', session: Array<{ __typename?: 'session', id: any, session_name: string, preferences?: Maybe<any>, company?: Maybe<{ __typename?: 'company', id: any, name: string }>, program?: Maybe<{ __typename?: 'program', id: any, name: string, company_id?: Maybe<any> }>, script: Array<{ __typename?: 'scripts', id: any, media_id?: Maybe<any>, order: number, preferences?: Maybe<any>, segment_name: string, segment_type: string, prompts: Array<{ __typename?: 'prompts', id: any, segment_id: any, text: string }> }>, session_phrases: Array<{ __typename?: 'speech_phrases_session', speech_phrase: { __typename?: 'speech_phrases', id: any, priority: number, preload?: Maybe<boolean>, is_shared: boolean, category: string, content: string } }>, surveys: Array<{ __typename?: 'surveys', batch: number, description: string, survey_questions: Array<{ __typename?: 'survey_questions', question: string, type: Question_Type_Enum }> }> }> };

export type SpeechPhraseFragment = { __typename?: 'speech_phrases', id: any, category: string, priority: number, preload?: Maybe<boolean>, content: string, is_shared: boolean };

export type GetSpeechPhrasesQueryVariables = Exact<{
  session_id?: Maybe<Scalars['uuid']>;
}>;


export type GetSpeechPhrasesQuery = { __typename?: 'query_root', speech_phrases: Array<{ __typename?: 'speech_phrases', id: any, category: string, priority: number, preload?: Maybe<boolean>, content: string, is_shared: boolean }> };

export type GetSessionSpeechPhrasesQueryVariables = Exact<{
  session_id?: Maybe<Scalars['uuid']>;
}>;


export type GetSessionSpeechPhrasesQuery = { __typename?: 'query_root', speech_phrases: Array<{ __typename?: 'speech_phrases', id: any, category: string, priority: number, preload?: Maybe<boolean>, content: string, is_shared: boolean }> };

export type SyntethizeTextToSpeechMutationVariables = Exact<{
  sessionId: Scalars['String'];
  text: Scalars['String'];
}>;


export type SyntethizeTextToSpeechMutation = { __typename?: 'mutation_root', syntethizeTextToSpeech?: Maybe<{ __typename?: 'SyntethizeTextToSpeechOutput', audioContent: string }> };

export type InsertSpeechPhrasesMutationVariables = Exact<{
  objects: Array<Speech_Phrases_Insert_Input> | Speech_Phrases_Insert_Input;
}>;


export type InsertSpeechPhrasesMutation = { __typename?: 'mutation_root', insert_speech_phrases?: Maybe<{ __typename?: 'speech_phrases_mutation_response', returning: Array<{ __typename?: 'speech_phrases', id: any }> }> };

export type AddSpeechPhraseToSessionMutationVariables = Exact<{
  objects: Array<Speech_Phrases_Session_Insert_Input> | Speech_Phrases_Session_Insert_Input;
}>;


export type AddSpeechPhraseToSessionMutation = { __typename?: 'mutation_root', insert_speech_phrases_session?: Maybe<{ __typename?: 'speech_phrases_session_mutation_response', returning: Array<{ __typename?: 'speech_phrases_session', session_id: any, speech_phrase_id: any }> }> };

export type UpdateSpeechPhrasesMutationVariables = Exact<{
  speechPhraseId: Scalars['uuid'];
  speechPhrase: Speech_Phrases_Set_Input;
}>;


export type UpdateSpeechPhrasesMutation = { __typename?: 'mutation_root', update_speech_phrases_by_pk?: Maybe<{ __typename?: 'speech_phrases', id: any, category: string, priority: number, preload?: Maybe<boolean>, content: string, is_shared: boolean }> };

export type DeleteSpeechPhrasesFromSessionMutationVariables = Exact<{
  sessionId: Scalars['uuid'];
  speechPhraseId: Scalars['uuid'];
}>;


export type DeleteSpeechPhrasesFromSessionMutation = { __typename?: 'mutation_root', delete_speech_phrases_session?: Maybe<{ __typename?: 'speech_phrases_session_mutation_response', returning: Array<{ __typename?: 'speech_phrases_session', id: any }> }> };

export type QuestionFragment = { __typename?: 'survey_questions', id: any, question: string, type: Question_Type_Enum, survey: { __typename?: 'surveys', id: any, batch: number } };

export type InsertSurveyQuestionsMutationVariables = Exact<{
  objects: Array<Survey_Questions_Insert_Input> | Survey_Questions_Insert_Input;
}>;


export type InsertSurveyQuestionsMutation = { __typename?: 'mutation_root', insert_survey_questions?: Maybe<{ __typename?: 'survey_questions_mutation_response', returning: Array<{ __typename?: 'survey_questions', id: any }> }> };

export type UpdateQuestionMutationVariables = Exact<{
  questionId: Scalars['uuid'];
  questionDescription: Scalars['String'];
  surveyId: Scalars['uuid'];
  batch: Scalars['Int'];
}>;


export type UpdateQuestionMutation = { __typename?: 'mutation_root', update_survey_questions_by_pk?: Maybe<{ __typename?: 'survey_questions', id: any, question: string }>, update_surveys_by_pk?: Maybe<{ __typename?: 'surveys', id: any, batch: number }> };

export type DeleteQuestionsMutationVariables = Exact<{
  questionIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteQuestionsMutation = { __typename?: 'mutation_root', delete_survey_questions?: Maybe<{ __typename?: 'survey_questions_mutation_response', returning: Array<{ __typename?: 'survey_questions', id: any }> }> };

export type GetSessionSurveysQueryVariables = Exact<{
  sessionId?: Maybe<Scalars['uuid']>;
}>;


export type GetSessionSurveysQuery = { __typename?: 'query_root', survey_questions: Array<{ __typename?: 'survey_questions', id: any, question: string, type: Question_Type_Enum, survey: { __typename?: 'surveys', id: any, batch: number } }> };

export const TempAgoraTokenFragmentDoc = gql`
    fragment TempAgoraToken on GetAgoraTempTokenOutput {
  channelName
  token
  participantAgoraId
}
    `;
export const AgoraRecordingFragmentFragmentDoc = gql`
    fragment AgoraRecordingFragment on StartRecordingOutput {
  resourceId
  sid
  sessionId
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on company {
  id
  name
}
    `;
export const NotificationTemplateFragmentDoc = gql`
    fragment NotificationTemplate on notification_templates {
  id
  content
  type
  notification_type {
    value
    comment
    notification_offset {
      offset_type
      offset_unit
      offset_value
    }
  }
}
    `;
export const ParticipantFragmentDoc = gql`
    fragment Participant on participant {
  id
  email
  first_name
  group
  id
  last_name
  metadata
  name_pronunciation
  notification_preference
  phone
  preferred_name
  profile_photo
  agora_id
  participant_sessions {
    id
    session_id
    deleted_at
    last_notification
    confirmation_status
  }
}
    `;
export const ParticipantSessionFragmentDoc = gql`
    fragment ParticipantSession on participant_session {
  id
  last_notification
  confirmation_status
  participant {
    email
    first_name
    group
    id
    last_name
    metadata
    name_pronunciation
    notification_preference
    phone
    preferred_name
    profile_photo
    agora_id
  }
}
    `;
export const UserPresenceParticipantFragmentDoc = gql`
    fragment UserPresenceParticipant on participant {
  id
  email
  first_name
  group
  id
  last_name
  metadata
  name_pronunciation
  notification_preference
  phone
  preferred_name
  profile_photo
  agora_id
}
    `;
export const UserPresenceFragmentDoc = gql`
    fragment UserPresence on user_presence {
  id
  created_at
  last_seen_at
  device
  status
  user {
    ...UserPresenceParticipant
  }
}
    ${UserPresenceParticipantFragmentDoc}`;
export const ProgramFragmentDoc = gql`
    fragment Program on program {
  id
  name
  company_id
  company {
    id
    name
  }
}
    `;
export const MediaSummaryFragmentDoc = gql`
    fragment MediaSummary on media {
  id
  name
  content_type
  storage_key
}
    `;
export const PromptFragmentDoc = gql`
    fragment Prompt on prompts {
  id
  text
  segment_id
}
    `;
export const SegmentFragmentDoc = gql`
    fragment Segment on scripts {
  id
  segment_type
  segment_name
  order
  preferences
  media_id
  media {
    ...MediaSummary
  }
  prompts {
    ...Prompt
  }
}
    ${MediaSummaryFragmentDoc}
${PromptFragmentDoc}`;
export const SessionFragmentDoc = gql`
    fragment Session on session {
  id
  session_name
  company {
    id
    name
  }
  date_time
  preferences
  deleted_at
  timezone
  is_template
  template {
    id
    session_name
  }
  is_multigroup
  max_participant_limit
  program {
    id
    name
    company_id
  }
  participant_session_aggregate(where: {deleted_at: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  subgroups {
    id
    session_name
  }
}
    `;
export const SessionGroupParticipantFragmentDoc = gql`
    fragment SessionGroupParticipant on participant {
  id
  first_name
  last_name
  preferred_name
  group
  metadata
}
    `;
export const SessionGroupFragmentDoc = gql`
    fragment SessionGroup on session {
  id
  session_name
  is_multigroup
  max_participant_limit
  program {
    id
    name
    company_id
  }
  participant_session {
    deleted_at
    participant {
      ...SessionGroupParticipant
    }
  }
}
    ${SessionGroupParticipantFragmentDoc}`;
export const SessionTemplateFragmentDoc = gql`
    fragment SessionTemplate on session {
  id
  session_name
  company {
    id
    name
  }
  preferences
  program {
    id
    name
    company_id
  }
  script {
    id
    media_id
    order
    preferences
    segment_name
    segment_type
    prompts {
      id
      segment_id
      text
    }
  }
  session_phrases {
    speech_phrase {
      id
      priority
      preload
      is_shared
      category
      content
    }
  }
  surveys {
    batch
    description
    survey_questions {
      question
      type
    }
  }
}
    `;
export const SessionTemplateSummaryFragmentDoc = gql`
    fragment SessionTemplateSummary on session {
  id
  session_name
  company {
    id
    name
  }
  program {
    id
    name
    company_id
  }
}
    `;
export const SpeechPhraseFragmentDoc = gql`
    fragment SpeechPhrase on speech_phrases {
  id
  category
  priority
  preload
  content
  is_shared
}
    `;
export const QuestionFragmentDoc = gql`
    fragment Question on survey_questions {
  id
  question
  type
  survey {
    id
    batch
  }
}
    `;
export const GetAgoraTempTokenDocument = gql`
    query GetAgoraTempToken($sessionId: String!) {
  getAgoraTempToken(sessionId: $sessionId) {
    ...TempAgoraToken
  }
}
    ${TempAgoraTokenFragmentDoc}`;

/**
 * __useGetAgoraTempTokenQuery__
 *
 * To run a query within a React component, call `useGetAgoraTempTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgoraTempTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgoraTempTokenQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetAgoraTempTokenQuery(baseOptions: Apollo.QueryHookOptions<GetAgoraTempTokenQuery, GetAgoraTempTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgoraTempTokenQuery, GetAgoraTempTokenQueryVariables>(GetAgoraTempTokenDocument, options);
      }
export function useGetAgoraTempTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgoraTempTokenQuery, GetAgoraTempTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgoraTempTokenQuery, GetAgoraTempTokenQueryVariables>(GetAgoraTempTokenDocument, options);
        }
export type GetAgoraTempTokenQueryHookResult = ReturnType<typeof useGetAgoraTempTokenQuery>;
export type GetAgoraTempTokenLazyQueryHookResult = ReturnType<typeof useGetAgoraTempTokenLazyQuery>;
export type GetAgoraTempTokenQueryResult = Apollo.QueryResult<GetAgoraTempTokenQuery, GetAgoraTempTokenQueryVariables>;
export const StartRecordingDocument = gql`
    mutation StartRecording($token: String!, $sessionId: String!) {
  startRecording(token: $token, sessionId: $sessionId) {
    ...AgoraRecordingFragment
  }
}
    ${AgoraRecordingFragmentFragmentDoc}`;
export type StartRecordingMutationFn = Apollo.MutationFunction<StartRecordingMutation, StartRecordingMutationVariables>;

/**
 * __useStartRecordingMutation__
 *
 * To run a mutation, you first call `useStartRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRecordingMutation, { data, loading, error }] = useStartRecordingMutation({
 *   variables: {
 *      token: // value for 'token'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useStartRecordingMutation(baseOptions?: Apollo.MutationHookOptions<StartRecordingMutation, StartRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartRecordingMutation, StartRecordingMutationVariables>(StartRecordingDocument, options);
      }
export type StartRecordingMutationHookResult = ReturnType<typeof useStartRecordingMutation>;
export type StartRecordingMutationResult = Apollo.MutationResult<StartRecordingMutation>;
export type StartRecordingMutationOptions = Apollo.BaseMutationOptions<StartRecordingMutation, StartRecordingMutationVariables>;
export const GetCompaniesDocument = gql`
    query GetCompanies($order_by: [company_order_by!] = {}) {
  company(where: {deleted_at: {_is_null: true}}, order_by: $order_by) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const EventsDocument = gql`
    subscription Events($sessionId: uuid) {
  event(where: {session_id: {_eq: $sessionId}}, order_by: {created_at: desc}) {
    id
    email
    event_type {
      name
    }
    metadata
    created_at
  }
}
    `;

/**
 * __useEventsSubscription__
 *
 * To run a query within a React component, call `useEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEventsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EventsSubscription, EventsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventsSubscription, EventsSubscriptionVariables>(EventsDocument, options);
      }
export type EventsSubscriptionHookResult = ReturnType<typeof useEventsSubscription>;
export type EventsSubscriptionResult = Apollo.SubscriptionResult<EventsSubscription>;
export const RegisterEventDocument = gql`
    mutation RegisterEvent($sessionId: String!, $eventTypeName: String!, $metadata: String!, $clientTimestamp: String!) {
  registerEvent(
    eventTypeName: $eventTypeName
    metadata: $metadata
    sessionId: $sessionId
    clientTimestamp: $clientTimestamp
  ) {
    id
  }
}
    `;
export type RegisterEventMutationFn = Apollo.MutationFunction<RegisterEventMutation, RegisterEventMutationVariables>;

/**
 * __useRegisterEventMutation__
 *
 * To run a mutation, you first call `useRegisterEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEventMutation, { data, loading, error }] = useRegisterEventMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      eventTypeName: // value for 'eventTypeName'
 *      metadata: // value for 'metadata'
 *      clientTimestamp: // value for 'clientTimestamp'
 *   },
 * });
 */
export function useRegisterEventMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEventMutation, RegisterEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEventMutation, RegisterEventMutationVariables>(RegisterEventDocument, options);
      }
export type RegisterEventMutationHookResult = ReturnType<typeof useRegisterEventMutation>;
export type RegisterEventMutationResult = Apollo.MutationResult<RegisterEventMutation>;
export type RegisterEventMutationOptions = Apollo.BaseMutationOptions<RegisterEventMutation, RegisterEventMutationVariables>;
export const SendTalkTimeMessageDocument = gql`
    mutation sendTalkTimeMessage($sessionId: String!, $segmentName: String!, $segmentType: String!) {
  sendTalkTimeMessage(
    sessionId: $sessionId
    segmentName: $segmentName
    segmentType: $segmentType
  ) {
    id
  }
}
    `;
export type SendTalkTimeMessageMutationFn = Apollo.MutationFunction<SendTalkTimeMessageMutation, SendTalkTimeMessageMutationVariables>;

/**
 * __useSendTalkTimeMessageMutation__
 *
 * To run a mutation, you first call `useSendTalkTimeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTalkTimeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTalkTimeMessageMutation, { data, loading, error }] = useSendTalkTimeMessageMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      segmentName: // value for 'segmentName'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSendTalkTimeMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTalkTimeMessageMutation, SendTalkTimeMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTalkTimeMessageMutation, SendTalkTimeMessageMutationVariables>(SendTalkTimeMessageDocument, options);
      }
export type SendTalkTimeMessageMutationHookResult = ReturnType<typeof useSendTalkTimeMessageMutation>;
export type SendTalkTimeMessageMutationResult = Apollo.MutationResult<SendTalkTimeMessageMutation>;
export type SendTalkTimeMessageMutationOptions = Apollo.BaseMutationOptions<SendTalkTimeMessageMutation, SendTalkTimeMessageMutationVariables>;
export const LogAuthSignInDocument = gql`
    mutation LogAuthSignIn($email: String!) {
  insert_logs_one(object: {action: auth_login, email: $email}) {
    id
    email
    action
  }
}
    `;
export type LogAuthSignInMutationFn = Apollo.MutationFunction<LogAuthSignInMutation, LogAuthSignInMutationVariables>;

/**
 * __useLogAuthSignInMutation__
 *
 * To run a mutation, you first call `useLogAuthSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogAuthSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logAuthSignInMutation, { data, loading, error }] = useLogAuthSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLogAuthSignInMutation(baseOptions?: Apollo.MutationHookOptions<LogAuthSignInMutation, LogAuthSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogAuthSignInMutation, LogAuthSignInMutationVariables>(LogAuthSignInDocument, options);
      }
export type LogAuthSignInMutationHookResult = ReturnType<typeof useLogAuthSignInMutation>;
export type LogAuthSignInMutationResult = Apollo.MutationResult<LogAuthSignInMutation>;
export type LogAuthSignInMutationOptions = Apollo.BaseMutationOptions<LogAuthSignInMutation, LogAuthSignInMutationVariables>;
export const LogAuthSignOutDocument = gql`
    mutation LogAuthSignOut($email: String!) {
  insert_logs_one(object: {action: auth_logout, email: $email}) {
    id
    email
    action
  }
}
    `;
export type LogAuthSignOutMutationFn = Apollo.MutationFunction<LogAuthSignOutMutation, LogAuthSignOutMutationVariables>;

/**
 * __useLogAuthSignOutMutation__
 *
 * To run a mutation, you first call `useLogAuthSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogAuthSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logAuthSignOutMutation, { data, loading, error }] = useLogAuthSignOutMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLogAuthSignOutMutation(baseOptions?: Apollo.MutationHookOptions<LogAuthSignOutMutation, LogAuthSignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogAuthSignOutMutation, LogAuthSignOutMutationVariables>(LogAuthSignOutDocument, options);
      }
export type LogAuthSignOutMutationHookResult = ReturnType<typeof useLogAuthSignOutMutation>;
export type LogAuthSignOutMutationResult = Apollo.MutationResult<LogAuthSignOutMutation>;
export type LogAuthSignOutMutationOptions = Apollo.BaseMutationOptions<LogAuthSignOutMutation, LogAuthSignOutMutationVariables>;
export const GetAllMediaDocument = gql`
    query GetAllMedia {
  media(order_by: {created_at: desc}) {
    ...MediaSummary
  }
}
    ${MediaSummaryFragmentDoc}`;

/**
 * __useGetAllMediaQuery__
 *
 * To run a query within a React component, call `useGetAllMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMediaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMediaQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMediaQuery, GetAllMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMediaQuery, GetAllMediaQueryVariables>(GetAllMediaDocument, options);
      }
export function useGetAllMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMediaQuery, GetAllMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMediaQuery, GetAllMediaQueryVariables>(GetAllMediaDocument, options);
        }
export type GetAllMediaQueryHookResult = ReturnType<typeof useGetAllMediaQuery>;
export type GetAllMediaLazyQueryHookResult = ReturnType<typeof useGetAllMediaLazyQuery>;
export type GetAllMediaQueryResult = Apollo.QueryResult<GetAllMediaQuery, GetAllMediaQueryVariables>;
export const InsertMediaOneDocument = gql`
    mutation InsertMediaOne($object: media_insert_input!) {
  insert_media_one(object: $object) {
    name
    storage_key
    content_type
    id
  }
}
    `;
export type InsertMediaOneMutationFn = Apollo.MutationFunction<InsertMediaOneMutation, InsertMediaOneMutationVariables>;

/**
 * __useInsertMediaOneMutation__
 *
 * To run a mutation, you first call `useInsertMediaOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMediaOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMediaOneMutation, { data, loading, error }] = useInsertMediaOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertMediaOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertMediaOneMutation, InsertMediaOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMediaOneMutation, InsertMediaOneMutationVariables>(InsertMediaOneDocument, options);
      }
export type InsertMediaOneMutationHookResult = ReturnType<typeof useInsertMediaOneMutation>;
export type InsertMediaOneMutationResult = Apollo.MutationResult<InsertMediaOneMutation>;
export type InsertMediaOneMutationOptions = Apollo.BaseMutationOptions<InsertMediaOneMutation, InsertMediaOneMutationVariables>;
export const GetNotificationTemplatesBySessionIdDocument = gql`
    query GetNotificationTemplatesBySessionId($sessionId: uuid) {
  notification_templates(where: {session_id: {_eq: $sessionId}}) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;

/**
 * __useGetNotificationTemplatesBySessionIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplatesBySessionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplatesBySessionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplatesBySessionIdQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetNotificationTemplatesBySessionIdQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationTemplatesBySessionIdQuery, GetNotificationTemplatesBySessionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplatesBySessionIdQuery, GetNotificationTemplatesBySessionIdQueryVariables>(GetNotificationTemplatesBySessionIdDocument, options);
      }
export function useGetNotificationTemplatesBySessionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplatesBySessionIdQuery, GetNotificationTemplatesBySessionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplatesBySessionIdQuery, GetNotificationTemplatesBySessionIdQueryVariables>(GetNotificationTemplatesBySessionIdDocument, options);
        }
export type GetNotificationTemplatesBySessionIdQueryHookResult = ReturnType<typeof useGetNotificationTemplatesBySessionIdQuery>;
export type GetNotificationTemplatesBySessionIdLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplatesBySessionIdLazyQuery>;
export type GetNotificationTemplatesBySessionIdQueryResult = Apollo.QueryResult<GetNotificationTemplatesBySessionIdQuery, GetNotificationTemplatesBySessionIdQueryVariables>;
export const AddNotificationTemplatesToSessionDocument = gql`
    mutation AddNotificationTemplatesToSession($objects: [notification_templates_insert_input!]!) {
  insert_notification_templates(objects: $objects) {
    returning {
      ...NotificationTemplate
    }
  }
}
    ${NotificationTemplateFragmentDoc}`;
export type AddNotificationTemplatesToSessionMutationFn = Apollo.MutationFunction<AddNotificationTemplatesToSessionMutation, AddNotificationTemplatesToSessionMutationVariables>;

/**
 * __useAddNotificationTemplatesToSessionMutation__
 *
 * To run a mutation, you first call `useAddNotificationTemplatesToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationTemplatesToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationTemplatesToSessionMutation, { data, loading, error }] = useAddNotificationTemplatesToSessionMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddNotificationTemplatesToSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationTemplatesToSessionMutation, AddNotificationTemplatesToSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationTemplatesToSessionMutation, AddNotificationTemplatesToSessionMutationVariables>(AddNotificationTemplatesToSessionDocument, options);
      }
export type AddNotificationTemplatesToSessionMutationHookResult = ReturnType<typeof useAddNotificationTemplatesToSessionMutation>;
export type AddNotificationTemplatesToSessionMutationResult = Apollo.MutationResult<AddNotificationTemplatesToSessionMutation>;
export type AddNotificationTemplatesToSessionMutationOptions = Apollo.BaseMutationOptions<AddNotificationTemplatesToSessionMutation, AddNotificationTemplatesToSessionMutationVariables>;
export const UpdateNotificationTemplateDocument = gql`
    mutation UpdateNotificationTemplate($id: uuid!, $notificationTemplate: notification_templates_set_input!) {
  update_notification_templates_by_pk(
    pk_columns: {id: $id}
    _set: $notificationTemplate
  ) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;
export type UpdateNotificationTemplateMutationFn = Apollo.MutationFunction<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;

/**
 * __useUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTemplateMutation, { data, loading, error }] = useUpdateNotificationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notificationTemplate: // value for 'notificationTemplate'
 *   },
 * });
 */
export function useUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>(UpdateNotificationTemplateDocument, options);
      }
export type UpdateNotificationTemplateMutationHookResult = ReturnType<typeof useUpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationResult = Apollo.MutationResult<UpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;
export const DeleteNotificationTemplateDocument = gql`
    mutation DeleteNotificationTemplate($id: uuid!) {
  delete_notification_templates_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteNotificationTemplateMutationFn = Apollo.MutationFunction<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;

/**
 * __useDeleteNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTemplateMutation, { data, loading, error }] = useDeleteNotificationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>(DeleteNotificationTemplateDocument, options);
      }
export type DeleteNotificationTemplateMutationHookResult = ReturnType<typeof useDeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationResult = Apollo.MutationResult<DeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;
export const UpdateConfirmationStatusDocument = gql`
    mutation UpdateConfirmationStatus($confirmation_status: confirmation_status_enum!, $id: uuid!) {
  update_participant_session_by_pk(
    _set: {confirmation_status: $confirmation_status}
    pk_columns: {id: $id}
  ) {
    id
    participant_id
  }
}
    `;
export type UpdateConfirmationStatusMutationFn = Apollo.MutationFunction<UpdateConfirmationStatusMutation, UpdateConfirmationStatusMutationVariables>;

/**
 * __useUpdateConfirmationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConfirmationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfirmationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfirmationStatusMutation, { data, loading, error }] = useUpdateConfirmationStatusMutation({
 *   variables: {
 *      confirmation_status: // value for 'confirmation_status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateConfirmationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfirmationStatusMutation, UpdateConfirmationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConfirmationStatusMutation, UpdateConfirmationStatusMutationVariables>(UpdateConfirmationStatusDocument, options);
      }
export type UpdateConfirmationStatusMutationHookResult = ReturnType<typeof useUpdateConfirmationStatusMutation>;
export type UpdateConfirmationStatusMutationResult = Apollo.MutationResult<UpdateConfirmationStatusMutation>;
export type UpdateConfirmationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateConfirmationStatusMutation, UpdateConfirmationStatusMutationVariables>;
export const GetParticipantsBySessionIdDocument = gql`
    query GetParticipantsBySessionId($sessionId: uuid) {
  participant_session(
    where: {session_id: {_eq: $sessionId}, deleted_at: {_is_null: true}}
  ) {
    ...ParticipantSession
  }
}
    ${ParticipantSessionFragmentDoc}`;

/**
 * __useGetParticipantsBySessionIdQuery__
 *
 * To run a query within a React component, call `useGetParticipantsBySessionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsBySessionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsBySessionIdQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetParticipantsBySessionIdQuery(baseOptions?: Apollo.QueryHookOptions<GetParticipantsBySessionIdQuery, GetParticipantsBySessionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsBySessionIdQuery, GetParticipantsBySessionIdQueryVariables>(GetParticipantsBySessionIdDocument, options);
      }
export function useGetParticipantsBySessionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsBySessionIdQuery, GetParticipantsBySessionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsBySessionIdQuery, GetParticipantsBySessionIdQueryVariables>(GetParticipantsBySessionIdDocument, options);
        }
export type GetParticipantsBySessionIdQueryHookResult = ReturnType<typeof useGetParticipantsBySessionIdQuery>;
export type GetParticipantsBySessionIdLazyQueryHookResult = ReturnType<typeof useGetParticipantsBySessionIdLazyQuery>;
export type GetParticipantsBySessionIdQueryResult = Apollo.QueryResult<GetParticipantsBySessionIdQuery, GetParticipantsBySessionIdQueryVariables>;
export const GetParticipantsByCompanyIdDocument = gql`
    query GetParticipantsByCompanyId($companyId: uuid!) {
  participant(
    where: {company_id: {_eq: $companyId}, deleted_at: {_is_null: true}}
  ) {
    ...Participant
  }
}
    ${ParticipantFragmentDoc}`;

/**
 * __useGetParticipantsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetParticipantsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetParticipantsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsByCompanyIdQuery, GetParticipantsByCompanyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsByCompanyIdQuery, GetParticipantsByCompanyIdQueryVariables>(GetParticipantsByCompanyIdDocument, options);
      }
export function useGetParticipantsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsByCompanyIdQuery, GetParticipantsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsByCompanyIdQuery, GetParticipantsByCompanyIdQueryVariables>(GetParticipantsByCompanyIdDocument, options);
        }
export type GetParticipantsByCompanyIdQueryHookResult = ReturnType<typeof useGetParticipantsByCompanyIdQuery>;
export type GetParticipantsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetParticipantsByCompanyIdLazyQuery>;
export type GetParticipantsByCompanyIdQueryResult = Apollo.QueryResult<GetParticipantsByCompanyIdQuery, GetParticipantsByCompanyIdQueryVariables>;
export const DeleteSessionParticipantByIdDocument = gql`
    mutation DeleteSessionParticipantById($id: uuid!, $deletedAt: timestamptz!) {
  update_participant_session_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: $deletedAt}
  ) {
    id
  }
}
    `;
export type DeleteSessionParticipantByIdMutationFn = Apollo.MutationFunction<DeleteSessionParticipantByIdMutation, DeleteSessionParticipantByIdMutationVariables>;

/**
 * __useDeleteSessionParticipantByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSessionParticipantByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionParticipantByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionParticipantByIdMutation, { data, loading, error }] = useDeleteSessionParticipantByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteSessionParticipantByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionParticipantByIdMutation, DeleteSessionParticipantByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionParticipantByIdMutation, DeleteSessionParticipantByIdMutationVariables>(DeleteSessionParticipantByIdDocument, options);
      }
export type DeleteSessionParticipantByIdMutationHookResult = ReturnType<typeof useDeleteSessionParticipantByIdMutation>;
export type DeleteSessionParticipantByIdMutationResult = Apollo.MutationResult<DeleteSessionParticipantByIdMutation>;
export type DeleteSessionParticipantByIdMutationOptions = Apollo.BaseMutationOptions<DeleteSessionParticipantByIdMutation, DeleteSessionParticipantByIdMutationVariables>;
export const AddSessionParticipantDocument = gql`
    mutation AddSessionParticipant($sessionId: uuid!, $participantId: uuid!) {
  insert_participant_session_one(
    object: {participant_id: $participantId, session_id: $sessionId}
  ) {
    id
  }
}
    `;
export type AddSessionParticipantMutationFn = Apollo.MutationFunction<AddSessionParticipantMutation, AddSessionParticipantMutationVariables>;

/**
 * __useAddSessionParticipantMutation__
 *
 * To run a mutation, you first call `useAddSessionParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSessionParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSessionParticipantMutation, { data, loading, error }] = useAddSessionParticipantMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useAddSessionParticipantMutation(baseOptions?: Apollo.MutationHookOptions<AddSessionParticipantMutation, AddSessionParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSessionParticipantMutation, AddSessionParticipantMutationVariables>(AddSessionParticipantDocument, options);
      }
export type AddSessionParticipantMutationHookResult = ReturnType<typeof useAddSessionParticipantMutation>;
export type AddSessionParticipantMutationResult = Apollo.MutationResult<AddSessionParticipantMutation>;
export type AddSessionParticipantMutationOptions = Apollo.BaseMutationOptions<AddSessionParticipantMutation, AddSessionParticipantMutationVariables>;
export const UpdateSessionParticipantStatusDocument = gql`
    mutation UpdateSessionParticipantStatus($id: uuid!, $deletedAt: timestamptz = null) {
  update_participant_session_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: $deletedAt}
  ) {
    id
  }
}
    `;
export type UpdateSessionParticipantStatusMutationFn = Apollo.MutationFunction<UpdateSessionParticipantStatusMutation, UpdateSessionParticipantStatusMutationVariables>;

/**
 * __useUpdateSessionParticipantStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSessionParticipantStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionParticipantStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionParticipantStatusMutation, { data, loading, error }] = useUpdateSessionParticipantStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useUpdateSessionParticipantStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionParticipantStatusMutation, UpdateSessionParticipantStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionParticipantStatusMutation, UpdateSessionParticipantStatusMutationVariables>(UpdateSessionParticipantStatusDocument, options);
      }
export type UpdateSessionParticipantStatusMutationHookResult = ReturnType<typeof useUpdateSessionParticipantStatusMutation>;
export type UpdateSessionParticipantStatusMutationResult = Apollo.MutationResult<UpdateSessionParticipantStatusMutation>;
export type UpdateSessionParticipantStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSessionParticipantStatusMutation, UpdateSessionParticipantStatusMutationVariables>;
export const SendRegistrationMailDocument = gql`
    mutation SendRegistrationMail($participantEmail: String!, $participantId: String!, $participantFirstName: String!, $participantLastName: String!, $sessionDateTime: String!, $sessionId: String!, $sessionName: String!, $companyName: String!, $sessionTimezone: String!, $participantPreferredName: String) {
  emailRegisterSession(
    participantEmail: $participantEmail
    participantFirstName: $participantFirstName
    participantId: $participantId
    participantLastName: $participantLastName
    sessionDateTime: $sessionDateTime
    sessionId: $sessionId
    sessionName: $sessionName
    companyName: $companyName
    sessionTimezone: $sessionTimezone
    participantPreferredName: $participantPreferredName
  ) {
    success
  }
}
    `;
export type SendRegistrationMailMutationFn = Apollo.MutationFunction<SendRegistrationMailMutation, SendRegistrationMailMutationVariables>;

/**
 * __useSendRegistrationMailMutation__
 *
 * To run a mutation, you first call `useSendRegistrationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRegistrationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRegistrationMailMutation, { data, loading, error }] = useSendRegistrationMailMutation({
 *   variables: {
 *      participantEmail: // value for 'participantEmail'
 *      participantId: // value for 'participantId'
 *      participantFirstName: // value for 'participantFirstName'
 *      participantLastName: // value for 'participantLastName'
 *      sessionDateTime: // value for 'sessionDateTime'
 *      sessionId: // value for 'sessionId'
 *      sessionName: // value for 'sessionName'
 *      companyName: // value for 'companyName'
 *      sessionTimezone: // value for 'sessionTimezone'
 *      participantPreferredName: // value for 'participantPreferredName'
 *   },
 * });
 */
export function useSendRegistrationMailMutation(baseOptions?: Apollo.MutationHookOptions<SendRegistrationMailMutation, SendRegistrationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRegistrationMailMutation, SendRegistrationMailMutationVariables>(SendRegistrationMailDocument, options);
      }
export type SendRegistrationMailMutationHookResult = ReturnType<typeof useSendRegistrationMailMutation>;
export type SendRegistrationMailMutationResult = Apollo.MutationResult<SendRegistrationMailMutation>;
export type SendRegistrationMailMutationOptions = Apollo.BaseMutationOptions<SendRegistrationMailMutation, SendRegistrationMailMutationVariables>;
export const ObserveActiveParticipantsBySessionIdDocument = gql`
    subscription ObserveActiveParticipantsBySessionId($sessionId: uuid!) {
  user_presence(
    where: {session_id: {_eq: $sessionId}, status: {_eq: "online"}}
    order_by: {created_at: asc}
  ) {
    ...UserPresence
  }
}
    ${UserPresenceFragmentDoc}`;

/**
 * __useObserveActiveParticipantsBySessionIdSubscription__
 *
 * To run a query within a React component, call `useObserveActiveParticipantsBySessionIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveActiveParticipantsBySessionIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveActiveParticipantsBySessionIdSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useObserveActiveParticipantsBySessionIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<ObserveActiveParticipantsBySessionIdSubscription, ObserveActiveParticipantsBySessionIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveActiveParticipantsBySessionIdSubscription, ObserveActiveParticipantsBySessionIdSubscriptionVariables>(ObserveActiveParticipantsBySessionIdDocument, options);
      }
export type ObserveActiveParticipantsBySessionIdSubscriptionHookResult = ReturnType<typeof useObserveActiveParticipantsBySessionIdSubscription>;
export type ObserveActiveParticipantsBySessionIdSubscriptionResult = Apollo.SubscriptionResult<ObserveActiveParticipantsBySessionIdSubscription>;
export const MoveParticipantToSubgroupDocument = gql`
    mutation MoveParticipantToSubgroup($userId: uuid!, $newSessionId: uuid!, $oldSessionId: uuid!) {
  update_participant_session(
    where: {participant_id: {_eq: $userId}, session_id: {_eq: $oldSessionId}}
    _set: {session_id: $newSessionId}
  ) {
    affected_rows
  }
  update_user_presence(
    where: {user_id: {_eq: $userId}, session_id: {_eq: $oldSessionId}}
    _set: {session_id: $newSessionId}
  ) {
    affected_rows
  }
}
    `;
export type MoveParticipantToSubgroupMutationFn = Apollo.MutationFunction<MoveParticipantToSubgroupMutation, MoveParticipantToSubgroupMutationVariables>;

/**
 * __useMoveParticipantToSubgroupMutation__
 *
 * To run a mutation, you first call `useMoveParticipantToSubgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveParticipantToSubgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveParticipantToSubgroupMutation, { data, loading, error }] = useMoveParticipantToSubgroupMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      newSessionId: // value for 'newSessionId'
 *      oldSessionId: // value for 'oldSessionId'
 *   },
 * });
 */
export function useMoveParticipantToSubgroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveParticipantToSubgroupMutation, MoveParticipantToSubgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveParticipantToSubgroupMutation, MoveParticipantToSubgroupMutationVariables>(MoveParticipantToSubgroupDocument, options);
      }
export type MoveParticipantToSubgroupMutationHookResult = ReturnType<typeof useMoveParticipantToSubgroupMutation>;
export type MoveParticipantToSubgroupMutationResult = Apollo.MutationResult<MoveParticipantToSubgroupMutation>;
export type MoveParticipantToSubgroupMutationOptions = Apollo.BaseMutationOptions<MoveParticipantToSubgroupMutation, MoveParticipantToSubgroupMutationVariables>;
export const AddPrevalenceScoreRunDocument = gql`
    mutation AddPrevalenceScoreRun($object: nabu_prevalence_score_classification_runs_insert_input!) {
  insert_nabu_prevalence_score_classification_runs_one(object: $object) {
    id
    owner
    program_id
    status
    storage_path
    created_at
  }
}
    `;
export type AddPrevalenceScoreRunMutationFn = Apollo.MutationFunction<AddPrevalenceScoreRunMutation, AddPrevalenceScoreRunMutationVariables>;

/**
 * __useAddPrevalenceScoreRunMutation__
 *
 * To run a mutation, you first call `useAddPrevalenceScoreRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPrevalenceScoreRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPrevalenceScoreRunMutation, { data, loading, error }] = useAddPrevalenceScoreRunMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddPrevalenceScoreRunMutation(baseOptions?: Apollo.MutationHookOptions<AddPrevalenceScoreRunMutation, AddPrevalenceScoreRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPrevalenceScoreRunMutation, AddPrevalenceScoreRunMutationVariables>(AddPrevalenceScoreRunDocument, options);
      }
export type AddPrevalenceScoreRunMutationHookResult = ReturnType<typeof useAddPrevalenceScoreRunMutation>;
export type AddPrevalenceScoreRunMutationResult = Apollo.MutationResult<AddPrevalenceScoreRunMutation>;
export type AddPrevalenceScoreRunMutationOptions = Apollo.BaseMutationOptions<AddPrevalenceScoreRunMutation, AddPrevalenceScoreRunMutationVariables>;
export const GetPrevalenceScoreRunsDocument = gql`
    query GetPrevalenceScoreRuns($program_id: uuid!) {
  nabu_prevalence_score_classification_runs(
    where: {program_id: {_eq: $program_id}}
  ) {
    id
    owner
    program_id
    status
    storage_path
    created_at
  }
}
    `;

/**
 * __useGetPrevalenceScoreRunsQuery__
 *
 * To run a query within a React component, call `useGetPrevalenceScoreRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrevalenceScoreRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrevalenceScoreRunsQuery({
 *   variables: {
 *      program_id: // value for 'program_id'
 *   },
 * });
 */
export function useGetPrevalenceScoreRunsQuery(baseOptions: Apollo.QueryHookOptions<GetPrevalenceScoreRunsQuery, GetPrevalenceScoreRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrevalenceScoreRunsQuery, GetPrevalenceScoreRunsQueryVariables>(GetPrevalenceScoreRunsDocument, options);
      }
export function useGetPrevalenceScoreRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrevalenceScoreRunsQuery, GetPrevalenceScoreRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrevalenceScoreRunsQuery, GetPrevalenceScoreRunsQueryVariables>(GetPrevalenceScoreRunsDocument, options);
        }
export type GetPrevalenceScoreRunsQueryHookResult = ReturnType<typeof useGetPrevalenceScoreRunsQuery>;
export type GetPrevalenceScoreRunsLazyQueryHookResult = ReturnType<typeof useGetPrevalenceScoreRunsLazyQuery>;
export type GetPrevalenceScoreRunsQueryResult = Apollo.QueryResult<GetPrevalenceScoreRunsQuery, GetPrevalenceScoreRunsQueryVariables>;
export const GetCompanyProgramsDocument = gql`
    query GetCompanyPrograms($company_id: uuid!, $order_by: [program_order_by!] = {}) {
  program(where: {company_id: {_eq: $company_id}}, order_by: $order_by) {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useGetCompanyProgramsQuery__
 *
 * To run a query within a React component, call `useGetCompanyProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProgramsQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetCompanyProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProgramsQuery, GetCompanyProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProgramsQuery, GetCompanyProgramsQueryVariables>(GetCompanyProgramsDocument, options);
      }
export function useGetCompanyProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProgramsQuery, GetCompanyProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProgramsQuery, GetCompanyProgramsQueryVariables>(GetCompanyProgramsDocument, options);
        }
export type GetCompanyProgramsQueryHookResult = ReturnType<typeof useGetCompanyProgramsQuery>;
export type GetCompanyProgramsLazyQueryHookResult = ReturnType<typeof useGetCompanyProgramsLazyQuery>;
export type GetCompanyProgramsQueryResult = Apollo.QueryResult<GetCompanyProgramsQuery, GetCompanyProgramsQueryVariables>;
export const GetProgramDocument = gql`
    query GetProgram($program_id: uuid!) {
  program_by_pk(id: $program_id) {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      program_id: // value for 'program_id'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: Apollo.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramQueryResult = Apollo.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const CreateProgramDocument = gql`
    mutation CreateProgram($company_id: uuid!, $name: String!) {
  insert_program_one(object: {company_id: $company_id, name: $name}) {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
      }
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<CreateProgramMutation, CreateProgramMutationVariables>;
export const UpdateProgramDocument = gql`
    mutation UpdateProgram($program_id: uuid!, $name: String!) {
  update_program_by_pk(pk_columns: {id: $program_id}, _set: {name: $name}) {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      program_id: // value for 'program_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const GetRegistrationLinkDocument = gql`
    mutation GetRegistrationLink($programId: String!) {
  getProgramRegistrationLink(programId: $programId) {
    link
  }
}
    `;
export type GetRegistrationLinkMutationFn = Apollo.MutationFunction<GetRegistrationLinkMutation, GetRegistrationLinkMutationVariables>;

/**
 * __useGetRegistrationLinkMutation__
 *
 * To run a mutation, you first call `useGetRegistrationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRegistrationLinkMutation, { data, loading, error }] = useGetRegistrationLinkMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetRegistrationLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetRegistrationLinkMutation, GetRegistrationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRegistrationLinkMutation, GetRegistrationLinkMutationVariables>(GetRegistrationLinkDocument, options);
      }
export type GetRegistrationLinkMutationHookResult = ReturnType<typeof useGetRegistrationLinkMutation>;
export type GetRegistrationLinkMutationResult = Apollo.MutationResult<GetRegistrationLinkMutation>;
export type GetRegistrationLinkMutationOptions = Apollo.BaseMutationOptions<GetRegistrationLinkMutation, GetRegistrationLinkMutationVariables>;
export const GetSegmentPromptsDocument = gql`
    query GetSegmentPrompts($segmentId: uuid) {
  prompts(where: {segment_id: {_eq: $segmentId}}) {
    ...Prompt
  }
}
    ${PromptFragmentDoc}`;

/**
 * __useGetSegmentPromptsQuery__
 *
 * To run a query within a React component, call `useGetSegmentPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentPromptsQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useGetSegmentPromptsQuery(baseOptions?: Apollo.QueryHookOptions<GetSegmentPromptsQuery, GetSegmentPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentPromptsQuery, GetSegmentPromptsQueryVariables>(GetSegmentPromptsDocument, options);
      }
export function useGetSegmentPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentPromptsQuery, GetSegmentPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentPromptsQuery, GetSegmentPromptsQueryVariables>(GetSegmentPromptsDocument, options);
        }
export type GetSegmentPromptsQueryHookResult = ReturnType<typeof useGetSegmentPromptsQuery>;
export type GetSegmentPromptsLazyQueryHookResult = ReturnType<typeof useGetSegmentPromptsLazyQuery>;
export type GetSegmentPromptsQueryResult = Apollo.QueryResult<GetSegmentPromptsQuery, GetSegmentPromptsQueryVariables>;
export const InsertPromptDocument = gql`
    mutation InsertPrompt($object: prompts_insert_input!) {
  insert_prompts_one(object: $object) {
    ...Prompt
  }
}
    ${PromptFragmentDoc}`;
export type InsertPromptMutationFn = Apollo.MutationFunction<InsertPromptMutation, InsertPromptMutationVariables>;

/**
 * __useInsertPromptMutation__
 *
 * To run a mutation, you first call `useInsertPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPromptMutation, { data, loading, error }] = useInsertPromptMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPromptMutation(baseOptions?: Apollo.MutationHookOptions<InsertPromptMutation, InsertPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPromptMutation, InsertPromptMutationVariables>(InsertPromptDocument, options);
      }
export type InsertPromptMutationHookResult = ReturnType<typeof useInsertPromptMutation>;
export type InsertPromptMutationResult = Apollo.MutationResult<InsertPromptMutation>;
export type InsertPromptMutationOptions = Apollo.BaseMutationOptions<InsertPromptMutation, InsertPromptMutationVariables>;
export const UpdatePromptDocument = gql`
    mutation UpdatePrompt($id: uuid!, $text: String!) {
  update_prompts_by_pk(pk_columns: {id: $id}, _set: {text: $text}) {
    ...Prompt
  }
}
    ${PromptFragmentDoc}`;
export type UpdatePromptMutationFn = Apollo.MutationFunction<UpdatePromptMutation, UpdatePromptMutationVariables>;

/**
 * __useUpdatePromptMutation__
 *
 * To run a mutation, you first call `useUpdatePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromptMutation, { data, loading, error }] = useUpdatePromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdatePromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromptMutation, UpdatePromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromptMutation, UpdatePromptMutationVariables>(UpdatePromptDocument, options);
      }
export type UpdatePromptMutationHookResult = ReturnType<typeof useUpdatePromptMutation>;
export type UpdatePromptMutationResult = Apollo.MutationResult<UpdatePromptMutation>;
export type UpdatePromptMutationOptions = Apollo.BaseMutationOptions<UpdatePromptMutation, UpdatePromptMutationVariables>;
export const DeletePromptDocument = gql`
    mutation DeletePrompt($id: uuid!) {
  delete_prompts_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePromptMutationFn = Apollo.MutationFunction<DeletePromptMutation, DeletePromptMutationVariables>;

/**
 * __useDeletePromptMutation__
 *
 * To run a mutation, you first call `useDeletePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromptMutation, { data, loading, error }] = useDeletePromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePromptMutation(baseOptions?: Apollo.MutationHookOptions<DeletePromptMutation, DeletePromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePromptMutation, DeletePromptMutationVariables>(DeletePromptDocument, options);
      }
export type DeletePromptMutationHookResult = ReturnType<typeof useDeletePromptMutation>;
export type DeletePromptMutationResult = Apollo.MutationResult<DeletePromptMutation>;
export type DeletePromptMutationOptions = Apollo.BaseMutationOptions<DeletePromptMutation, DeletePromptMutationVariables>;
export const GetSessionScriptDocument = gql`
    query GetSessionScript($sessionId: uuid) {
  scripts(where: {session_id: {_eq: $sessionId}}, order_by: {order: asc}) {
    ...Segment
  }
}
    ${SegmentFragmentDoc}`;

/**
 * __useGetSessionScriptQuery__
 *
 * To run a query within a React component, call `useGetSessionScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionScriptQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionScriptQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionScriptQuery, GetSessionScriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionScriptQuery, GetSessionScriptQueryVariables>(GetSessionScriptDocument, options);
      }
export function useGetSessionScriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionScriptQuery, GetSessionScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionScriptQuery, GetSessionScriptQueryVariables>(GetSessionScriptDocument, options);
        }
export type GetSessionScriptQueryHookResult = ReturnType<typeof useGetSessionScriptQuery>;
export type GetSessionScriptLazyQueryHookResult = ReturnType<typeof useGetSessionScriptLazyQuery>;
export type GetSessionScriptQueryResult = Apollo.QueryResult<GetSessionScriptQuery, GetSessionScriptQueryVariables>;
export const InsertScriptDocument = gql`
    mutation InsertScript($objects: [scripts_insert_input!]!) {
  insert_scripts(objects: $objects) {
    returning {
      ...Segment
    }
  }
}
    ${SegmentFragmentDoc}`;
export type InsertScriptMutationFn = Apollo.MutationFunction<InsertScriptMutation, InsertScriptMutationVariables>;

/**
 * __useInsertScriptMutation__
 *
 * To run a mutation, you first call `useInsertScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertScriptMutation, { data, loading, error }] = useInsertScriptMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertScriptMutation(baseOptions?: Apollo.MutationHookOptions<InsertScriptMutation, InsertScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertScriptMutation, InsertScriptMutationVariables>(InsertScriptDocument, options);
      }
export type InsertScriptMutationHookResult = ReturnType<typeof useInsertScriptMutation>;
export type InsertScriptMutationResult = Apollo.MutationResult<InsertScriptMutation>;
export type InsertScriptMutationOptions = Apollo.BaseMutationOptions<InsertScriptMutation, InsertScriptMutationVariables>;
export const UpdateScriptInfoDocument = gql`
    mutation UpdateScriptInfo($id: uuid!, $segment_name: String!, $segment_media: uuid = null) {
  update_scripts(
    where: {id: {_eq: $id}}
    _set: {segment_name: $segment_name, media_id: $segment_media}
  ) {
    returning {
      ...Segment
    }
  }
}
    ${SegmentFragmentDoc}`;
export type UpdateScriptInfoMutationFn = Apollo.MutationFunction<UpdateScriptInfoMutation, UpdateScriptInfoMutationVariables>;

/**
 * __useUpdateScriptInfoMutation__
 *
 * To run a mutation, you first call `useUpdateScriptInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScriptInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScriptInfoMutation, { data, loading, error }] = useUpdateScriptInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segment_name: // value for 'segment_name'
 *      segment_media: // value for 'segment_media'
 *   },
 * });
 */
export function useUpdateScriptInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScriptInfoMutation, UpdateScriptInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScriptInfoMutation, UpdateScriptInfoMutationVariables>(UpdateScriptInfoDocument, options);
      }
export type UpdateScriptInfoMutationHookResult = ReturnType<typeof useUpdateScriptInfoMutation>;
export type UpdateScriptInfoMutationResult = Apollo.MutationResult<UpdateScriptInfoMutation>;
export type UpdateScriptInfoMutationOptions = Apollo.BaseMutationOptions<UpdateScriptInfoMutation, UpdateScriptInfoMutationVariables>;
export const UpdateScriptPreferencesDocument = gql`
    mutation UpdateScriptPreferences($id: uuid!, $preferences: jsonb) {
  update_scripts(where: {id: {_eq: $id}}, _set: {preferences: $preferences}) {
    returning {
      ...Segment
    }
  }
}
    ${SegmentFragmentDoc}`;
export type UpdateScriptPreferencesMutationFn = Apollo.MutationFunction<UpdateScriptPreferencesMutation, UpdateScriptPreferencesMutationVariables>;

/**
 * __useUpdateScriptPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateScriptPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScriptPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScriptPreferencesMutation, { data, loading, error }] = useUpdateScriptPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useUpdateScriptPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScriptPreferencesMutation, UpdateScriptPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScriptPreferencesMutation, UpdateScriptPreferencesMutationVariables>(UpdateScriptPreferencesDocument, options);
      }
export type UpdateScriptPreferencesMutationHookResult = ReturnType<typeof useUpdateScriptPreferencesMutation>;
export type UpdateScriptPreferencesMutationResult = Apollo.MutationResult<UpdateScriptPreferencesMutation>;
export type UpdateScriptPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateScriptPreferencesMutation, UpdateScriptPreferencesMutationVariables>;
export const DeleteSessionScriptDocument = gql`
    mutation DeleteSessionScript($sessionId: uuid!) {
  delete_scripts(where: {session_id: {_eq: $sessionId}}) {
    affected_rows
  }
}
    `;
export type DeleteSessionScriptMutationFn = Apollo.MutationFunction<DeleteSessionScriptMutation, DeleteSessionScriptMutationVariables>;

/**
 * __useDeleteSessionScriptMutation__
 *
 * To run a mutation, you first call `useDeleteSessionScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionScriptMutation, { data, loading, error }] = useDeleteSessionScriptMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useDeleteSessionScriptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionScriptMutation, DeleteSessionScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionScriptMutation, DeleteSessionScriptMutationVariables>(DeleteSessionScriptDocument, options);
      }
export type DeleteSessionScriptMutationHookResult = ReturnType<typeof useDeleteSessionScriptMutation>;
export type DeleteSessionScriptMutationResult = Apollo.MutationResult<DeleteSessionScriptMutation>;
export type DeleteSessionScriptMutationOptions = Apollo.BaseMutationOptions<DeleteSessionScriptMutation, DeleteSessionScriptMutationVariables>;
export const DeleteScriptSegmentDocument = gql`
    mutation DeleteScriptSegment($id: uuid!) {
  delete_scripts_by_pk(id: $id) {
    segment_name
  }
}
    `;
export type DeleteScriptSegmentMutationFn = Apollo.MutationFunction<DeleteScriptSegmentMutation, DeleteScriptSegmentMutationVariables>;

/**
 * __useDeleteScriptSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteScriptSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScriptSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScriptSegmentMutation, { data, loading, error }] = useDeleteScriptSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScriptSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScriptSegmentMutation, DeleteScriptSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScriptSegmentMutation, DeleteScriptSegmentMutationVariables>(DeleteScriptSegmentDocument, options);
      }
export type DeleteScriptSegmentMutationHookResult = ReturnType<typeof useDeleteScriptSegmentMutation>;
export type DeleteScriptSegmentMutationResult = Apollo.MutationResult<DeleteScriptSegmentMutation>;
export type DeleteScriptSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteScriptSegmentMutation, DeleteScriptSegmentMutationVariables>;
export const SessionByIdDocument = gql`
    subscription SessionById($id: uuid) {
  session(where: {id: {_eq: $id}}) {
    ...Session
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useSessionByIdSubscription__
 *
 * To run a query within a React component, call `useSessionByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSessionByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionByIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionByIdSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SessionByIdSubscription, SessionByIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SessionByIdSubscription, SessionByIdSubscriptionVariables>(SessionByIdDocument, options);
      }
export type SessionByIdSubscriptionHookResult = ReturnType<typeof useSessionByIdSubscription>;
export type SessionByIdSubscriptionResult = Apollo.SubscriptionResult<SessionByIdSubscription>;
export const GetSessionsDocument = gql`
    query GetSessions($limit: Int!, $offset: Int!, $orderBy: [session_order_by!], $where: session_bool_exp) {
  session(limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
    ...Session
  }
  session_aggregate(where: {deleted_at: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useGetSessionsQuery__
 *
 * To run a query within a React component, call `useGetSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
      }
export function useGetSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
export type GetSessionsQueryHookResult = ReturnType<typeof useGetSessionsQuery>;
export type GetSessionsLazyQueryHookResult = ReturnType<typeof useGetSessionsLazyQuery>;
export type GetSessionsQueryResult = Apollo.QueryResult<GetSessionsQuery, GetSessionsQueryVariables>;
export const GetSessionByIdDocument = gql`
    query GetSessionById($id: uuid) {
  session(where: {id: {_eq: $id}}) {
    ...Session
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useGetSessionByIdQuery__
 *
 * To run a query within a React component, call `useGetSessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionByIdQuery, GetSessionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionByIdQuery, GetSessionByIdQueryVariables>(GetSessionByIdDocument, options);
      }
export function useGetSessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionByIdQuery, GetSessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionByIdQuery, GetSessionByIdQueryVariables>(GetSessionByIdDocument, options);
        }
export type GetSessionByIdQueryHookResult = ReturnType<typeof useGetSessionByIdQuery>;
export type GetSessionByIdLazyQueryHookResult = ReturnType<typeof useGetSessionByIdLazyQuery>;
export type GetSessionByIdQueryResult = Apollo.QueryResult<GetSessionByIdQuery, GetSessionByIdQueryVariables>;
export const FinishSessionDocument = gql`
    mutation FinishSession($sessionId: String!) {
  finishSession(sessionId: $sessionId) {
    sessionId
  }
}
    `;
export type FinishSessionMutationFn = Apollo.MutationFunction<FinishSessionMutation, FinishSessionMutationVariables>;

/**
 * __useFinishSessionMutation__
 *
 * To run a mutation, you first call `useFinishSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSessionMutation, { data, loading, error }] = useFinishSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useFinishSessionMutation(baseOptions?: Apollo.MutationHookOptions<FinishSessionMutation, FinishSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSessionMutation, FinishSessionMutationVariables>(FinishSessionDocument, options);
      }
export type FinishSessionMutationHookResult = ReturnType<typeof useFinishSessionMutation>;
export type FinishSessionMutationResult = Apollo.MutationResult<FinishSessionMutation>;
export type FinishSessionMutationOptions = Apollo.BaseMutationOptions<FinishSessionMutation, FinishSessionMutationVariables>;
export const ChangePreferencesDocument = gql`
    mutation ChangePreferences($sessionId: String!, $preferences: String!) {
  changePreferences(sessionId: $sessionId, preferences: $preferences) {
    id
  }
}
    `;
export type ChangePreferencesMutationFn = Apollo.MutationFunction<ChangePreferencesMutation, ChangePreferencesMutationVariables>;

/**
 * __useChangePreferencesMutation__
 *
 * To run a mutation, you first call `useChangePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePreferencesMutation, { data, loading, error }] = useChangePreferencesMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useChangePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ChangePreferencesMutation, ChangePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePreferencesMutation, ChangePreferencesMutationVariables>(ChangePreferencesDocument, options);
      }
export type ChangePreferencesMutationHookResult = ReturnType<typeof useChangePreferencesMutation>;
export type ChangePreferencesMutationResult = Apollo.MutationResult<ChangePreferencesMutation>;
export type ChangePreferencesMutationOptions = Apollo.BaseMutationOptions<ChangePreferencesMutation, ChangePreferencesMutationVariables>;
export const SoftDeleteSessionDocument = gql`
    mutation SoftDeleteSession($sessionId: uuid!, $deletedAtTimestamp: timestamptz!) {
  update_session(
    where: {id: {_eq: $sessionId}}
    _set: {deleted_at: $deletedAtTimestamp}
  ) {
    returning {
      id
    }
  }
}
    `;
export type SoftDeleteSessionMutationFn = Apollo.MutationFunction<SoftDeleteSessionMutation, SoftDeleteSessionMutationVariables>;

/**
 * __useSoftDeleteSessionMutation__
 *
 * To run a mutation, you first call `useSoftDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteSessionMutation, { data, loading, error }] = useSoftDeleteSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      deletedAtTimestamp: // value for 'deletedAtTimestamp'
 *   },
 * });
 */
export function useSoftDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteSessionMutation, SoftDeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteSessionMutation, SoftDeleteSessionMutationVariables>(SoftDeleteSessionDocument, options);
      }
export type SoftDeleteSessionMutationHookResult = ReturnType<typeof useSoftDeleteSessionMutation>;
export type SoftDeleteSessionMutationResult = Apollo.MutationResult<SoftDeleteSessionMutation>;
export type SoftDeleteSessionMutationOptions = Apollo.BaseMutationOptions<SoftDeleteSessionMutation, SoftDeleteSessionMutationVariables>;
export const InsertSessionDocument = gql`
    mutation InsertSession($session_name: String!, $program_id: uuid, $company_id: uuid, $date_time: timestamptz!, $timezone: String!, $is_template: Boolean!, $template_id: uuid, $is_multigroup: Boolean!, $max_participant_limit: Int!) {
  insert_session_one(
    object: {session_name: $session_name, company_id: $company_id, date_time: $date_time, timezone: $timezone, is_template: $is_template, template_id: $template_id, program_id: $program_id, is_multigroup: $is_multigroup, max_participant_limit: $max_participant_limit}
  ) {
    id
  }
}
    `;
export type InsertSessionMutationFn = Apollo.MutationFunction<InsertSessionMutation, InsertSessionMutationVariables>;

/**
 * __useInsertSessionMutation__
 *
 * To run a mutation, you first call `useInsertSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSessionMutation, { data, loading, error }] = useInsertSessionMutation({
 *   variables: {
 *      session_name: // value for 'session_name'
 *      program_id: // value for 'program_id'
 *      company_id: // value for 'company_id'
 *      date_time: // value for 'date_time'
 *      timezone: // value for 'timezone'
 *      is_template: // value for 'is_template'
 *      template_id: // value for 'template_id'
 *      is_multigroup: // value for 'is_multigroup'
 *      max_participant_limit: // value for 'max_participant_limit'
 *   },
 * });
 */
export function useInsertSessionMutation(baseOptions?: Apollo.MutationHookOptions<InsertSessionMutation, InsertSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSessionMutation, InsertSessionMutationVariables>(InsertSessionDocument, options);
      }
export type InsertSessionMutationHookResult = ReturnType<typeof useInsertSessionMutation>;
export type InsertSessionMutationResult = Apollo.MutationResult<InsertSessionMutation>;
export type InsertSessionMutationOptions = Apollo.BaseMutationOptions<InsertSessionMutation, InsertSessionMutationVariables>;
export const UpdateSessionByIdDocument = gql`
    mutation UpdateSessionById($session_id: uuid!, $session_name: String!, $company_id: uuid, $program_id: uuid!, $date_time: timestamptz!, $timezone: String!, $template_id: uuid, $is_multigroup: Boolean!) {
  update_session_by_pk(
    pk_columns: {id: $session_id}
    _set: {session_name: $session_name, program_id: $program_id, company_id: $company_id, date_time: $date_time, timezone: $timezone, template_id: $template_id, is_multigroup: $is_multigroup}
  ) {
    id
  }
}
    `;
export type UpdateSessionByIdMutationFn = Apollo.MutationFunction<UpdateSessionByIdMutation, UpdateSessionByIdMutationVariables>;

/**
 * __useUpdateSessionByIdMutation__
 *
 * To run a mutation, you first call `useUpdateSessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionByIdMutation, { data, loading, error }] = useUpdateSessionByIdMutation({
 *   variables: {
 *      session_id: // value for 'session_id'
 *      session_name: // value for 'session_name'
 *      company_id: // value for 'company_id'
 *      program_id: // value for 'program_id'
 *      date_time: // value for 'date_time'
 *      timezone: // value for 'timezone'
 *      template_id: // value for 'template_id'
 *      is_multigroup: // value for 'is_multigroup'
 *   },
 * });
 */
export function useUpdateSessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionByIdMutation, UpdateSessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionByIdMutation, UpdateSessionByIdMutationVariables>(UpdateSessionByIdDocument, options);
      }
export type UpdateSessionByIdMutationHookResult = ReturnType<typeof useUpdateSessionByIdMutation>;
export type UpdateSessionByIdMutationResult = Apollo.MutationResult<UpdateSessionByIdMutation>;
export type UpdateSessionByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSessionByIdMutation, UpdateSessionByIdMutationVariables>;
export const UpdateSessionMaxParticipantLimitDocument = gql`
    mutation UpdateSessionMaxParticipantLimit($session_id: uuid!, $max_participant_limit: Int!) {
  update_session_by_pk(
    pk_columns: {id: $session_id}
    _set: {max_participant_limit: $max_participant_limit}
  ) {
    id
  }
}
    `;
export type UpdateSessionMaxParticipantLimitMutationFn = Apollo.MutationFunction<UpdateSessionMaxParticipantLimitMutation, UpdateSessionMaxParticipantLimitMutationVariables>;

/**
 * __useUpdateSessionMaxParticipantLimitMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMaxParticipantLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMaxParticipantLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMaxParticipantLimitMutation, { data, loading, error }] = useUpdateSessionMaxParticipantLimitMutation({
 *   variables: {
 *      session_id: // value for 'session_id'
 *      max_participant_limit: // value for 'max_participant_limit'
 *   },
 * });
 */
export function useUpdateSessionMaxParticipantLimitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMaxParticipantLimitMutation, UpdateSessionMaxParticipantLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMaxParticipantLimitMutation, UpdateSessionMaxParticipantLimitMutationVariables>(UpdateSessionMaxParticipantLimitDocument, options);
      }
export type UpdateSessionMaxParticipantLimitMutationHookResult = ReturnType<typeof useUpdateSessionMaxParticipantLimitMutation>;
export type UpdateSessionMaxParticipantLimitMutationResult = Apollo.MutationResult<UpdateSessionMaxParticipantLimitMutation>;
export type UpdateSessionMaxParticipantLimitMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMaxParticipantLimitMutation, UpdateSessionMaxParticipantLimitMutationVariables>;
export const ObserveSessionGroupsDocument = gql`
    subscription ObserveSessionGroups($sessionId: uuid) {
  session(
    where: {base_session_id: {_eq: $sessionId}}
    order_by: {session_name: asc_nulls_last}
  ) {
    ...SessionGroup
  }
}
    ${SessionGroupFragmentDoc}`;

/**
 * __useObserveSessionGroupsSubscription__
 *
 * To run a query within a React component, call `useObserveSessionGroupsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveSessionGroupsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveSessionGroupsSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useObserveSessionGroupsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObserveSessionGroupsSubscription, ObserveSessionGroupsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveSessionGroupsSubscription, ObserveSessionGroupsSubscriptionVariables>(ObserveSessionGroupsDocument, options);
      }
export type ObserveSessionGroupsSubscriptionHookResult = ReturnType<typeof useObserveSessionGroupsSubscription>;
export type ObserveSessionGroupsSubscriptionResult = Apollo.SubscriptionResult<ObserveSessionGroupsSubscription>;
export const GetSessionsByProgramIdDocument = gql`
    query GetSessionsByProgramId($programId: uuid!, $includeMultigroup: Boolean = false) {
  session(
    where: {program_id: {_eq: $programId}, is_multigroup: {_eq: $includeMultigroup}, deleted_at: {_is_null: true}, is_template: {_eq: false}, base_session_id: {_is_null: true}}
  ) {
    ...SessionGroup
  }
}
    ${SessionGroupFragmentDoc}`;

/**
 * __useGetSessionsByProgramIdQuery__
 *
 * To run a query within a React component, call `useGetSessionsByProgramIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsByProgramIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsByProgramIdQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      includeMultigroup: // value for 'includeMultigroup'
 *   },
 * });
 */
export function useGetSessionsByProgramIdQuery(baseOptions: Apollo.QueryHookOptions<GetSessionsByProgramIdQuery, GetSessionsByProgramIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionsByProgramIdQuery, GetSessionsByProgramIdQueryVariables>(GetSessionsByProgramIdDocument, options);
      }
export function useGetSessionsByProgramIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionsByProgramIdQuery, GetSessionsByProgramIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionsByProgramIdQuery, GetSessionsByProgramIdQueryVariables>(GetSessionsByProgramIdDocument, options);
        }
export type GetSessionsByProgramIdQueryHookResult = ReturnType<typeof useGetSessionsByProgramIdQuery>;
export type GetSessionsByProgramIdLazyQueryHookResult = ReturnType<typeof useGetSessionsByProgramIdLazyQuery>;
export type GetSessionsByProgramIdQueryResult = Apollo.QueryResult<GetSessionsByProgramIdQuery, GetSessionsByProgramIdQueryVariables>;
export const UpdateBaseSessionDocument = gql`
    mutation UpdateBaseSession($session_id: uuid!, $base_session_id: uuid!) {
  update_session_by_pk(
    pk_columns: {id: $session_id}
    _set: {base_session_id: $base_session_id}
  ) {
    id
  }
}
    `;
export type UpdateBaseSessionMutationFn = Apollo.MutationFunction<UpdateBaseSessionMutation, UpdateBaseSessionMutationVariables>;

/**
 * __useUpdateBaseSessionMutation__
 *
 * To run a mutation, you first call `useUpdateBaseSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaseSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaseSessionMutation, { data, loading, error }] = useUpdateBaseSessionMutation({
 *   variables: {
 *      session_id: // value for 'session_id'
 *      base_session_id: // value for 'base_session_id'
 *   },
 * });
 */
export function useUpdateBaseSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaseSessionMutation, UpdateBaseSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaseSessionMutation, UpdateBaseSessionMutationVariables>(UpdateBaseSessionDocument, options);
      }
export type UpdateBaseSessionMutationHookResult = ReturnType<typeof useUpdateBaseSessionMutation>;
export type UpdateBaseSessionMutationResult = Apollo.MutationResult<UpdateBaseSessionMutation>;
export type UpdateBaseSessionMutationOptions = Apollo.BaseMutationOptions<UpdateBaseSessionMutation, UpdateBaseSessionMutationVariables>;
export const GetSessionTemplatesDocument = gql`
    query GetSessionTemplates {
  session(where: {is_template: {_eq: true}, deleted_at: {_is_null: true}}) {
    ...SessionTemplateSummary
  }
}
    ${SessionTemplateSummaryFragmentDoc}`;

/**
 * __useGetSessionTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSessionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionTemplatesQuery, GetSessionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionTemplatesQuery, GetSessionTemplatesQueryVariables>(GetSessionTemplatesDocument, options);
      }
export function useGetSessionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionTemplatesQuery, GetSessionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionTemplatesQuery, GetSessionTemplatesQueryVariables>(GetSessionTemplatesDocument, options);
        }
export type GetSessionTemplatesQueryHookResult = ReturnType<typeof useGetSessionTemplatesQuery>;
export type GetSessionTemplatesLazyQueryHookResult = ReturnType<typeof useGetSessionTemplatesLazyQuery>;
export type GetSessionTemplatesQueryResult = Apollo.QueryResult<GetSessionTemplatesQuery, GetSessionTemplatesQueryVariables>;
export const GetSessionTemplateByIdDocument = gql`
    query GetSessionTemplateById($id: uuid) {
  session(where: {id: {_eq: $id}, is_template: {_eq: true}}) {
    ...SessionTemplate
  }
}
    ${SessionTemplateFragmentDoc}`;

/**
 * __useGetSessionTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetSessionTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionTemplateByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionTemplateByIdQuery, GetSessionTemplateByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionTemplateByIdQuery, GetSessionTemplateByIdQueryVariables>(GetSessionTemplateByIdDocument, options);
      }
export function useGetSessionTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionTemplateByIdQuery, GetSessionTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionTemplateByIdQuery, GetSessionTemplateByIdQueryVariables>(GetSessionTemplateByIdDocument, options);
        }
export type GetSessionTemplateByIdQueryHookResult = ReturnType<typeof useGetSessionTemplateByIdQuery>;
export type GetSessionTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetSessionTemplateByIdLazyQuery>;
export type GetSessionTemplateByIdQueryResult = Apollo.QueryResult<GetSessionTemplateByIdQuery, GetSessionTemplateByIdQueryVariables>;
export const GetSpeechPhrasesDocument = gql`
    query GetSpeechPhrases($session_id: uuid = "") {
  speech_phrases(
    where: {_or: [{is_shared: {_eq: true}}, {speech_phrases_sessions: {session_id: {_eq: $session_id}}}]}
    order_by: {category: asc, priority: asc}
  ) {
    ...SpeechPhrase
  }
}
    ${SpeechPhraseFragmentDoc}`;

/**
 * __useGetSpeechPhrasesQuery__
 *
 * To run a query within a React component, call `useGetSpeechPhrasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeechPhrasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeechPhrasesQuery({
 *   variables: {
 *      session_id: // value for 'session_id'
 *   },
 * });
 */
export function useGetSpeechPhrasesQuery(baseOptions?: Apollo.QueryHookOptions<GetSpeechPhrasesQuery, GetSpeechPhrasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeechPhrasesQuery, GetSpeechPhrasesQueryVariables>(GetSpeechPhrasesDocument, options);
      }
export function useGetSpeechPhrasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeechPhrasesQuery, GetSpeechPhrasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeechPhrasesQuery, GetSpeechPhrasesQueryVariables>(GetSpeechPhrasesDocument, options);
        }
export type GetSpeechPhrasesQueryHookResult = ReturnType<typeof useGetSpeechPhrasesQuery>;
export type GetSpeechPhrasesLazyQueryHookResult = ReturnType<typeof useGetSpeechPhrasesLazyQuery>;
export type GetSpeechPhrasesQueryResult = Apollo.QueryResult<GetSpeechPhrasesQuery, GetSpeechPhrasesQueryVariables>;
export const GetSessionSpeechPhrasesDocument = gql`
    query GetSessionSpeechPhrases($session_id: uuid = "") {
  speech_phrases(
    where: {speech_phrases_sessions: {session_id: {_eq: $session_id}}}
    order_by: {category: asc, priority: asc}
  ) {
    ...SpeechPhrase
  }
}
    ${SpeechPhraseFragmentDoc}`;

/**
 * __useGetSessionSpeechPhrasesQuery__
 *
 * To run a query within a React component, call `useGetSessionSpeechPhrasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionSpeechPhrasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionSpeechPhrasesQuery({
 *   variables: {
 *      session_id: // value for 'session_id'
 *   },
 * });
 */
export function useGetSessionSpeechPhrasesQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionSpeechPhrasesQuery, GetSessionSpeechPhrasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionSpeechPhrasesQuery, GetSessionSpeechPhrasesQueryVariables>(GetSessionSpeechPhrasesDocument, options);
      }
export function useGetSessionSpeechPhrasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionSpeechPhrasesQuery, GetSessionSpeechPhrasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionSpeechPhrasesQuery, GetSessionSpeechPhrasesQueryVariables>(GetSessionSpeechPhrasesDocument, options);
        }
export type GetSessionSpeechPhrasesQueryHookResult = ReturnType<typeof useGetSessionSpeechPhrasesQuery>;
export type GetSessionSpeechPhrasesLazyQueryHookResult = ReturnType<typeof useGetSessionSpeechPhrasesLazyQuery>;
export type GetSessionSpeechPhrasesQueryResult = Apollo.QueryResult<GetSessionSpeechPhrasesQuery, GetSessionSpeechPhrasesQueryVariables>;
export const SyntethizeTextToSpeechDocument = gql`
    mutation SyntethizeTextToSpeech($sessionId: String!, $text: String!) {
  syntethizeTextToSpeech(sessionId: $sessionId, text: $text) {
    audioContent
  }
}
    `;
export type SyntethizeTextToSpeechMutationFn = Apollo.MutationFunction<SyntethizeTextToSpeechMutation, SyntethizeTextToSpeechMutationVariables>;

/**
 * __useSyntethizeTextToSpeechMutation__
 *
 * To run a mutation, you first call `useSyntethizeTextToSpeechMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyntethizeTextToSpeechMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syntethizeTextToSpeechMutation, { data, loading, error }] = useSyntethizeTextToSpeechMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSyntethizeTextToSpeechMutation(baseOptions?: Apollo.MutationHookOptions<SyntethizeTextToSpeechMutation, SyntethizeTextToSpeechMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyntethizeTextToSpeechMutation, SyntethizeTextToSpeechMutationVariables>(SyntethizeTextToSpeechDocument, options);
      }
export type SyntethizeTextToSpeechMutationHookResult = ReturnType<typeof useSyntethizeTextToSpeechMutation>;
export type SyntethizeTextToSpeechMutationResult = Apollo.MutationResult<SyntethizeTextToSpeechMutation>;
export type SyntethizeTextToSpeechMutationOptions = Apollo.BaseMutationOptions<SyntethizeTextToSpeechMutation, SyntethizeTextToSpeechMutationVariables>;
export const InsertSpeechPhrasesDocument = gql`
    mutation InsertSpeechPhrases($objects: [speech_phrases_insert_input!]!) {
  insert_speech_phrases(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type InsertSpeechPhrasesMutationFn = Apollo.MutationFunction<InsertSpeechPhrasesMutation, InsertSpeechPhrasesMutationVariables>;

/**
 * __useInsertSpeechPhrasesMutation__
 *
 * To run a mutation, you first call `useInsertSpeechPhrasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSpeechPhrasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSpeechPhrasesMutation, { data, loading, error }] = useInsertSpeechPhrasesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertSpeechPhrasesMutation(baseOptions?: Apollo.MutationHookOptions<InsertSpeechPhrasesMutation, InsertSpeechPhrasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSpeechPhrasesMutation, InsertSpeechPhrasesMutationVariables>(InsertSpeechPhrasesDocument, options);
      }
export type InsertSpeechPhrasesMutationHookResult = ReturnType<typeof useInsertSpeechPhrasesMutation>;
export type InsertSpeechPhrasesMutationResult = Apollo.MutationResult<InsertSpeechPhrasesMutation>;
export type InsertSpeechPhrasesMutationOptions = Apollo.BaseMutationOptions<InsertSpeechPhrasesMutation, InsertSpeechPhrasesMutationVariables>;
export const AddSpeechPhraseToSessionDocument = gql`
    mutation AddSpeechPhraseToSession($objects: [speech_phrases_session_insert_input!]!) {
  insert_speech_phrases_session(
    objects: $objects
    on_conflict: {constraint: speech_phrases_session_pkey, update_columns: updated_at}
  ) {
    returning {
      session_id
      speech_phrase_id
    }
  }
}
    `;
export type AddSpeechPhraseToSessionMutationFn = Apollo.MutationFunction<AddSpeechPhraseToSessionMutation, AddSpeechPhraseToSessionMutationVariables>;

/**
 * __useAddSpeechPhraseToSessionMutation__
 *
 * To run a mutation, you first call `useAddSpeechPhraseToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpeechPhraseToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpeechPhraseToSessionMutation, { data, loading, error }] = useAddSpeechPhraseToSessionMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddSpeechPhraseToSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddSpeechPhraseToSessionMutation, AddSpeechPhraseToSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpeechPhraseToSessionMutation, AddSpeechPhraseToSessionMutationVariables>(AddSpeechPhraseToSessionDocument, options);
      }
export type AddSpeechPhraseToSessionMutationHookResult = ReturnType<typeof useAddSpeechPhraseToSessionMutation>;
export type AddSpeechPhraseToSessionMutationResult = Apollo.MutationResult<AddSpeechPhraseToSessionMutation>;
export type AddSpeechPhraseToSessionMutationOptions = Apollo.BaseMutationOptions<AddSpeechPhraseToSessionMutation, AddSpeechPhraseToSessionMutationVariables>;
export const UpdateSpeechPhrasesDocument = gql`
    mutation UpdateSpeechPhrases($speechPhraseId: uuid!, $speechPhrase: speech_phrases_set_input!) {
  update_speech_phrases_by_pk(
    pk_columns: {id: $speechPhraseId}
    _set: $speechPhrase
  ) {
    id
    category
    priority
    preload
    content
    is_shared
  }
}
    `;
export type UpdateSpeechPhrasesMutationFn = Apollo.MutationFunction<UpdateSpeechPhrasesMutation, UpdateSpeechPhrasesMutationVariables>;

/**
 * __useUpdateSpeechPhrasesMutation__
 *
 * To run a mutation, you first call `useUpdateSpeechPhrasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpeechPhrasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpeechPhrasesMutation, { data, loading, error }] = useUpdateSpeechPhrasesMutation({
 *   variables: {
 *      speechPhraseId: // value for 'speechPhraseId'
 *      speechPhrase: // value for 'speechPhrase'
 *   },
 * });
 */
export function useUpdateSpeechPhrasesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpeechPhrasesMutation, UpdateSpeechPhrasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpeechPhrasesMutation, UpdateSpeechPhrasesMutationVariables>(UpdateSpeechPhrasesDocument, options);
      }
export type UpdateSpeechPhrasesMutationHookResult = ReturnType<typeof useUpdateSpeechPhrasesMutation>;
export type UpdateSpeechPhrasesMutationResult = Apollo.MutationResult<UpdateSpeechPhrasesMutation>;
export type UpdateSpeechPhrasesMutationOptions = Apollo.BaseMutationOptions<UpdateSpeechPhrasesMutation, UpdateSpeechPhrasesMutationVariables>;
export const DeleteSpeechPhrasesFromSessionDocument = gql`
    mutation DeleteSpeechPhrasesFromSession($sessionId: uuid!, $speechPhraseId: uuid!) {
  delete_speech_phrases_session(
    where: {session_id: {_eq: $sessionId}, speech_phrase_id: {_eq: $speechPhraseId}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteSpeechPhrasesFromSessionMutationFn = Apollo.MutationFunction<DeleteSpeechPhrasesFromSessionMutation, DeleteSpeechPhrasesFromSessionMutationVariables>;

/**
 * __useDeleteSpeechPhrasesFromSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSpeechPhrasesFromSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpeechPhrasesFromSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpeechPhrasesFromSessionMutation, { data, loading, error }] = useDeleteSpeechPhrasesFromSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      speechPhraseId: // value for 'speechPhraseId'
 *   },
 * });
 */
export function useDeleteSpeechPhrasesFromSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpeechPhrasesFromSessionMutation, DeleteSpeechPhrasesFromSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpeechPhrasesFromSessionMutation, DeleteSpeechPhrasesFromSessionMutationVariables>(DeleteSpeechPhrasesFromSessionDocument, options);
      }
export type DeleteSpeechPhrasesFromSessionMutationHookResult = ReturnType<typeof useDeleteSpeechPhrasesFromSessionMutation>;
export type DeleteSpeechPhrasesFromSessionMutationResult = Apollo.MutationResult<DeleteSpeechPhrasesFromSessionMutation>;
export type DeleteSpeechPhrasesFromSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSpeechPhrasesFromSessionMutation, DeleteSpeechPhrasesFromSessionMutationVariables>;
export const InsertSurveyQuestionsDocument = gql`
    mutation InsertSurveyQuestions($objects: [survey_questions_insert_input!]!) {
  insert_survey_questions(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type InsertSurveyQuestionsMutationFn = Apollo.MutationFunction<InsertSurveyQuestionsMutation, InsertSurveyQuestionsMutationVariables>;

/**
 * __useInsertSurveyQuestionsMutation__
 *
 * To run a mutation, you first call `useInsertSurveyQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSurveyQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSurveyQuestionsMutation, { data, loading, error }] = useInsertSurveyQuestionsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertSurveyQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<InsertSurveyQuestionsMutation, InsertSurveyQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSurveyQuestionsMutation, InsertSurveyQuestionsMutationVariables>(InsertSurveyQuestionsDocument, options);
      }
export type InsertSurveyQuestionsMutationHookResult = ReturnType<typeof useInsertSurveyQuestionsMutation>;
export type InsertSurveyQuestionsMutationResult = Apollo.MutationResult<InsertSurveyQuestionsMutation>;
export type InsertSurveyQuestionsMutationOptions = Apollo.BaseMutationOptions<InsertSurveyQuestionsMutation, InsertSurveyQuestionsMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($questionId: uuid!, $questionDescription: String!, $surveyId: uuid!, $batch: Int!) {
  update_survey_questions_by_pk(
    _set: {question: $questionDescription}
    pk_columns: {id: $questionId}
  ) {
    id
    question
  }
  update_surveys_by_pk(_set: {batch: $batch}, pk_columns: {id: $surveyId}) {
    id
    batch
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      questionDescription: // value for 'questionDescription'
 *      surveyId: // value for 'surveyId'
 *      batch: // value for 'batch'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const DeleteQuestionsDocument = gql`
    mutation DeleteQuestions($questionIds: [uuid!]!) {
  delete_survey_questions(where: {id: {_in: $questionIds}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteQuestionsMutationFn = Apollo.MutationFunction<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>;

/**
 * __useDeleteQuestionsMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionsMutation, { data, loading, error }] = useDeleteQuestionsMutation({
 *   variables: {
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useDeleteQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>(DeleteQuestionsDocument, options);
      }
export type DeleteQuestionsMutationHookResult = ReturnType<typeof useDeleteQuestionsMutation>;
export type DeleteQuestionsMutationResult = Apollo.MutationResult<DeleteQuestionsMutation>;
export type DeleteQuestionsMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>;
export const GetSessionSurveysDocument = gql`
    query GetSessionSurveys($sessionId: uuid) {
  survey_questions(
    where: {survey: {session_id: {_eq: $sessionId}}}
    order_by: {survey: {batch: asc}}
  ) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useGetSessionSurveysQuery__
 *
 * To run a query within a React component, call `useGetSessionSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionSurveysQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionSurveysQuery, GetSessionSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionSurveysQuery, GetSessionSurveysQueryVariables>(GetSessionSurveysDocument, options);
      }
export function useGetSessionSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionSurveysQuery, GetSessionSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionSurveysQuery, GetSessionSurveysQueryVariables>(GetSessionSurveysDocument, options);
        }
export type GetSessionSurveysQueryHookResult = ReturnType<typeof useGetSessionSurveysQuery>;
export type GetSessionSurveysLazyQueryHookResult = ReturnType<typeof useGetSessionSurveysLazyQuery>;
export type GetSessionSurveysQueryResult = Apollo.QueryResult<GetSessionSurveysQuery, GetSessionSurveysQueryVariables>;